// This file is generated automatically by scripts/generate-models-ts.js
// Do not edit this file manually.

export const SHERPA_MODELS_CONFIG = {
  "kokoro-en-en-19": {
    "id": "kokoro-en-en-19",
    "model_type": "kokoro",
    "developer": "kokoro",
    "name": "en",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "19",
    "sample_rate": 24000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/kokoro-en-v0_19.tar.bz2",
    "compression": true,
    "filesize_mb": 304.84
  },
  "kokoro-zh_en-int8-multi": {
    "id": "kokoro-zh_en-int8-multi",
    "model_type": "kokoro",
    "developer": "kokoro",
    "name": "int8",
    "language": [
      {
        "lang_code": "zh",
        "language_name": "Chinese",
        "country": "CN"
      },
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "multi",
    "sample_rate": 24000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/kokoro-int8-multi-lang-v1_1.tar.bz2",
    "compression": true,
    "filesize_mb": 140.19
  },
  "kokoro-zh_en-multi-lang": {
    "id": "kokoro-zh_en-multi-lang",
    "model_type": "kokoro",
    "developer": "kokoro",
    "name": "multi",
    "language": [
      {
        "lang_code": "zh",
        "language_name": "Chinese",
        "country": "CN"
      },
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "lang",
    "sample_rate": 24000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/kokoro-multi-lang-v1_1.tar.bz2",
    "compression": true,
    "filesize_mb": 347.93
  },
  "icefall-fs-ljspeech": {
    "id": "icefall-fs-ljspeech",
    "model_type": "matcha",
    "developer": "icefall",
    "name": "ljspeech",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/matcha-icefall-en_US-ljspeech.tar.bz2",
    "compression": true,
    "filesize_mb": 73.2
  },
  "icefall-fs-baker": {
    "id": "icefall-fs-baker",
    "model_type": "matcha",
    "developer": "icefall",
    "name": "baker",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/matcha-icefall-zh-baker.tar.bz2",
    "compression": true,
    "filesize_mb": 71.76
  },
  "tts-fs-khadijah": {
    "id": "tts-fs-khadijah",
    "model_type": "matcha",
    "developer": "tts",
    "name": "khadijah",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/matcha-tts-fa_en-khadijah.tar.bz2",
    "compression": true,
    "filesize_mb": 72.97
  },
  "tts-fs-musa": {
    "id": "tts-fs-musa",
    "model_type": "matcha",
    "developer": "tts",
    "name": "musa",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/matcha-tts-fa_en-musa.tar.bz2",
    "compression": true,
    "filesize_mb": 72.96
  },
  "cantonese-fs-xiaomaiiwn": {
    "id": "cantonese-fs-xiaomaiiwn",
    "model_type": "vits",
    "developer": "cantonese",
    "name": "xiaomaiiwn",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-cantonese-hf-xiaomaiiwn.tar.bz2",
    "compression": true,
    "filesize_mb": 102.99
  },
  "coqui-bg-cv": {
    "id": "coqui-bg-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "bg",
        "language_name": "Bulgarian",
        "country": "BG"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-bg-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.94
  },
  "coqui-bn-custom_female": {
    "id": "coqui-bn-custom_female",
    "model_type": "vits",
    "developer": "coqui",
    "name": "custom_female",
    "language": [
      {
        "lang_code": "bn",
        "language_name": "Bangla",
        "country": "BD"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-bn-custom_female.tar.bz2",
    "compression": true,
    "filesize_mb": 103.05
  },
  "coqui-cs-cv": {
    "id": "coqui-cs-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "cs",
        "language_name": "Czech",
        "country": "CZ"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-cs-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.96
  },
  "coqui-da-cv": {
    "id": "coqui-da-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "da",
        "language_name": "Danish",
        "country": "DK"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-da-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.96
  },
  "coqui-de-css10": {
    "id": "coqui-de-css10",
    "model_type": "vits",
    "developer": "coqui",
    "name": "css10",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-de-css10.tar.bz2",
    "compression": true,
    "filesize_mb": 64
  },
  "coqui-en-ljspeech-neon": {
    "id": "coqui-en-ljspeech-neon",
    "model_type": "vits",
    "developer": "coqui",
    "name": "ljspeech",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "neon",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-en-ljspeech-neon.tar.bz2",
    "compression": true,
    "filesize_mb": 110.07
  },
  "coqui-en-ljspeech": {
    "id": "coqui-en-ljspeech",
    "model_type": "vits",
    "developer": "coqui",
    "name": "ljspeech",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-en-ljspeech.tar.bz2",
    "compression": true,
    "filesize_mb": 110.07
  },
  "coqui-en-vctk": {
    "id": "coqui-en-vctk",
    "model_type": "vits",
    "developer": "coqui",
    "name": "vctk",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-en-vctk.tar.bz2",
    "compression": true,
    "filesize_mb": 116.74
  },
  "coqui-es-css10": {
    "id": "coqui-es-css10",
    "model_type": "vits",
    "developer": "coqui",
    "name": "css10",
    "language": [
      {
        "lang_code": "es",
        "language_name": "Spanish",
        "country": "ES"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-es-css10.tar.bz2",
    "compression": true,
    "filesize_mb": 63.98
  },
  "coqui-et-cv": {
    "id": "coqui-et-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "et",
        "language_name": "Estonian",
        "country": "EE"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-et-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.96
  },
  "coqui-fi-css10": {
    "id": "coqui-fi-css10",
    "model_type": "vits",
    "developer": "coqui",
    "name": "css10",
    "language": [
      {
        "lang_code": "fi",
        "language_name": "Finnish",
        "country": "FI"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-fi-css10.tar.bz2",
    "compression": true,
    "filesize_mb": 63.99
  },
  "coqui-fr-css10": {
    "id": "coqui-fr-css10",
    "model_type": "vits",
    "developer": "coqui",
    "name": "css10",
    "language": [
      {
        "lang_code": "fr",
        "language_name": "French",
        "country": "FR"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-fr-css10.tar.bz2",
    "compression": true,
    "filesize_mb": 63.94
  },
  "coqui-ga-cv": {
    "id": "coqui-ga-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "ga",
        "language_name": "Irish",
        "country": "IE"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-ga-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.94
  },
  "coqui-hr-cv": {
    "id": "coqui-hr-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "hr",
        "language_name": "Croatian",
        "country": "HR"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-hr-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.96
  },
  "coqui-lt-cv": {
    "id": "coqui-lt-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "lt",
        "language_name": "Lithuanian",
        "country": "LT"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-lt-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.95
  },
  "coqui-lv-cv": {
    "id": "coqui-lv-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "lv",
        "language_name": "Latvian",
        "country": "LV"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-lv-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.95
  },
  "coqui-mt-cv": {
    "id": "coqui-mt-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "mt",
        "language_name": "Maltese",
        "country": "MT"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-mt-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.96
  },
  "coqui-nl-css10": {
    "id": "coqui-nl-css10",
    "model_type": "vits",
    "developer": "coqui",
    "name": "css10",
    "language": [
      {
        "lang_code": "nl",
        "language_name": "Dutch",
        "country": "NL"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-nl-css10.tar.bz2",
    "compression": true,
    "filesize_mb": 64.01
  },
  "coqui-pl-mai_female": {
    "id": "coqui-pl-mai_female",
    "model_type": "vits",
    "developer": "coqui",
    "name": "mai_female",
    "language": [
      {
        "lang_code": "pl",
        "language_name": "Polish",
        "country": "PL"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-pl-mai_female.tar.bz2",
    "compression": true,
    "filesize_mb": 63.96
  },
  "coqui-pt-cv": {
    "id": "coqui-pt-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "pt",
        "language_name": "Portuguese",
        "country": "BR"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-pt-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.94
  },
  "coqui-ro-cv": {
    "id": "coqui-ro-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "ro",
        "language_name": "Romanian",
        "country": "RO"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-ro-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.96
  },
  "coqui-sk-cv": {
    "id": "coqui-sk-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "sk",
        "language_name": "Slovak",
        "country": "SK"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-sk-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.96
  },
  "coqui-sl-cv": {
    "id": "coqui-sl-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "sl",
        "language_name": "Slovenian",
        "country": "SI"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-sl-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.94
  },
  "coqui-sv-cv": {
    "id": "coqui-sv-cv",
    "model_type": "vits",
    "developer": "coqui",
    "name": "cv",
    "language": [
      {
        "lang_code": "sv",
        "language_name": "Swedish",
        "country": "SE"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-sv-cv.tar.bz2",
    "compression": true,
    "filesize_mb": 63.96
  },
  "coqui-uk-mai": {
    "id": "coqui-uk-mai",
    "model_type": "vits",
    "developer": "coqui",
    "name": "mai",
    "language": [
      {
        "lang_code": "uk",
        "language_name": "Ukrainian",
        "country": "UA"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-coqui-uk-mai.tar.bz2",
    "compression": true,
    "filesize_mb": 63.91
  },
  "icefall-fs-ljspeech-low": {
    "id": "icefall-fs-ljspeech-low",
    "model_type": "vits",
    "developer": "icefall",
    "name": "ljspeech",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "low",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-icefall-en_US-ljspeech-low.tar.bz2",
    "compression": true,
    "filesize_mb": 30.27
  },
  "icefall-fs-ljspeech-medium": {
    "id": "icefall-fs-ljspeech-medium",
    "model_type": "vits",
    "developer": "icefall",
    "name": "ljspeech",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-icefall-en_US-ljspeech-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 70.13
  },
  "icefall-fs-aishell3": {
    "id": "icefall-fs-aishell3",
    "model_type": "vits",
    "developer": "icefall",
    "name": "aishell3",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-icefall-zh-aishell3.tar.bz2",
    "compression": true,
    "filesize_mb": 30.1
  },
  "ljs-fs-unknown": {
    "id": "ljs-fs-unknown",
    "model_type": "vits",
    "developer": "ljs",
    "name": "unknown",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-ljs.tar.bz2",
    "compression": true,
    "filesize_mb": 103.99
  },
  "melo-fs-en": {
    "id": "melo-fs-en",
    "model_type": "vits",
    "developer": "melo",
    "name": "en",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-melo-tts-en.tar.bz2",
    "compression": true,
    "filesize_mb": 155.22
  },
  "melo-fs-zh_en": {
    "id": "melo-fs-zh_en",
    "model_type": "vits",
    "developer": "melo",
    "name": "zh_en",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-melo-tts-zh_en.tar.bz2",
    "compression": true,
    "filesize_mb": 159.27
  },
  "mimic3-af-google-nwu_low": {
    "id": "mimic3-af-google-nwu_low",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "google",
    "language": [
      {
        "lang_code": "af",
        "language_name": "Afrikaans",
        "country": "ZA"
      }
    ],
    "quality": "nwu_low",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-af_ZA-google-nwu_low.tar.bz2",
    "compression": true,
    "filesize_mb": 76.26
  },
  "mimic3-fs-multi": {
    "id": "mimic3-fs-multi",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "multi",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-bn-multi_low.tar.bz2",
    "compression": true,
    "filesize_mb": 76.19
  },
  "mimic3-el-rapunzelina": {
    "id": "mimic3-el-rapunzelina",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "rapunzelina",
    "language": [
      {
        "lang_code": "el",
        "language_name": "Greek",
        "country": "GR"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-el_GR-rapunzelina_low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.79
  },
  "mimic3-es-m-ailabs_low": {
    "id": "mimic3-es-m-ailabs_low",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "m",
    "language": [
      {
        "lang_code": "es",
        "language_name": "Spanish",
        "country": "ES"
      }
    ],
    "quality": "ailabs_low",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-es_ES-m-ailabs_low.tar.bz2",
    "compression": true,
    "filesize_mb": 76.31
  },
  "mimic3-fs-haaniye": {
    "id": "mimic3-fs-haaniye",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "haaniye",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-fa-haaniye_low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.99
  },
  "mimic3-fi-harri-tapani": {
    "id": "mimic3-fi-harri-tapani",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "harri",
    "language": [
      {
        "lang_code": "fi",
        "language_name": "Finnish",
        "country": "FI"
      }
    ],
    "quality": "tapani",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-fi_FI-harri-tapani-ylilammi_low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.79
  },
  "mimic3-gu-cmu-low": {
    "id": "mimic3-gu-cmu-low",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "cmu",
    "language": [
      {
        "lang_code": "gu",
        "language_name": "Gujarati",
        "country": "IN"
      }
    ],
    "quality": "low",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-gu_IN-cmu-indic_low.tar.bz2",
    "compression": true,
    "filesize_mb": 76.29
  },
  "mimic3-hu-diana-low": {
    "id": "mimic3-hu-diana-low",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "diana",
    "language": [
      {
        "lang_code": "hu",
        "language_name": "Hungarian",
        "country": "HU"
      }
    ],
    "quality": "low",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-hu_HU-diana-majlinger_low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.79
  },
  "mimic3-ko-kss": {
    "id": "mimic3-ko-kss",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "kss",
    "language": [
      {
        "lang_code": "ko",
        "language_name": "Korean",
        "country": "KO"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-ko_KO-kss_low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.74
  },
  "mimic3-ne-ne-low": {
    "id": "mimic3-ne-ne-low",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "ne",
    "language": [
      {
        "lang_code": "ne",
        "language_name": "Nepali",
        "country": "NP"
      }
    ],
    "quality": "low",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-ne_NP-ne-google_low.tar.bz2",
    "compression": true,
    "filesize_mb": 76.17
  },
  "mimic3-pl-m-ailabs_low": {
    "id": "mimic3-pl-m-ailabs_low",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "m",
    "language": [
      {
        "lang_code": "pl",
        "language_name": "Polish",
        "country": "PL"
      }
    ],
    "quality": "ailabs_low",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-pl_PL-m-ailabs_low.tar.bz2",
    "compression": true,
    "filesize_mb": 76.3
  },
  "mimic3-tn-google-nwu_low": {
    "id": "mimic3-tn-google-nwu_low",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "google",
    "language": [
      {
        "lang_code": "tn",
        "language_name": "Tswana",
        "country": "ZA"
      }
    ],
    "quality": "nwu_low",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-tn_ZA-google-nwu_low.tar.bz2",
    "compression": true,
    "filesize_mb": 76.22
  },
  "mimic3-vi-vais1000": {
    "id": "mimic3-vi-vais1000",
    "model_type": "vits",
    "developer": "mimic3",
    "name": "vais1000",
    "language": [
      {
        "lang_code": "vi",
        "language_name": "Vietnamese",
        "country": "VN"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-mimic3-vi_VN-vais1000_low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.73
  },
  "piper-ar-kareem-low": {
    "id": "piper-ar-kareem-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "kareem",
    "language": [
      {
        "lang_code": "ar",
        "language_name": "Arabic",
        "country": "JO"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ar_JO-kareem-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64.03
  },
  "piper-ar-kareem-medium": {
    "id": "piper-ar-kareem-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "kareem",
    "language": [
      {
        "lang_code": "ar",
        "language_name": "Arabic",
        "country": "JO"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ar_JO-kareem-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.08
  },
  "piper-ca-upc_ona-medium": {
    "id": "piper-ca-upc_ona-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "upc_ona",
    "language": [
      {
        "lang_code": "ca",
        "language_name": "Catalan",
        "country": "ES"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ca_ES-upc_ona-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.09
  },
  "piper-ca-upc_ona-low": {
    "id": "piper-ca-upc_ona-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "upc_ona",
    "language": [
      {
        "lang_code": "ca",
        "language_name": "Catalan",
        "country": "ES"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ca_ES-upc_ona-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.27
  },
  "piper-ca-upc_pau-low": {
    "id": "piper-ca-upc_pau-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "upc_pau",
    "language": [
      {
        "lang_code": "ca",
        "language_name": "Catalan",
        "country": "ES"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ca_ES-upc_pau-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.28
  },
  "piper-cs-jirka-low": {
    "id": "piper-cs-jirka-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "jirka",
    "language": [
      {
        "lang_code": "cs",
        "language_name": "Czech",
        "country": "CZ"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-cs_CZ-jirka-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64.06
  },
  "piper-cs-jirka-medium": {
    "id": "piper-cs-jirka-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "jirka",
    "language": [
      {
        "lang_code": "cs",
        "language_name": "Czech",
        "country": "CZ"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-cs_CZ-jirka-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.08
  },
  "piper-cy-gwryw_gogleddol-medium": {
    "id": "piper-cy-gwryw_gogleddol-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "gwryw_gogleddol",
    "language": [
      {
        "lang_code": "cy",
        "language_name": "Welsh",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-cy_GB-gwryw_gogleddol-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.08
  },
  "piper-da-talesyntese-medium": {
    "id": "piper-da-talesyntese-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "talesyntese",
    "language": [
      {
        "lang_code": "da",
        "language_name": "Danish",
        "country": "DK"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-da_DK-talesyntese-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-de-eva_k-low": {
    "id": "piper-de-eva_k-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "eva_k",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-de_DE-eva_k-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.26
  },
  "piper-de-karlsson-low": {
    "id": "piper-de-karlsson-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "karlsson",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-de_DE-karlsson-low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.99
  },
  "piper-de-kerstin-low": {
    "id": "piper-de-kerstin-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "kerstin",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-de_DE-kerstin-low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.99
  },
  "piper-de-pavoque-low": {
    "id": "piper-de-pavoque-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "pavoque",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-de_DE-pavoque-low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.98
  },
  "piper-de-ramona-low": {
    "id": "piper-de-ramona-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "ramona",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-de_DE-ramona-low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.97
  },
  "piper-de-thorsten-high": {
    "id": "piper-de-thorsten-high",
    "model_type": "vits",
    "developer": "piper",
    "name": "thorsten",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "high",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-de_DE-thorsten-high.tar.bz2",
    "compression": true,
    "filesize_mb": 110.22
  },
  "piper-de-thorsten-low": {
    "id": "piper-de-thorsten-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "thorsten",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-de_DE-thorsten-low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.99
  },
  "piper-de-thorsten-medium": {
    "id": "piper-de-thorsten-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "thorsten",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-de_DE-thorsten-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-de-thorsten_emotional-medium": {
    "id": "piper-de-thorsten_emotional-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "thorsten_emotional",
    "language": [
      {
        "lang_code": "de",
        "language_name": "German",
        "country": "DE"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-de_DE-thorsten_emotional-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.47
  },
  "piper-el-rapunzelina-low": {
    "id": "piper-el-rapunzelina-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "rapunzelina",
    "language": [
      {
        "lang_code": "el",
        "language_name": "Greek",
        "country": "GR"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-el_GR-rapunzelina-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64.01
  },
  "piper-en-alan-low": {
    "id": "piper-en-alan-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "alan",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-alan-low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.98
  },
  "piper-en-alan-medium": {
    "id": "piper-en-alan-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "alan",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-alan-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.1
  },
  "piper-en-alba-medium": {
    "id": "piper-en-alba-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "alba",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-alba-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-en-aru-medium": {
    "id": "piper-en-aru-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "aru",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-aru-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.56
  },
  "piper-en-cori-high": {
    "id": "piper-en-cori-high",
    "model_type": "vits",
    "developer": "piper",
    "name": "cori",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "high",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-cori-high.tar.bz2",
    "compression": true,
    "filesize_mb": 110.25
  },
  "piper-en-cori-medium": {
    "id": "piper-en-cori-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "cori",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-cori-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-en-jenny_dioco-medium": {
    "id": "piper-en-jenny_dioco-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "jenny_dioco",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-jenny_dioco-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.1
  },
  "piper-en-northern_english_male-medium": {
    "id": "piper-en-northern_english_male-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "northern_english_male",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-northern_english_male-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.08
  },
  "piper-en-semaine-medium": {
    "id": "piper-en-semaine-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "semaine",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-semaine-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.52
  },
  "piper-en-southern_english_female-low": {
    "id": "piper-en-southern_english_female-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "southern_english_female",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-southern_english_female-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64
  },
  "piper-en-southern_english_female-medium": {
    "id": "piper-en-southern_english_female-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "southern_english_female",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-southern_english_female-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.54
  },
  "piper-en-southern_english_female_medium": {
    "id": "piper-en-southern_english_female_medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "southern_english_female_medium",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "unknown",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-southern_english_female_medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.54
  },
  "piper-en-southern_english_male-medium": {
    "id": "piper-en-southern_english_male-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "southern_english_male",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-southern_english_male-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.6
  },
  "piper-en-sweetbbak-amy": {
    "id": "piper-en-sweetbbak-amy",
    "model_type": "vits",
    "developer": "piper",
    "name": "sweetbbak",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "amy",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-sweetbbak-amy.tar.bz2",
    "compression": true,
    "filesize_mb": 110.24
  },
  "piper-en-vctk-medium": {
    "id": "piper-en-vctk-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "vctk",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "GB"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_GB-vctk-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.75
  },
  "piper-en-amy-low": {
    "id": "piper-en-amy-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "amy",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-amy-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64
  },
  "piper-en-amy-medium": {
    "id": "piper-en-amy-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "amy",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-amy-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.1
  },
  "piper-en-arctic-medium": {
    "id": "piper-en-arctic-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "arctic",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-arctic-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.56
  },
  "piper-en-bryce-medium": {
    "id": "piper-en-bryce-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "bryce",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-bryce-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.13
  },
  "piper-en-danny-low": {
    "id": "piper-en-danny-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "danny",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-danny-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64
  },
  "piper-en-glados": {
    "id": "piper-en-glados",
    "model_type": "vits",
    "developer": "piper",
    "name": "glados",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-glados.tar.bz2",
    "compression": true,
    "filesize_mb": 64.09
  },
  "piper-en-hfc_female-medium": {
    "id": "piper-en-hfc_female-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "hfc_female",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-hfc_female-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.13
  },
  "piper-en-hfc_male-medium": {
    "id": "piper-en-hfc_male-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "hfc_male",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-hfc_male-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-en-joe-medium": {
    "id": "piper-en-joe-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "joe",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-joe-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.07
  },
  "piper-en-john-medium": {
    "id": "piper-en-john-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "john",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-john-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.13
  },
  "piper-en-kathleen-low": {
    "id": "piper-en-kathleen-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "kathleen",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-kathleen-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64
  },
  "piper-en-kristin-medium": {
    "id": "piper-en-kristin-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "kristin",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-kristin-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-en-kusal-medium": {
    "id": "piper-en-kusal-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "kusal",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-kusal-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.1
  },
  "piper-en-l2arctic-medium": {
    "id": "piper-en-l2arctic-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "l2arctic",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-l2arctic-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.56
  },
  "piper-en-lessac-high": {
    "id": "piper-en-lessac-high",
    "model_type": "vits",
    "developer": "piper",
    "name": "lessac",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "high",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-lessac-high.tar.bz2",
    "compression": true,
    "filesize_mb": 110.2
  },
  "piper-en-lessac-low": {
    "id": "piper-en-lessac-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "lessac",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-lessac-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64.01
  },
  "piper-en-lessac-medium": {
    "id": "piper-en-lessac-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "lessac",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-lessac-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.1
  },
  "piper-en-libritts-high": {
    "id": "piper-en-libritts-high",
    "model_type": "vits",
    "developer": "piper",
    "name": "libritts",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "high",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-libritts-high.tar.bz2",
    "compression": true,
    "filesize_mb": 124.94
  },
  "piper-en-libritts_r-medium": {
    "id": "piper-en-libritts_r-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "libritts_r",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-libritts_r-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 78.19
  },
  "piper-en-ljspeech-high": {
    "id": "piper-en-ljspeech-high",
    "model_type": "vits",
    "developer": "piper",
    "name": "ljspeech",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "high",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-ljspeech-high.tar.bz2",
    "compression": true,
    "filesize_mb": 110.45
  },
  "piper-en-ljspeech-medium": {
    "id": "piper-en-ljspeech-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "ljspeech",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-ljspeech-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.06
  },
  "piper-en-norman-medium": {
    "id": "piper-en-norman-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "norman",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-norman-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.07
  },
  "piper-en-ryan-high": {
    "id": "piper-en-ryan-high",
    "model_type": "vits",
    "developer": "piper",
    "name": "ryan",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "high",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-ryan-high.tar.bz2",
    "compression": true,
    "filesize_mb": 110.27
  },
  "piper-en-ryan-low": {
    "id": "piper-en-ryan-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "ryan",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-ryan-low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.99
  },
  "piper-en-ryan-medium": {
    "id": "piper-en-ryan-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "ryan",
    "language": [
      {
        "lang_code": "en",
        "language_name": "English",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-en_US-ryan-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-fs-glados-medium": {
    "id": "piper-fs-glados-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "glados",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-es-glados-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.09
  },
  "piper-es-carlfm-low": {
    "id": "piper-es-carlfm-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "carlfm",
    "language": [
      {
        "lang_code": "es",
        "language_name": "Spanish",
        "country": "ES"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-es_ES-carlfm-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.28
  },
  "piper-es-davefx-medium": {
    "id": "piper-es-davefx-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "davefx",
    "language": [
      {
        "lang_code": "es",
        "language_name": "Spanish",
        "country": "ES"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-es_ES-davefx-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.09
  },
  "piper-es-sharvard-medium": {
    "id": "piper-es-sharvard-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "sharvard",
    "language": [
      {
        "lang_code": "es",
        "language_name": "Spanish",
        "country": "ES"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-es_ES-sharvard-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.57
  },
  "piper-es-ald-medium": {
    "id": "piper-es-ald-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "ald",
    "language": [
      {
        "lang_code": "es",
        "language_name": "Spanish",
        "country": "MX"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-es_MX-ald-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.07
  },
  "piper-es-claude-high": {
    "id": "piper-es-claude-high",
    "model_type": "vits",
    "developer": "piper",
    "name": "claude",
    "language": [
      {
        "lang_code": "es",
        "language_name": "Spanish",
        "country": "MX"
      }
    ],
    "quality": "high",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-es_MX-claude-high.tar.bz2",
    "compression": true,
    "filesize_mb": 64.13
  },
  "piper-fs-haaniye_low": {
    "id": "piper-fs-haaniye_low",
    "model_type": "vits",
    "developer": "piper",
    "name": "haaniye_low",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fa-haaniye_low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.98
  },
  "piper-fa-amir-medium": {
    "id": "piper-fa-amir-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "amir",
    "language": [
      {
        "lang_code": "fa",
        "language_name": "Persian",
        "country": "IR"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fa_IR-amir-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.07
  },
  "piper-fa-gyro-medium": {
    "id": "piper-fa-gyro-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "gyro",
    "language": [
      {
        "lang_code": "fa",
        "language_name": "Persian",
        "country": "IR"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fa_IR-gyro-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.14
  },
  "piper-fi-harri-low": {
    "id": "piper-fi-harri-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "harri",
    "language": [
      {
        "lang_code": "fi",
        "language_name": "Finnish",
        "country": "FI"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fi_FI-harri-low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.98
  },
  "piper-fi-harri-medium": {
    "id": "piper-fi-harri-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "harri",
    "language": [
      {
        "lang_code": "fi",
        "language_name": "Finnish",
        "country": "FI"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fi_FI-harri-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.1
  },
  "piper-fr-gilles-low": {
    "id": "piper-fr-gilles-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "gilles",
    "language": [
      {
        "lang_code": "fr",
        "language_name": "French",
        "country": "FR"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fr_FR-gilles-low.tar.bz2",
    "compression": true,
    "filesize_mb": 63.98
  },
  "piper-fr-siwis-low": {
    "id": "piper-fr-siwis-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "siwis",
    "language": [
      {
        "lang_code": "fr",
        "language_name": "French",
        "country": "FR"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fr_FR-siwis-low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.28
  },
  "piper-fr-siwis-medium": {
    "id": "piper-fr-siwis-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "siwis",
    "language": [
      {
        "lang_code": "fr",
        "language_name": "French",
        "country": "FR"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fr_FR-siwis-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-fr-tjiho-model1": {
    "id": "piper-fr-tjiho-model1",
    "model_type": "vits",
    "developer": "piper",
    "name": "tjiho",
    "language": [
      {
        "lang_code": "fr",
        "language_name": "French",
        "country": "FR"
      }
    ],
    "quality": "model1",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fr_FR-tjiho-model1.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-fr-tjiho-model2": {
    "id": "piper-fr-tjiho-model2",
    "model_type": "vits",
    "developer": "piper",
    "name": "tjiho",
    "language": [
      {
        "lang_code": "fr",
        "language_name": "French",
        "country": "FR"
      }
    ],
    "quality": "model2",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fr_FR-tjiho-model2.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-fr-tjiho-model3": {
    "id": "piper-fr-tjiho-model3",
    "model_type": "vits",
    "developer": "piper",
    "name": "tjiho",
    "language": [
      {
        "lang_code": "fr",
        "language_name": "French",
        "country": "FR"
      }
    ],
    "quality": "model3",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fr_FR-tjiho-model3.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-fr-tom-medium": {
    "id": "piper-fr-tom-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "tom",
    "language": [
      {
        "lang_code": "fr",
        "language_name": "French",
        "country": "FR"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fr_FR-tom-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.09
  },
  "piper-fr-upmc-medium": {
    "id": "piper-fr-upmc-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "upmc",
    "language": [
      {
        "lang_code": "fr",
        "language_name": "French",
        "country": "FR"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-fr_FR-upmc-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.67
  },
  "piper-hu-anna-medium": {
    "id": "piper-hu-anna-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "anna",
    "language": [
      {
        "lang_code": "hu",
        "language_name": "Hungarian",
        "country": "HU"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-hu_HU-anna-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.07
  },
  "piper-hu-berta-medium": {
    "id": "piper-hu-berta-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "berta",
    "language": [
      {
        "lang_code": "hu",
        "language_name": "Hungarian",
        "country": "HU"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-hu_HU-berta-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-hu-imre-medium": {
    "id": "piper-hu-imre-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "imre",
    "language": [
      {
        "lang_code": "hu",
        "language_name": "Hungarian",
        "country": "HU"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-hu_HU-imre-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-is-bui-medium": {
    "id": "piper-is-bui-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "bui",
    "language": [
      {
        "lang_code": "is",
        "language_name": "Icelandic",
        "country": "IS"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-is_IS-bui-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.19
  },
  "piper-is-salka-medium": {
    "id": "piper-is-salka-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "salka",
    "language": [
      {
        "lang_code": "is",
        "language_name": "Icelandic",
        "country": "IS"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-is_IS-salka-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.26
  },
  "piper-is-steinn-medium": {
    "id": "piper-is-steinn-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "steinn",
    "language": [
      {
        "lang_code": "is",
        "language_name": "Icelandic",
        "country": "IS"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-is_IS-steinn-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.27
  },
  "piper-is-ugla-medium": {
    "id": "piper-is-ugla-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "ugla",
    "language": [
      {
        "lang_code": "is",
        "language_name": "Icelandic",
        "country": "IS"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-is_IS-ugla-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.27
  },
  "piper-it-paola-medium": {
    "id": "piper-it-paola-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "paola",
    "language": [
      {
        "lang_code": "it",
        "language_name": "Italian",
        "country": "IT"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-it_IT-paola-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.08
  },
  "piper-it-riccardo-low": {
    "id": "piper-it-riccardo-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "riccardo",
    "language": [
      {
        "lang_code": "it",
        "language_name": "Italian",
        "country": "IT"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-it_IT-riccardo-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.31
  },
  "piper-ka-natia-medium": {
    "id": "piper-ka-natia-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "natia",
    "language": [
      {
        "lang_code": "ka",
        "language_name": "Georgian",
        "country": "GE"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ka_GE-natia-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.13
  },
  "piper-kk-iseke-low": {
    "id": "piper-kk-iseke-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "iseke",
    "language": [
      {
        "lang_code": "kk",
        "language_name": "Kazakh",
        "country": "KZ"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-kk_KZ-iseke-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.31
  },
  "piper-kk-issai-high": {
    "id": "piper-kk-issai-high",
    "model_type": "vits",
    "developer": "piper",
    "name": "issai",
    "language": [
      {
        "lang_code": "kk",
        "language_name": "Kazakh",
        "country": "KZ"
      }
    ],
    "quality": "high",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-kk_KZ-issai-high.tar.bz2",
    "compression": true,
    "filesize_mb": 123.31
  },
  "piper-kk-raya-low": {
    "id": "piper-kk-raya-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "raya",
    "language": [
      {
        "lang_code": "kk",
        "language_name": "Kazakh",
        "country": "KZ"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-kk_KZ-raya-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.29
  },
  "piper-lb-marylux-medium": {
    "id": "piper-lb-marylux-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "marylux",
    "language": [
      {
        "lang_code": "lb",
        "language_name": "Luxembourgish",
        "country": "LU"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-lb_LU-marylux-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-ne-google-medium": {
    "id": "piper-ne-google-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "google",
    "language": [
      {
        "lang_code": "ne",
        "language_name": "Nepali",
        "country": "NP"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ne_NP-google-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.52
  },
  "piper-ne-google-low": {
    "id": "piper-ne-google-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "google",
    "language": [
      {
        "lang_code": "ne",
        "language_name": "Nepali",
        "country": "NP"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ne_NP-google-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 31.68
  },
  "piper-nl-nathalie-medium": {
    "id": "piper-nl-nathalie-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "nathalie",
    "language": [
      {
        "lang_code": "nl",
        "language_name": "Dutch",
        "country": "BE"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-nl_BE-nathalie-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-nl-nathalie-low": {
    "id": "piper-nl-nathalie-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "nathalie",
    "language": [
      {
        "lang_code": "nl",
        "language_name": "Dutch",
        "country": "BE"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-nl_BE-nathalie-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.27
  },
  "piper-nl-rdh-medium": {
    "id": "piper-nl-rdh-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "rdh",
    "language": [
      {
        "lang_code": "nl",
        "language_name": "Dutch",
        "country": "BE"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-nl_BE-rdh-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.01
  },
  "piper-nl-rdh-low": {
    "id": "piper-nl-rdh-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "rdh",
    "language": [
      {
        "lang_code": "nl",
        "language_name": "Dutch",
        "country": "BE"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-nl_BE-rdh-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.27
  },
  "piper-no-talesyntese-medium": {
    "id": "piper-no-talesyntese-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "talesyntese",
    "language": [
      {
        "lang_code": "no",
        "language_name": "Norwegian",
        "country": "NO"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-no_NO-talesyntese-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.13
  },
  "piper-pl-darkman-medium": {
    "id": "piper-pl-darkman-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "darkman",
    "language": [
      {
        "lang_code": "pl",
        "language_name": "Polish",
        "country": "PL"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-pl_PL-darkman-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.08
  },
  "piper-pl-gosia-medium": {
    "id": "piper-pl-gosia-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "gosia",
    "language": [
      {
        "lang_code": "pl",
        "language_name": "Polish",
        "country": "PL"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-pl_PL-gosia-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-pl-mc_speech-medium": {
    "id": "piper-pl-mc_speech-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "mc_speech",
    "language": [
      {
        "lang_code": "pl",
        "language_name": "Polish",
        "country": "PL"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-pl_PL-mc_speech-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.13
  },
  "piper-pt-edresson-low": {
    "id": "piper-pt-edresson-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "edresson",
    "language": [
      {
        "lang_code": "pt",
        "language_name": "Portuguese",
        "country": "BR"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-pt_BR-edresson-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64
  },
  "piper-pt-faber-medium": {
    "id": "piper-pt-faber-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "faber",
    "language": [
      {
        "lang_code": "pt",
        "language_name": "Portuguese",
        "country": "BR"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-pt_BR-faber-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.08
  },
  "piper-pt-tugao-medium": {
    "id": "piper-pt-tugao-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "tugao",
    "language": [
      {
        "lang_code": "pt",
        "language_name": "Portuguese",
        "country": "PT"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-pt_PT-tugao-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-ro-mihai-medium": {
    "id": "piper-ro-mihai-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "mihai",
    "language": [
      {
        "lang_code": "ro",
        "language_name": "Romanian",
        "country": "RO"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ro_RO-mihai-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.08
  },
  "piper-ru-denis-medium": {
    "id": "piper-ru-denis-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "denis",
    "language": [
      {
        "lang_code": "ru",
        "language_name": "Russian",
        "country": "RU"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ru_RU-denis-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.09
  },
  "piper-ru-dmitri-medium": {
    "id": "piper-ru-dmitri-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "dmitri",
    "language": [
      {
        "lang_code": "ru",
        "language_name": "Russian",
        "country": "RU"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ru_RU-dmitri-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.09
  },
  "piper-ru-irina-medium": {
    "id": "piper-ru-irina-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "irina",
    "language": [
      {
        "lang_code": "ru",
        "language_name": "Russian",
        "country": "RU"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ru_RU-irina-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.06
  },
  "piper-ru-ruslan-medium": {
    "id": "piper-ru-ruslan-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "ruslan",
    "language": [
      {
        "lang_code": "ru",
        "language_name": "Russian",
        "country": "RU"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-ru_RU-ruslan-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.07
  },
  "piper-sk-lili-medium": {
    "id": "piper-sk-lili-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "lili",
    "language": [
      {
        "lang_code": "sk",
        "language_name": "Slovak",
        "country": "SK"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-sk_SK-lili-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.08
  },
  "piper-sl-artur-medium": {
    "id": "piper-sl-artur-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "artur",
    "language": [
      {
        "lang_code": "sl",
        "language_name": "Slovenian",
        "country": "SI"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-sl_SI-artur-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 63.97
  },
  "piper-sr-serbski_institut-medium": {
    "id": "piper-sr-serbski_institut-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "serbski_institut",
    "language": [
      {
        "lang_code": "sr",
        "language_name": "Serbian",
        "country": "RS"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-sr_RS-serbski_institut-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.61
  },
  "piper-sv-nst-medium": {
    "id": "piper-sv-nst-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "nst",
    "language": [
      {
        "lang_code": "sv",
        "language_name": "Swedish",
        "country": "SE"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-sv_SE-nst-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.03
  },
  "piper-sw-lanfrica-medium": {
    "id": "piper-sw-lanfrica-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "lanfrica",
    "language": [
      {
        "lang_code": "sw",
        "language_name": "Swahili",
        "country": "CD"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-sw_CD-lanfrica-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-tr-dfki-medium": {
    "id": "piper-tr-dfki-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "dfki",
    "language": [
      {
        "lang_code": "tr",
        "language_name": "Turkish",
        "country": "TR"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-tr_TR-dfki-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.12
  },
  "piper-tr-fahrettin-medium": {
    "id": "piper-tr-fahrettin-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "fahrettin",
    "language": [
      {
        "lang_code": "tr",
        "language_name": "Turkish",
        "country": "TR"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-tr_TR-fahrettin-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.11
  },
  "piper-tr-fettah-medium": {
    "id": "piper-tr-fettah-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "fettah",
    "language": [
      {
        "lang_code": "tr",
        "language_name": "Turkish",
        "country": "TR"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-tr_TR-fettah-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.1
  },
  "piper-uk-lada-low": {
    "id": "piper-uk-lada-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "lada",
    "language": [
      {
        "lang_code": "uk",
        "language_name": "Ukrainian",
        "country": "UA"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-uk_UA-lada-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 25.25
  },
  "piper-uk-ukrainian_tts-medium": {
    "id": "piper-uk-ukrainian_tts-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "ukrainian_tts",
    "language": [
      {
        "lang_code": "uk",
        "language_name": "Ukrainian",
        "country": "UA"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-uk_UA-ukrainian_tts-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 76.6
  },
  "piper-vi-25hours_single-low": {
    "id": "piper-vi-25hours_single-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "25hours_single",
    "language": [
      {
        "lang_code": "vi",
        "language_name": "Vietnamese",
        "country": "VN"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-vi_VN-25hours_single-low.tar.bz2",
    "compression": true,
    "filesize_mb": 64
  },
  "piper-vi-vais1000-medium": {
    "id": "piper-vi-vais1000-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "vais1000",
    "language": [
      {
        "lang_code": "vi",
        "language_name": "Vietnamese",
        "country": "VN"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-vi_VN-vais1000-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.09
  },
  "piper-vi-vivos-low": {
    "id": "piper-vi-vivos-low",
    "model_type": "vits",
    "developer": "piper",
    "name": "vivos",
    "language": [
      {
        "lang_code": "vi",
        "language_name": "Vietnamese",
        "country": "VN"
      }
    ],
    "quality": "low",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-vi_VN-vivos-x_low.tar.bz2",
    "compression": true,
    "filesize_mb": 31.83
  },
  "piper-zh-huayan-medium": {
    "id": "piper-zh-huayan-medium",
    "model_type": "vits",
    "developer": "piper",
    "name": "huayan",
    "language": [
      {
        "lang_code": "zh",
        "language_name": "Chinese",
        "country": "CN"
      }
    ],
    "quality": "medium",
    "sample_rate": 22050,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-piper-zh_CN-huayan-medium.tar.bz2",
    "compression": true,
    "filesize_mb": 64.15
  },
  "vctk-fs-unknown": {
    "id": "vctk-fs-unknown",
    "model_type": "vits",
    "developer": "vctk",
    "name": "unknown",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-vctk.tar.bz2",
    "compression": true,
    "filesize_mb": 144.73
  },
  "zh-fs-unknown": {
    "id": "zh-fs-unknown",
    "model_type": "vits",
    "developer": "zh",
    "name": "unknown",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-aishell3.tar.bz2",
    "compression": true,
    "filesize_mb": 140.12
  },
  "zh-fs-abyssinvoker": {
    "id": "zh-fs-abyssinvoker",
    "model_type": "vits",
    "developer": "zh",
    "name": "abyssinvoker",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-abyssinvoker.tar.bz2",
    "compression": true,
    "filesize_mb": 114.99
  },
  "zh-fs-bronya": {
    "id": "zh-fs-bronya",
    "model_type": "vits",
    "developer": "zh",
    "name": "bronya",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-bronya.tar.bz2",
    "compression": true,
    "filesize_mb": 115.01
  },
  "zh-fs-doom": {
    "id": "zh-fs-doom",
    "model_type": "vits",
    "developer": "zh",
    "name": "doom",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-doom.tar.bz2",
    "compression": true,
    "filesize_mb": 114.97
  },
  "zh-fs-echo": {
    "id": "zh-fs-echo",
    "model_type": "vits",
    "developer": "zh",
    "name": "echo",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-echo.tar.bz2",
    "compression": true,
    "filesize_mb": 114.97
  },
  "zh-fs-eula": {
    "id": "zh-fs-eula",
    "model_type": "vits",
    "developer": "zh",
    "name": "eula",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-eula.tar.bz2",
    "compression": true,
    "filesize_mb": 114.98
  },
  "zh-fs-fanchen-C": {
    "id": "zh-fs-fanchen-C",
    "model_type": "vits",
    "developer": "zh",
    "name": "fanchen",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "C",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-fanchen-C.tar.bz2",
    "compression": true,
    "filesize_mb": 113.8
  },
  "zh-fs-fanchen-unity": {
    "id": "zh-fs-fanchen-unity",
    "model_type": "vits",
    "developer": "zh",
    "name": "fanchen",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unity",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-fanchen-unity.tar.bz2",
    "compression": true,
    "filesize_mb": 113.62
  },
  "zh-fs-fanchen-wnj": {
    "id": "zh-fs-fanchen-wnj",
    "model_type": "vits",
    "developer": "zh",
    "name": "fanchen",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "wnj",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-fanchen-wnj.tar.bz2",
    "compression": true,
    "filesize_mb": 113.64
  },
  "zh-fs-fanchen-ZhiHuiLaoZhe": {
    "id": "zh-fs-fanchen-ZhiHuiLaoZhe",
    "model_type": "vits",
    "developer": "zh",
    "name": "fanchen",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "ZhiHuiLaoZhe",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-fanchen-ZhiHuiLaoZhe.tar.bz2",
    "compression": true,
    "filesize_mb": 113.93
  },
  "zh-fs-fanchen-new": {
    "id": "zh-fs-fanchen-new",
    "model_type": "vits",
    "developer": "zh",
    "name": "fanchen",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "new",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-fanchen-ZhiHuiLaoZhe_new.tar.bz2",
    "compression": true,
    "filesize_mb": 113.87
  },
  "zh-fs-keqing": {
    "id": "zh-fs-keqing",
    "model_type": "vits",
    "developer": "zh",
    "name": "keqing",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-keqing.tar.bz2",
    "compression": true,
    "filesize_mb": 115.01
  },
  "zh-fs-theresa": {
    "id": "zh-fs-theresa",
    "model_type": "vits",
    "developer": "zh",
    "name": "theresa",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-theresa.tar.bz2",
    "compression": true,
    "filesize_mb": 115.01
  },
  "zh-fs-zenyatta": {
    "id": "zh-fs-zenyatta",
    "model_type": "vits",
    "developer": "zh",
    "name": "zenyatta",
    "language": [
      {
        "lang_code": "fs",
        "language_name": "Unknown language [fs]",
        "country": "US"
      }
    ],
    "quality": "unknown",
    "sample_rate": 16000,
    "num_speakers": 1,
    "url": "https://github.com/k2-fsa/sherpa-onnx/releases/download/tts-models/vits-zh-hf-zenyatta.tar.bz2",
    "compression": true,
    "filesize_mb": 115
  },
  "mms_abi": {
    "id": "mms_abi",
    "language": [
      {
        "Iso Code": "abi",
        "Language Name": "Abidji",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/abi"
  },
  "mms_ace": {
    "id": "mms_ace",
    "language": [
      {
        "Iso Code": "ace",
        "Language Name": "Aceh",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ace"
  },
  "mms_aca": {
    "id": "mms_aca",
    "language": [
      {
        "Iso Code": "aca",
        "Language Name": "Achagua",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/aca"
  },
  "mms_acn": {
    "id": "mms_acn",
    "language": [
      {
        "Iso Code": "acn",
        "Language Name": "Achang",
        "Country": "China, Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/acn"
  },
  "mms_acr": {
    "id": "mms_acr",
    "language": [
      {
        "Iso Code": "acr",
        "Language Name": "Achi",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/acr"
  },
  "mms_ach": {
    "id": "mms_ach",
    "language": [
      {
        "Iso Code": "ach",
        "Language Name": "Acholi",
        "Country": "Uganda, South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ach"
  },
  "mms_acu": {
    "id": "mms_acu",
    "language": [
      {
        "Iso Code": "acu",
        "Language Name": "Achuar-Shiwiar",
        "Country": "Ecuador, Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/acu"
  },
  "mms_guq": {
    "id": "mms_guq",
    "language": [
      {
        "Iso Code": "guq",
        "Language Name": "Aché",
        "Country": "Paraguay"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/guq"
  },
  "mms_ade": {
    "id": "mms_ade",
    "language": [
      {
        "Iso Code": "ade",
        "Language Name": "Adele",
        "Country": "Ghana, Togo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ade"
  },
  "mms_adj": {
    "id": "mms_adj",
    "language": [
      {
        "Iso Code": "adj",
        "Language Name": "Adioukrou",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/adj"
  },
  "mms_agd": {
    "id": "mms_agd",
    "language": [
      {
        "Iso Code": "agd",
        "Language Name": "Agarabi",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/agd"
  },
  "mms_agx": {
    "id": "mms_agx",
    "language": [
      {
        "Iso Code": "agx",
        "Language Name": "Aghul",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/agx"
  },
  "mms_agn": {
    "id": "mms_agn",
    "language": [
      {
        "Iso Code": "agn",
        "Language Name": "Agutaynen",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/agn"
  },
  "mms_aha": {
    "id": "mms_aha",
    "language": [
      {
        "Iso Code": "aha",
        "Language Name": "Ahanta",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/aha"
  },
  "mms_aka": {
    "id": "mms_aka",
    "language": [
      {
        "Iso Code": "aka",
        "Language Name": "Akan",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/aka"
  },
  "mms_knj": {
    "id": "mms_knj",
    "language": [
      {
        "Iso Code": "knj",
        "Language Name": "Akateko",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/knj"
  },
  "mms_ake": {
    "id": "mms_ake",
    "language": [
      {
        "Iso Code": "ake",
        "Language Name": "Akawaio",
        "Country": "Guyana, Venezuela"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ake"
  },
  "mms_aeu": {
    "id": "mms_aeu",
    "language": [
      {
        "Iso Code": "aeu",
        "Language Name": "Akeu",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/aeu"
  },
  "mms_ahk": {
    "id": "mms_ahk",
    "language": [
      {
        "Iso Code": "ahk",
        "Language Name": "Akha",
        "Country": "China, Laos, Myanmar, Thailand"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ahk"
  },
  "mms_bss": {
    "id": "mms_bss",
    "language": [
      {
        "Iso Code": "bss",
        "Language Name": "Akoose",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bss"
  },
  "mms_alj": {
    "id": "mms_alj",
    "language": [
      {
        "Iso Code": "alj",
        "Language Name": "Alangan",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/alj"
  },
  "mms_sqi": {
    "id": "mms_sqi",
    "language": [
      {
        "Iso Code": "sqi",
        "Language Name": "Albanian",
        "Country": "Albania"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sqi"
  },
  "mms_alt": {
    "id": "mms_alt",
    "language": [
      {
        "Iso Code": "alt",
        "Language Name": "Altai, Southern",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/alt"
  },
  "mms_alp": {
    "id": "mms_alp",
    "language": [
      {
        "Iso Code": "alp",
        "Language Name": "Alune",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/alp"
  },
  "mms_alz": {
    "id": "mms_alz",
    "language": [
      {
        "Iso Code": "alz",
        "Language Name": "Alur",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/alz"
  },
  "mms_kab": {
    "id": "mms_kab",
    "language": [
      {
        "Iso Code": "kab",
        "Language Name": "Amazigh",
        "Country": "Algeria, Morocco"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kab"
  },
  "mms_amk": {
    "id": "mms_amk",
    "language": [
      {
        "Iso Code": "amk",
        "Language Name": "Ambai",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/amk"
  },
  "mms_mmg": {
    "id": "mms_mmg",
    "language": [
      {
        "Iso Code": "mmg",
        "Language Name": "Ambrym, North",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mmg"
  },
  "mms_amh": {
    "id": "mms_amh",
    "language": [
      {
        "Iso Code": "amh",
        "Language Name": "Amharic",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": false,
    "Sample Exists": false,
    "url": "Not available"
  },
  "mms_ami": {
    "id": "mms_ami",
    "language": [
      {
        "Iso Code": "ami",
        "Language Name": "Amis",
        "Country": "Taiwan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ami"
  },
  "mms_azg": {
    "id": "mms_azg",
    "language": [
      {
        "Iso Code": "azg",
        "Language Name": "Amuzgo, San Pedro Amuzgos",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/azg"
  },
  "mms_agg": {
    "id": "mms_agg",
    "language": [
      {
        "Iso Code": "agg",
        "Language Name": "Angor",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/agg"
  },
  "mms_boj": {
    "id": "mms_boj",
    "language": [
      {
        "Iso Code": "boj",
        "Language Name": "Anjam",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/boj"
  },
  "mms_cko": {
    "id": "mms_cko",
    "language": [
      {
        "Iso Code": "cko",
        "Language Name": "Anufo",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cko"
  },
  "mms_any": {
    "id": "mms_any",
    "language": [
      {
        "Iso Code": "any",
        "Language Name": "Anyin",
        "Country": "Ivory Coast, Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/any"
  },
  "mms_arl": {
    "id": "mms_arl",
    "language": [
      {
        "Iso Code": "arl",
        "Language Name": "Arabela",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/arl"
  },
  "mms_ara": {
    "id": "mms_ara",
    "language": [
      {
        "Iso Code": "ara",
        "Language Name": "Arabic",
        "Country": "Multiple Countries"
      }
    ],
    "Region": "Asia, Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ara"
  },
  "mms_atq": {
    "id": "mms_atq",
    "language": [
      {
        "Iso Code": "atq",
        "Language Name": "Aralle-Tabulahan",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/atq"
  },
  "mms_luc": {
    "id": "mms_luc",
    "language": [
      {
        "Iso Code": "luc",
        "Language Name": "Aringa",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/luc"
  },
  "mms_hyw": {
    "id": "mms_hyw",
    "language": [
      {
        "Iso Code": "hyw",
        "Language Name": "Armenian, Western",
        "Country": "Turkey"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hyw"
  },
  "mms_apr": {
    "id": "mms_apr",
    "language": [
      {
        "Iso Code": "apr",
        "Language Name": "Arop-Lokep",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/apr"
  },
  "mms_aia": {
    "id": "mms_aia",
    "language": [
      {
        "Iso Code": "aia",
        "Language Name": "Arosi",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/aia"
  },
  "mms_msy": {
    "id": "mms_msy",
    "language": [
      {
        "Iso Code": "msy",
        "Language Name": "Aruamu",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/msy"
  },
  "mms_cni": {
    "id": "mms_cni",
    "language": [
      {
        "Iso Code": "cni",
        "Language Name": "Asháninka",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cni"
  },
  "mms_cjo": {
    "id": "mms_cjo",
    "language": [
      {
        "Iso Code": "cjo",
        "Language Name": "Ashéninka, Pajonal",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cjo"
  },
  "mms_cpu": {
    "id": "mms_cpu",
    "language": [
      {
        "Iso Code": "cpu",
        "Language Name": "Ashéninka, Pichis",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cpu"
  },
  "mms_cpb": {
    "id": "mms_cpb",
    "language": [
      {
        "Iso Code": "cpb",
        "Language Name": "Ashéninka, Ucayali-Yurúa",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cpb"
  },
  "mms_asm": {
    "id": "mms_asm",
    "language": [
      {
        "Iso Code": "asm",
        "Language Name": "Assamese",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/asm"
  },
  "mms_asa": {
    "id": "mms_asa",
    "language": [
      {
        "Iso Code": "asa",
        "Language Name": "Asu",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/asa"
  },
  "mms_teo": {
    "id": "mms_teo",
    "language": [
      {
        "Iso Code": "teo",
        "Language Name": "Ateso",
        "Country": "Uganda, Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/teo"
  },
  "mms_ati": {
    "id": "mms_ati",
    "language": [
      {
        "Iso Code": "ati",
        "Language Name": "Attié",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ati"
  },
  "mms_djk": {
    "id": "mms_djk",
    "language": [
      {
        "Iso Code": "djk",
        "Language Name": "Aukan",
        "Country": "Suriname"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/djk"
  },
  "mms_ava": {
    "id": "mms_ava",
    "language": [
      {
        "Iso Code": "ava",
        "Language Name": "Avar",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ava"
  },
  "mms_avn": {
    "id": "mms_avn",
    "language": [
      {
        "Iso Code": "avn",
        "Language Name": "Avatime",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/avn"
  },
  "mms_avu": {
    "id": "mms_avu",
    "language": [
      {
        "Iso Code": "avu",
        "Language Name": "Avokaya",
        "Country": "South Sudan, Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/avu"
  },
  "mms_awb": {
    "id": "mms_awb",
    "language": [
      {
        "Iso Code": "awb",
        "Language Name": "Awa",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/awb"
  },
  "mms_kwi": {
    "id": "mms_kwi",
    "language": [
      {
        "Iso Code": "kwi",
        "Language Name": "Awa-Cuaiquer",
        "Country": "Colombia, Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kwi"
  },
  "mms_awa": {
    "id": "mms_awa",
    "language": [
      {
        "Iso Code": "awa",
        "Language Name": "Awadhi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/awa"
  },
  "mms_agr": {
    "id": "mms_agr",
    "language": [
      {
        "Iso Code": "agr",
        "Language Name": "Awajún",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/agr"
  },
  "mms_agu": {
    "id": "mms_agu",
    "language": [
      {
        "Iso Code": "agu",
        "Language Name": "Awakateko",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/agu"
  },
  "mms_ayr": {
    "id": "mms_ayr",
    "language": [
      {
        "Iso Code": "ayr",
        "Language Name": "Aymara, Central",
        "Country": "Bolivia, Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ayr"
  },
  "mms_ayo": {
    "id": "mms_ayo",
    "language": [
      {
        "Iso Code": "ayo",
        "Language Name": "Ayoreo",
        "Country": "Bolivia, Paraguay"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ayo"
  },
  "mms_abp": {
    "id": "mms_abp",
    "language": [
      {
        "Iso Code": "abp",
        "Language Name": "Ayta, Abellen",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/abp"
  },
  "mms_blx": {
    "id": "mms_blx",
    "language": [
      {
        "Iso Code": "blx",
        "Language Name": "Ayta, Mag-Indi",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/blx"
  },
  "mms_sgb": {
    "id": "mms_sgb",
    "language": [
      {
        "Iso Code": "sgb",
        "Language Name": "Ayta, Mag-antsi",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sgb"
  },
  "mms_azj-script_cyrillic": {
    "id": "mms_azj-script_cyrillic",
    "language": [
      {
        "Iso Code": "cyrillic",
        "Language Name": "Azerbaijani, North",
        "Country": "Azerbaijan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/azj-script_cyrillic"
  },
  "mms_azj-script_latin": {
    "id": "mms_azj-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Azerbaijani, North",
        "Country": "Azerbaijan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/azj-script_latin"
  },
  "mms_azb": {
    "id": "mms_azb",
    "language": [
      {
        "Iso Code": "azb",
        "Language Name": "Azerbaijani, South",
        "Country": "Iran"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/azb"
  },
  "mms_bba": {
    "id": "mms_bba",
    "language": [
      {
        "Iso Code": "bba",
        "Language Name": "Baatonum",
        "Country": "Benin, Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bba"
  },
  "mms_bhz": {
    "id": "mms_bhz",
    "language": [
      {
        "Iso Code": "bhz",
        "Language Name": "Bada",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bhz"
  },
  "mms_bvc": {
    "id": "mms_bvc",
    "language": [
      {
        "Iso Code": "bvc",
        "Language Name": "Baelelea",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bvc"
  },
  "mms_bfy": {
    "id": "mms_bfy",
    "language": [
      {
        "Iso Code": "bfy",
        "Language Name": "Bagheli",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bfy"
  },
  "mms_bgq": {
    "id": "mms_bgq",
    "language": [
      {
        "Iso Code": "bgq",
        "Language Name": "Bagri",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bgq"
  },
  "mms_bdq": {
    "id": "mms_bdq",
    "language": [
      {
        "Iso Code": "bdq",
        "Language Name": "Bahnar",
        "Country": "Vietnam"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bdq"
  },
  "mms_bdh": {
    "id": "mms_bdh",
    "language": [
      {
        "Iso Code": "bdh",
        "Language Name": "Baka",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bdh"
  },
  "mms_bqi": {
    "id": "mms_bqi",
    "language": [
      {
        "Iso Code": "bqi",
        "Language Name": "Bakhtiâri",
        "Country": "Iran"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bqi"
  },
  "mms_bjw": {
    "id": "mms_bjw",
    "language": [
      {
        "Iso Code": "bjw",
        "Language Name": "Bakwé",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bjw"
  },
  "mms_blz": {
    "id": "mms_blz",
    "language": [
      {
        "Iso Code": "blz",
        "Language Name": "Balantak",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/blz"
  },
  "mms_ban": {
    "id": "mms_ban",
    "language": [
      {
        "Iso Code": "ban",
        "Language Name": "Bali",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ban"
  },
  "mms_bcc-script_latin": {
    "id": "mms_bcc-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Balochi, Southern",
        "Country": "Pakistan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bcc-script_latin"
  },
  "mms_bcc-script_arabic": {
    "id": "mms_bcc-script_arabic",
    "language": [
      {
        "Iso Code": "arabic",
        "Language Name": "Balochi, Southern",
        "Country": "Pakistan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bcc-script_arabic"
  },
  "mms_bam": {
    "id": "mms_bam",
    "language": [
      {
        "Iso Code": "bam",
        "Language Name": "Bamanankan",
        "Country": "Mali"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bam"
  },
  "mms_ptu": {
    "id": "mms_ptu",
    "language": [
      {
        "Iso Code": "ptu",
        "Language Name": "Bambam",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ptu"
  },
  "mms_bcw": {
    "id": "mms_bcw",
    "language": [
      {
        "Iso Code": "bcw",
        "Language Name": "Bana",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bcw"
  },
  "mms_bqj": {
    "id": "mms_bqj",
    "language": [
      {
        "Iso Code": "bqj",
        "Language Name": "Bandial",
        "Country": "Senegal"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bqj"
  },
  "mms_bno": {
    "id": "mms_bno",
    "language": [
      {
        "Iso Code": "bno",
        "Language Name": "Bantoanon",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bno"
  },
  "mms_bbb": {
    "id": "mms_bbb",
    "language": [
      {
        "Iso Code": "bbb",
        "Language Name": "Barai",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bbb"
  },
  "mms_bfa": {
    "id": "mms_bfa",
    "language": [
      {
        "Iso Code": "bfa",
        "Language Name": "Bari",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bfa"
  },
  "mms_bjz": {
    "id": "mms_bjz",
    "language": [
      {
        "Iso Code": "bjz",
        "Language Name": "Baruga",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bjz"
  },
  "mms_bak": {
    "id": "mms_bak",
    "language": [
      {
        "Iso Code": "bak",
        "Language Name": "Bashkort",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bak"
  },
  "mms_eus": {
    "id": "mms_eus",
    "language": [
      {
        "Iso Code": "eus",
        "Language Name": "Basque",
        "Country": "Spain"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/eus"
  },
  "mms_bsq": {
    "id": "mms_bsq",
    "language": [
      {
        "Iso Code": "bsq",
        "Language Name": "Bassa",
        "Country": "Liberia, Sierra Leone"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bsq"
  },
  "mms_akb": {
    "id": "mms_akb",
    "language": [
      {
        "Iso Code": "akb",
        "Language Name": "Batak Angkola",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/akb"
  },
  "mms_btd": {
    "id": "mms_btd",
    "language": [
      {
        "Iso Code": "btd",
        "Language Name": "Batak Dairi",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/btd"
  },
  "mms_btx": {
    "id": "mms_btx",
    "language": [
      {
        "Iso Code": "btx",
        "Language Name": "Batak Karo",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/btx"
  },
  "mms_bts": {
    "id": "mms_bts",
    "language": [
      {
        "Iso Code": "bts",
        "Language Name": "Batak Simalungun",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bts"
  },
  "mms_bbc": {
    "id": "mms_bbc",
    "language": [
      {
        "Iso Code": "bbc",
        "Language Name": "Batak Toba",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bbc"
  },
  "mms_bvz": {
    "id": "mms_bvz",
    "language": [
      {
        "Iso Code": "bvz",
        "Language Name": "Bauzi",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bvz"
  },
  "mms_bjv": {
    "id": "mms_bjv",
    "language": [
      {
        "Iso Code": "bjv",
        "Language Name": "Bedjond",
        "Country": "Central African Republic"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bjv"
  },
  "mms_bep": {
    "id": "mms_bep",
    "language": [
      {
        "Iso Code": "bep",
        "Language Name": "Behoa",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bep"
  },
  "mms_bkv": {
    "id": "mms_bkv",
    "language": [
      {
        "Iso Code": "bkv",
        "Language Name": "Bekwarra",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bkv"
  },
  "mms_bzj": {
    "id": "mms_bzj",
    "language": [
      {
        "Iso Code": "bzj",
        "Language Name": "Belize English Creole",
        "Country": "Belize"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bzj"
  },
  "mms_bem": {
    "id": "mms_bem",
    "language": [
      {
        "Iso Code": "bem",
        "Language Name": "Bemba",
        "Country": "Zambia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bem"
  },
  "mms_bng": {
    "id": "mms_bng",
    "language": [
      {
        "Iso Code": "bng",
        "Language Name": "Benga",
        "Country": "Gabon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bng"
  },
  "mms_ben": {
    "id": "mms_ben",
    "language": [
      {
        "Iso Code": "ben",
        "Language Name": "Bengali",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ben"
  },
  "mms_bom": {
    "id": "mms_bom",
    "language": [
      {
        "Iso Code": "bom",
        "Language Name": "Berom",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bom"
  },
  "mms_btt": {
    "id": "mms_btt",
    "language": [
      {
        "Iso Code": "btt",
        "Language Name": "Bete-Bendi",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/btt"
  },
  "mms_bha": {
    "id": "mms_bha",
    "language": [
      {
        "Iso Code": "bha",
        "Language Name": "Bharia",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bha"
  },
  "mms_bgw": {
    "id": "mms_bgw",
    "language": [
      {
        "Iso Code": "bgw",
        "Language Name": "Bhatri",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bgw"
  },
  "mms_bht": {
    "id": "mms_bht",
    "language": [
      {
        "Iso Code": "bht",
        "Language Name": "Bhattiyali",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bht"
  },
  "mms_beh": {
    "id": "mms_beh",
    "language": [
      {
        "Iso Code": "beh",
        "Language Name": "Biali",
        "Country": "Benin"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/beh"
  },
  "mms_sne": {
    "id": "mms_sne",
    "language": [
      {
        "Iso Code": "sne",
        "Language Name": "Bidayuh, Bau",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sne"
  },
  "mms_ubl": {
    "id": "mms_ubl",
    "language": [
      {
        "Iso Code": "ubl",
        "Language Name": "Bikol, Buhi’non",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ubl"
  },
  "mms_bcl": {
    "id": "mms_bcl",
    "language": [
      {
        "Iso Code": "bcl",
        "Language Name": "Bikol, Central",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bcl"
  },
  "mms_bim": {
    "id": "mms_bim",
    "language": [
      {
        "Iso Code": "bim",
        "Language Name": "Bimoba",
        "Country": "Ghana, Togo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bim"
  },
  "mms_bkd": {
    "id": "mms_bkd",
    "language": [
      {
        "Iso Code": "bkd",
        "Language Name": "Binukid",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bkd"
  },
  "mms_bjr": {
    "id": "mms_bjr",
    "language": [
      {
        "Iso Code": "bjr",
        "Language Name": "Binumarien",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bjr"
  },
  "mms_bfo": {
    "id": "mms_bfo",
    "language": [
      {
        "Iso Code": "bfo",
        "Language Name": "Birifor, Malba",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bfo"
  },
  "mms_biv": {
    "id": "mms_biv",
    "language": [
      {
        "Iso Code": "biv",
        "Language Name": "Birifor, Southern",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/biv"
  },
  "mms_bib": {
    "id": "mms_bib",
    "language": [
      {
        "Iso Code": "bib",
        "Language Name": "Bisa",
        "Country": "Zambia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bib"
  },
  "mms_bis": {
    "id": "mms_bis",
    "language": [
      {
        "Iso Code": "bis",
        "Language Name": "Bislama",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bis"
  },
  "mms_bzi": {
    "id": "mms_bzi",
    "language": [
      {
        "Iso Code": "bzi",
        "Language Name": "Bisu",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bzi"
  },
  "mms_bqp": {
    "id": "mms_bqp",
    "language": [
      {
        "Iso Code": "bqp",
        "Language Name": "Bisã",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bqp"
  },
  "mms_bpr": {
    "id": "mms_bpr",
    "language": [
      {
        "Iso Code": "bpr",
        "Language Name": "Blaan, Koronadal",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bpr"
  },
  "mms_bps": {
    "id": "mms_bps",
    "language": [
      {
        "Iso Code": "bps",
        "Language Name": "Blaan, Sarangani",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bps"
  },
  "mms_bwq": {
    "id": "mms_bwq",
    "language": [
      {
        "Iso Code": "bwq",
        "Language Name": "Bobo Madaré, Southern",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bwq"
  },
  "mms_bdv": {
    "id": "mms_bdv",
    "language": [
      {
        "Iso Code": "bdv",
        "Language Name": "Bodo Parja",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bdv"
  },
  "mms_bqc": {
    "id": "mms_bqc",
    "language": [
      {
        "Iso Code": "bqc",
        "Language Name": "Boko",
        "Country": "Benin, Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bqc"
  },
  "mms_bus": {
    "id": "mms_bus",
    "language": [
      {
        "Iso Code": "bus",
        "Language Name": "Bokobaru",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bus"
  },
  "mms_bnp": {
    "id": "mms_bnp",
    "language": [
      {
        "Iso Code": "bnp",
        "Language Name": "Bola",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bnp"
  },
  "mms_bmq": {
    "id": "mms_bmq",
    "language": [
      {
        "Iso Code": "bmq",
        "Language Name": "Bomu",
        "Country": "Mali"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bmq"
  },
  "mms_bdg": {
    "id": "mms_bdg",
    "language": [
      {
        "Iso Code": "bdg",
        "Language Name": "Bonggi",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bdg"
  },
  "mms_boa": {
    "id": "mms_boa",
    "language": [
      {
        "Iso Code": "boa",
        "Language Name": "Bora",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/boa"
  },
  "mms_ksr": {
    "id": "mms_ksr",
    "language": [
      {
        "Iso Code": "ksr",
        "Language Name": "Borong",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ksr"
  },
  "mms_bor": {
    "id": "mms_bor",
    "language": [
      {
        "Iso Code": "bor",
        "Language Name": "Borôro",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bor"
  },
  "mms_bru": {
    "id": "mms_bru",
    "language": [
      {
        "Iso Code": "bru",
        "Language Name": "Bru, Eastern",
        "Country": "Laos"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bru"
  },
  "mms_box": {
    "id": "mms_box",
    "language": [
      {
        "Iso Code": "box",
        "Language Name": "Buamu",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/box"
  },
  "mms_bzh": {
    "id": "mms_bzh",
    "language": [
      {
        "Iso Code": "bzh",
        "Language Name": "Buang, Mapos",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bzh"
  },
  "mms_bgt": {
    "id": "mms_bgt",
    "language": [
      {
        "Iso Code": "bgt",
        "Language Name": "Bughotu",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bgt"
  },
  "mms_sab": {
    "id": "mms_sab",
    "language": [
      {
        "Iso Code": "sab",
        "Language Name": "Buglere",
        "Country": "Panama"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sab"
  },
  "mms_bul": {
    "id": "mms_bul",
    "language": [
      {
        "Iso Code": "bul",
        "Language Name": "Bulgarian",
        "Country": "Bulgaria"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bul"
  },
  "mms_bwu": {
    "id": "mms_bwu",
    "language": [
      {
        "Iso Code": "bwu",
        "Language Name": "Buli",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bwu"
  },
  "mms_bmv": {
    "id": "mms_bmv",
    "language": [
      {
        "Iso Code": "bmv",
        "Language Name": "Bum",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bmv"
  },
  "mms_mya": {
    "id": "mms_mya",
    "language": [
      {
        "Iso Code": "mya",
        "Language Name": "Burmese",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mya"
  },
  "mms_tte": {
    "id": "mms_tte",
    "language": [
      {
        "Iso Code": "tte",
        "Language Name": "Bwanabwana",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tte"
  },
  "mms_cjp": {
    "id": "mms_cjp",
    "language": [
      {
        "Iso Code": "cjp",
        "Language Name": "Cabécar",
        "Country": "Costa Rica"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cjp"
  },
  "mms_cbv": {
    "id": "mms_cbv",
    "language": [
      {
        "Iso Code": "cbv",
        "Language Name": "Cacua",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cbv"
  },
  "mms_kaq": {
    "id": "mms_kaq",
    "language": [
      {
        "Iso Code": "kaq",
        "Language Name": "Capanahua",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kaq"
  },
  "mms_cot": {
    "id": "mms_cot",
    "language": [
      {
        "Iso Code": "cot",
        "Language Name": "Caquinte",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cot"
  },
  "mms_cbc": {
    "id": "mms_cbc",
    "language": [
      {
        "Iso Code": "cbc",
        "Language Name": "Carapana",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cbc"
  },
  "mms_car": {
    "id": "mms_car",
    "language": [
      {
        "Iso Code": "car",
        "Language Name": "Carib",
        "Country": "Suriname"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/car"
  },
  "mms_cat": {
    "id": "mms_cat",
    "language": [
      {
        "Iso Code": "cat",
        "Language Name": "Catalan",
        "Country": "Spain"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cat"
  },
  "mms_ceb": {
    "id": "mms_ceb",
    "language": [
      {
        "Iso Code": "ceb",
        "Language Name": "Cebuano",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ceb"
  },
  "mms_cme": {
    "id": "mms_cme",
    "language": [
      {
        "Iso Code": "cme",
        "Language Name": "Cerma",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cme"
  },
  "mms_cbi": {
    "id": "mms_cbi",
    "language": [
      {
        "Iso Code": "cbi",
        "Language Name": "Chachi",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cbi"
  },
  "mms_ceg": {
    "id": "mms_ceg",
    "language": [
      {
        "Iso Code": "ceg",
        "Language Name": "Chamacoco",
        "Country": "Paraguay"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ceg"
  },
  "mms_cly": {
    "id": "mms_cly",
    "language": [
      {
        "Iso Code": "cly",
        "Language Name": "Chatino, Eastern Highland",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cly"
  },
  "mms_cya": {
    "id": "mms_cya",
    "language": [
      {
        "Iso Code": "cya",
        "Language Name": "Chatino, Nopala",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cya"
  },
  "mms_che": {
    "id": "mms_che",
    "language": [
      {
        "Iso Code": "che",
        "Language Name": "Chechen",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/che"
  },
  "mms_hne": {
    "id": "mms_hne",
    "language": [
      {
        "Iso Code": "hne",
        "Language Name": "Chhattisgarhi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hne"
  },
  "mms_nya": {
    "id": "mms_nya",
    "language": [
      {
        "Iso Code": "nya",
        "Language Name": "Chichewa",
        "Country": "Malawi"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nya"
  },
  "mms_dig": {
    "id": "mms_dig",
    "language": [
      {
        "Iso Code": "dig",
        "Language Name": "Chidigo",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dig"
  },
  "mms_dug": {
    "id": "mms_dug",
    "language": [
      {
        "Iso Code": "dug",
        "Language Name": "Chiduruma",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dug"
  },
  "mms_bgr": {
    "id": "mms_bgr",
    "language": [
      {
        "Iso Code": "bgr",
        "Language Name": "Chin, Bawm",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bgr"
  },
  "mms_cek": {
    "id": "mms_cek",
    "language": [
      {
        "Iso Code": "cek",
        "Language Name": "Chin, Eastern Khumi",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cek"
  },
  "mms_cfm": {
    "id": "mms_cfm",
    "language": [
      {
        "Iso Code": "cfm",
        "Language Name": "Chin, Falam",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cfm"
  },
  "mms_cnh": {
    "id": "mms_cnh",
    "language": [
      {
        "Iso Code": "cnh",
        "Language Name": "Chin, Hakha",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cnh"
  },
  "mms_hlt": {
    "id": "mms_hlt",
    "language": [
      {
        "Iso Code": "hlt",
        "Language Name": "Chin, Matu",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hlt"
  },
  "mms_mwq": {
    "id": "mms_mwq",
    "language": [
      {
        "Iso Code": "mwq",
        "Language Name": "Chin, Müün",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mwq"
  },
  "mms_ctd": {
    "id": "mms_ctd",
    "language": [
      {
        "Iso Code": "ctd",
        "Language Name": "Chin, Tedim",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ctd"
  },
  "mms_tcz": {
    "id": "mms_tcz",
    "language": [
      {
        "Iso Code": "tcz",
        "Language Name": "Chin, Thado",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tcz"
  },
  "mms_zyp": {
    "id": "mms_zyp",
    "language": [
      {
        "Iso Code": "zyp",
        "Language Name": "Chin, Zyphe",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zyp"
  },
  "mms_cco": {
    "id": "mms_cco",
    "language": [
      {
        "Iso Code": "cco",
        "Language Name": "Chinantec, Comaltepec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cco"
  },
  "mms_cnl": {
    "id": "mms_cnl",
    "language": [
      {
        "Iso Code": "cnl",
        "Language Name": "Chinantec, Lalana",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cnl"
  },
  "mms_cle": {
    "id": "mms_cle",
    "language": [
      {
        "Iso Code": "cle",
        "Language Name": "Chinantec, Lealao",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cle"
  },
  "mms_chz": {
    "id": "mms_chz",
    "language": [
      {
        "Iso Code": "chz",
        "Language Name": "Chinantec, Ozumacín",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/chz"
  },
  "mms_cpa": {
    "id": "mms_cpa",
    "language": [
      {
        "Iso Code": "cpa",
        "Language Name": "Chinantec, Palantla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cpa"
  },
  "mms_cso": {
    "id": "mms_cso",
    "language": [
      {
        "Iso Code": "cso",
        "Language Name": "Chinantec, Sochiapam",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cso"
  },
  "mms_cnt": {
    "id": "mms_cnt",
    "language": [
      {
        "Iso Code": "cnt",
        "Language Name": "Chinantec, Tepetotutla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cnt"
  },
  "mms_cuc": {
    "id": "mms_cuc",
    "language": [
      {
        "Iso Code": "cuc",
        "Language Name": "Chinantec, Usila",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cuc"
  },
  "mms_hak": {
    "id": "mms_hak",
    "language": [
      {
        "Iso Code": "hak",
        "Language Name": "Chinese, Hakka",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hak"
  },
  "mms_nan": {
    "id": "mms_nan",
    "language": [
      {
        "Iso Code": "nan",
        "Language Name": "Chinese, Min Nan",
        "Country": "Unknown"
      }
    ],
    "Region": "Unknown",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nan"
  },
  "mms_xnj": {
    "id": "mms_xnj",
    "language": [
      {
        "Iso Code": "xnj",
        "Language Name": "Chingoni",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xnj"
  },
  "mms_cap": {
    "id": "mms_cap",
    "language": [
      {
        "Iso Code": "cap",
        "Language Name": "Chipaya",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cap"
  },
  "mms_cax": {
    "id": "mms_cax",
    "language": [
      {
        "Iso Code": "cax",
        "Language Name": "Chiquitano",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cax"
  },
  "mms_ctg": {
    "id": "mms_ctg",
    "language": [
      {
        "Iso Code": "ctg",
        "Language Name": "Chittagonian",
        "Country": "Bangladesh"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ctg"
  },
  "mms_ctu": {
    "id": "mms_ctu",
    "language": [
      {
        "Iso Code": "ctu",
        "Language Name": "Chol",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ctu"
  },
  "mms_chf": {
    "id": "mms_chf",
    "language": [
      {
        "Iso Code": "chf",
        "Language Name": "Chontal, Tabasco",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/chf"
  },
  "mms_cce": {
    "id": "mms_cce",
    "language": [
      {
        "Iso Code": "cce",
        "Language Name": "Chopi",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cce"
  },
  "mms_crt": {
    "id": "mms_crt",
    "language": [
      {
        "Iso Code": "crt",
        "Language Name": "Chorote, Iyojwa’ja",
        "Country": "Paraguay"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/crt"
  },
  "mms_crq": {
    "id": "mms_crq",
    "language": [
      {
        "Iso Code": "crq",
        "Language Name": "Chorote, Iyo’wujwa",
        "Country": "Paraguay"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/crq"
  },
  "mms_cac-dialect_sansebastiáncoatán": {
    "id": "mms_cac-dialect_sansebastiáncoatán",
    "language": [
      {
        "Iso Code": "sansebastiáncoatán",
        "Language Name": "Chuj",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cac-dialect_sansebastiáncoatán"
  },
  "mms_cac-dialect_sanmateoixtatán": {
    "id": "mms_cac-dialect_sanmateoixtatán",
    "language": [
      {
        "Iso Code": "sanmateoixtatán",
        "Language Name": "Chuj",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cac-dialect_sanmateoixtatán"
  },
  "mms_ckt": {
    "id": "mms_ckt",
    "language": [
      {
        "Iso Code": "ckt",
        "Language Name": "Chukchi",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ckt"
  },
  "mms_ncu": {
    "id": "mms_ncu",
    "language": [
      {
        "Iso Code": "ncu",
        "Language Name": "Chumburung",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ncu"
  },
  "mms_cdj": {
    "id": "mms_cdj",
    "language": [
      {
        "Iso Code": "cdj",
        "Language Name": "Churahi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cdj"
  },
  "mms_chv": {
    "id": "mms_chv",
    "language": [
      {
        "Iso Code": "chv",
        "Language Name": "Chuvash",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/chv"
  },
  "mms_caa": {
    "id": "mms_caa",
    "language": [
      {
        "Iso Code": "caa",
        "Language Name": "Ch’orti’",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/caa"
  },
  "mms_asg": {
    "id": "mms_asg",
    "language": [
      {
        "Iso Code": "asg",
        "Language Name": "Cishingini",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/asg"
  },
  "mms_con": {
    "id": "mms_con",
    "language": [
      {
        "Iso Code": "con",
        "Language Name": "Cofán",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/con"
  },
  "mms_crn": {
    "id": "mms_crn",
    "language": [
      {
        "Iso Code": "crn",
        "Language Name": "Cora, El Nayar",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/crn"
  },
  "mms_cok": {
    "id": "mms_cok",
    "language": [
      {
        "Iso Code": "cok",
        "Language Name": "Cora, Santa Teresa",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cok"
  },
  "mms_crk-script_latin": {
    "id": "mms_crk-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Cree, Plains",
        "Country": "Canada"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/crk-script_latin"
  },
  "mms_crk-script_syllabics": {
    "id": "mms_crk-script_syllabics",
    "language": [
      {
        "Iso Code": "syllabics",
        "Language Name": "Cree, Plains",
        "Country": "Canada"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/crk-script_syllabics"
  },
  "mms_crh": {
    "id": "mms_crh",
    "language": [
      {
        "Iso Code": "crh",
        "Language Name": "Crimean Tatar",
        "Country": "Ukraine"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/crh"
  },
  "mms_cui": {
    "id": "mms_cui",
    "language": [
      {
        "Iso Code": "cui",
        "Language Name": "Cuiba",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cui"
  },
  "mms_dsh": {
    "id": "mms_dsh",
    "language": [
      {
        "Iso Code": "dsh",
        "Language Name": "Daasanach",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dsh"
  },
  "mms_dbq": {
    "id": "mms_dbq",
    "language": [
      {
        "Iso Code": "dbq",
        "Language Name": "Daba",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dbq"
  },
  "mms_dga": {
    "id": "mms_dga",
    "language": [
      {
        "Iso Code": "dga",
        "Language Name": "Dagaare, Southern",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dga"
  },
  "mms_dgi": {
    "id": "mms_dgi",
    "language": [
      {
        "Iso Code": "dgi",
        "Language Name": "Dagara, Northern",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dgi"
  },
  "mms_dgk": {
    "id": "mms_dgk",
    "language": [
      {
        "Iso Code": "dgk",
        "Language Name": "Dagba",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dgk"
  },
  "mms_dnj-dialect_gweetaawueast": {
    "id": "mms_dnj-dialect_gweetaawueast",
    "language": [
      {
        "Iso Code": "gweetaawueast",
        "Language Name": "Dan",
        "Country": "Liberia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dnj-dialect_gweetaawueast"
  },
  "mms_dnj-dialect_blowowest": {
    "id": "mms_dnj-dialect_blowowest",
    "language": [
      {
        "Iso Code": "blowowest",
        "Language Name": "Dan",
        "Country": "Liberia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dnj-dialect_blowowest"
  },
  "mms_daa": {
    "id": "mms_daa",
    "language": [
      {
        "Iso Code": "daa",
        "Language Name": "Dangaléat",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/daa"
  },
  "mms_dnt": {
    "id": "mms_dnt",
    "language": [
      {
        "Iso Code": "dnt",
        "Language Name": "Dani, Mid Grand Valley",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dnt"
  },
  "mms_dnw": {
    "id": "mms_dnw",
    "language": [
      {
        "Iso Code": "dnw",
        "Language Name": "Dani, Western",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dnw"
  },
  "mms_dar": {
    "id": "mms_dar",
    "language": [
      {
        "Iso Code": "dar",
        "Language Name": "Dargwa",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dar"
  },
  "mms_tcc": {
    "id": "mms_tcc",
    "language": [
      {
        "Iso Code": "tcc",
        "Language Name": "Datooga",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tcc"
  },
  "mms_dwr": {
    "id": "mms_dwr",
    "language": [
      {
        "Iso Code": "dwr",
        "Language Name": "Dawro",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dwr"
  },
  "mms_ded": {
    "id": "mms_ded",
    "language": [
      {
        "Iso Code": "ded",
        "Language Name": "Dedua",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ded"
  },
  "mms_mzw": {
    "id": "mms_mzw",
    "language": [
      {
        "Iso Code": "mzw",
        "Language Name": "Deg",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mzw"
  },
  "mms_ntr": {
    "id": "mms_ntr",
    "language": [
      {
        "Iso Code": "ntr",
        "Language Name": "Delo",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ntr"
  },
  "mms_ddn": {
    "id": "mms_ddn",
    "language": [
      {
        "Iso Code": "ddn",
        "Language Name": "Dendi",
        "Country": "Benin"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ddn"
  },
  "mms_des": {
    "id": "mms_des",
    "language": [
      {
        "Iso Code": "des",
        "Language Name": "Desano",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/des"
  },
  "mms_dso": {
    "id": "mms_dso",
    "language": [
      {
        "Iso Code": "dso",
        "Language Name": "Desiya",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dso"
  },
  "mms_nfa": {
    "id": "mms_nfa",
    "language": [
      {
        "Iso Code": "nfa",
        "Language Name": "Dhao",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nfa"
  },
  "mms_dhi": {
    "id": "mms_dhi",
    "language": [
      {
        "Iso Code": "dhi",
        "Language Name": "Dhimal",
        "Country": "Nepal"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dhi"
  },
  "mms_gud": {
    "id": "mms_gud",
    "language": [
      {
        "Iso Code": "gud",
        "Language Name": "Dida, Yocoboué",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gud"
  },
  "mms_did": {
    "id": "mms_did",
    "language": [
      {
        "Iso Code": "did",
        "Language Name": "Didinga",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/did"
  },
  "mms_mhu": {
    "id": "mms_mhu",
    "language": [
      {
        "Iso Code": "mhu",
        "Language Name": "Digaro-Mishmi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mhu"
  },
  "mms_dip": {
    "id": "mms_dip",
    "language": [
      {
        "Iso Code": "dip",
        "Language Name": "Dinka, Northeastern",
        "Country": "Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dip"
  },
  "mms_dik": {
    "id": "mms_dik",
    "language": [
      {
        "Iso Code": "dik",
        "Language Name": "Dinka, Southwestern",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dik"
  },
  "mms_tbz": {
    "id": "mms_tbz",
    "language": [
      {
        "Iso Code": "tbz",
        "Language Name": "Ditammari",
        "Country": "Benin"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tbz"
  },
  "mms_dts": {
    "id": "mms_dts",
    "language": [
      {
        "Iso Code": "dts",
        "Language Name": "Dogon, Toro So",
        "Country": "Mali"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dts"
  },
  "mms_dos": {
    "id": "mms_dos",
    "language": [
      {
        "Iso Code": "dos",
        "Language Name": "Dogosé",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dos"
  },
  "mms_dgo": {
    "id": "mms_dgo",
    "language": [
      {
        "Iso Code": "dgo",
        "Language Name": "Dogri",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dgo"
  },
  "mms_mvp": {
    "id": "mms_mvp",
    "language": [
      {
        "Iso Code": "mvp",
        "Language Name": "Duri",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mvp"
  },
  "mms_nld": {
    "id": "mms_nld",
    "language": [
      {
        "Iso Code": "nld",
        "Language Name": "Dutch",
        "Country": "Netherlands"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nld"
  },
  "mms_jen": {
    "id": "mms_jen",
    "language": [
      {
        "Iso Code": "jen",
        "Language Name": "Dza",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jen"
  },
  "mms_dzo": {
    "id": "mms_dzo",
    "language": [
      {
        "Iso Code": "dzo",
        "Language Name": "Dzongkha",
        "Country": "Bhutan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dzo"
  },
  "mms_idd": {
    "id": "mms_idd",
    "language": [
      {
        "Iso Code": "idd",
        "Language Name": "Ede Idaca",
        "Country": "Benin"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/idd"
  },
  "mms_eka": {
    "id": "mms_eka",
    "language": [
      {
        "Iso Code": "eka",
        "Language Name": "Ekajuk",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/eka"
  },
  "mms_cto": {
    "id": "mms_cto",
    "language": [
      {
        "Iso Code": "cto",
        "Language Name": "Embera Catío",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cto"
  },
  "mms_emp": {
    "id": "mms_emp",
    "language": [
      {
        "Iso Code": "emp",
        "Language Name": "Emberá, Northern",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/emp"
  },
  "mms_eng": {
    "id": "mms_eng",
    "language": [
      {
        "Iso Code": "eng",
        "Language Name": "English",
        "Country": "United Kingdom"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/eng"
  },
  "mms_enx": {
    "id": "mms_enx",
    "language": [
      {
        "Iso Code": "enx",
        "Language Name": "Enxet",
        "Country": "Paraguay"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/enx"
  },
  "mms_sja": {
    "id": "mms_sja",
    "language": [
      {
        "Iso Code": "sja",
        "Language Name": "Epena",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sja"
  },
  "mms_myv": {
    "id": "mms_myv",
    "language": [
      {
        "Iso Code": "myv",
        "Language Name": "Erzya",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/myv"
  },
  "mms_mcq": {
    "id": "mms_mcq",
    "language": [
      {
        "Iso Code": "mcq",
        "Language Name": "Ese",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mcq"
  },
  "mms_ese": {
    "id": "mms_ese",
    "language": [
      {
        "Iso Code": "ese",
        "Language Name": "Ese Ejja",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ese"
  },
  "mms_evn": {
    "id": "mms_evn",
    "language": [
      {
        "Iso Code": "evn",
        "Language Name": "Evenki",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/evn"
  },
  "mms_eza": {
    "id": "mms_eza",
    "language": [
      {
        "Iso Code": "eza",
        "Language Name": "Ezaa",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/eza"
  },
  "mms_fal": {
    "id": "mms_fal",
    "language": [
      {
        "Iso Code": "fal",
        "Language Name": "Fali, South",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/fal"
  },
  "mms_fao": {
    "id": "mms_fao",
    "language": [
      {
        "Iso Code": "fao",
        "Language Name": "Faroese",
        "Country": "Faroe Islands"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/fao"
  },
  "mms_far": {
    "id": "mms_far",
    "language": [
      {
        "Iso Code": "far",
        "Language Name": "Fataleka",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/far"
  },
  "mms_fij": {
    "id": "mms_fij",
    "language": [
      {
        "Iso Code": "fij",
        "Language Name": "Fijian",
        "Country": "Fiji"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/fij"
  },
  "mms_fin": {
    "id": "mms_fin",
    "language": [
      {
        "Iso Code": "fin",
        "Language Name": "Finnish",
        "Country": "Finland"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/fin"
  },
  "mms_fon": {
    "id": "mms_fon",
    "language": [
      {
        "Iso Code": "fon",
        "Language Name": "Fon",
        "Country": "Benin"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/fon"
  },
  "mms_frd": {
    "id": "mms_frd",
    "language": [
      {
        "Iso Code": "frd",
        "Language Name": "Fordata",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/frd"
  },
  "mms_fra": {
    "id": "mms_fra",
    "language": [
      {
        "Iso Code": "fra",
        "Language Name": "French",
        "Country": "France"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/fra"
  },
  "mms_ful": {
    "id": "mms_ful",
    "language": [
      {
        "Iso Code": "ful",
        "Language Name": "Fulah",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ful"
  },
  "mms_flr": {
    "id": "mms_flr",
    "language": [
      {
        "Iso Code": "flr",
        "Language Name": "Fuliiru",
        "Country": "Congo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/flr"
  },
  "mms_gau": {
    "id": "mms_gau",
    "language": [
      {
        "Iso Code": "gau",
        "Language Name": "Gadaba, Mudhili",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gau"
  },
  "mms_gbk": {
    "id": "mms_gbk",
    "language": [
      {
        "Iso Code": "gbk",
        "Language Name": "Gaddi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gbk"
  },
  "mms_gag-script_cyrillic": {
    "id": "mms_gag-script_cyrillic",
    "language": [
      {
        "Iso Code": "cyrillic",
        "Language Name": "Gagauz",
        "Country": "Moldova"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gag-script_cyrillic"
  },
  "mms_gag-script_latin": {
    "id": "mms_gag-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Gagauz",
        "Country": "Moldova"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gag-script_latin"
  },
  "mms_gbi": {
    "id": "mms_gbi",
    "language": [
      {
        "Iso Code": "gbi",
        "Language Name": "Galela",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gbi"
  },
  "mms_gmv": {
    "id": "mms_gmv",
    "language": [
      {
        "Iso Code": "gmv",
        "Language Name": "Gamo",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gmv"
  },
  "mms_lug": {
    "id": "mms_lug",
    "language": [
      {
        "Iso Code": "lug",
        "Language Name": "Ganda",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lug"
  },
  "mms_pwg": {
    "id": "mms_pwg",
    "language": [
      {
        "Iso Code": "pwg",
        "Language Name": "Gapapaiwa",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pwg"
  },
  "mms_gbm": {
    "id": "mms_gbm",
    "language": [
      {
        "Iso Code": "gbm",
        "Language Name": "Garhwali",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gbm"
  },
  "mms_cab": {
    "id": "mms_cab",
    "language": [
      {
        "Iso Code": "cab",
        "Language Name": "Garifuna",
        "Country": "Honduras"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cab"
  },
  "mms_grt": {
    "id": "mms_grt",
    "language": [
      {
        "Iso Code": "grt",
        "Language Name": "Garo",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/grt"
  },
  "mms_krs": {
    "id": "mms_krs",
    "language": [
      {
        "Iso Code": "krs",
        "Language Name": "Gbaya",
        "Country": "Central African Republic"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/krs"
  },
  "mms_gso": {
    "id": "mms_gso",
    "language": [
      {
        "Iso Code": "gso",
        "Language Name": "Gbaya, Southwest",
        "Country": "Central African Republic"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gso"
  },
  "mms_nlg": {
    "id": "mms_nlg",
    "language": [
      {
        "Iso Code": "nlg",
        "Language Name": "Gela",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nlg"
  },
  "mms_gej": {
    "id": "mms_gej",
    "language": [
      {
        "Iso Code": "gej",
        "Language Name": "Gen",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gej"
  },
  "mms_deu": {
    "id": "mms_deu",
    "language": [
      {
        "Iso Code": "deu",
        "Language Name": "German, Standard",
        "Country": "Germany"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/deu"
  },
  "mms_gri": {
    "id": "mms_gri",
    "language": [
      {
        "Iso Code": "gri",
        "Language Name": "Ghari",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gri"
  },
  "mms_kik": {
    "id": "mms_kik",
    "language": [
      {
        "Iso Code": "kik",
        "Language Name": "Gikuyu",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kik"
  },
  "mms_acd": {
    "id": "mms_acd",
    "language": [
      {
        "Iso Code": "acd",
        "Language Name": "Gikyode",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/acd"
  },
  "mms_glk": {
    "id": "mms_glk",
    "language": [
      {
        "Iso Code": "glk",
        "Language Name": "Gilaki",
        "Country": "Iran"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/glk"
  },
  "mms_gof-script_latin": {
    "id": "mms_gof-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Gofa",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gof-script_latin"
  },
  "mms_gog": {
    "id": "mms_gog",
    "language": [
      {
        "Iso Code": "gog",
        "Language Name": "Gogo",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gog"
  },
  "mms_gkn": {
    "id": "mms_gkn",
    "language": [
      {
        "Iso Code": "gkn",
        "Language Name": "Gokana",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gkn"
  },
  "mms_wsg": {
    "id": "mms_wsg",
    "language": [
      {
        "Iso Code": "wsg",
        "Language Name": "Gondi, Adilabad",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wsg"
  },
  "mms_gjn": {
    "id": "mms_gjn",
    "language": [
      {
        "Iso Code": "gjn",
        "Language Name": "Gonja",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gjn"
  },
  "mms_gqr": {
    "id": "mms_gqr",
    "language": [
      {
        "Iso Code": "gqr",
        "Language Name": "Gor",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gqr"
  },
  "mms_gor": {
    "id": "mms_gor",
    "language": [
      {
        "Iso Code": "gor",
        "Language Name": "Gorontalo",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gor"
  },
  "mms_gux": {
    "id": "mms_gux",
    "language": [
      {
        "Iso Code": "gux",
        "Language Name": "Gourmanchéma",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gux"
  },
  "mms_gbo": {
    "id": "mms_gbo",
    "language": [
      {
        "Iso Code": "gbo",
        "Language Name": "Grebo, Northern",
        "Country": "Liberia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gbo"
  },
  "mms_ell": {
    "id": "mms_ell",
    "language": [
      {
        "Iso Code": "ell",
        "Language Name": "Greek",
        "Country": "Greece"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ell"
  },
  "mms_grc": {
    "id": "mms_grc",
    "language": [
      {
        "Iso Code": "grc",
        "Language Name": "Greek, Ancient",
        "Country": "Greece"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/grc"
  },
  "mms_guh": {
    "id": "mms_guh",
    "language": [
      {
        "Iso Code": "guh",
        "Language Name": "Guahibo",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/guh"
  },
  "mms_gub": {
    "id": "mms_gub",
    "language": [
      {
        "Iso Code": "gub",
        "Language Name": "Guajajára",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gub"
  },
  "mms_grn": {
    "id": "mms_grn",
    "language": [
      {
        "Iso Code": "grn",
        "Language Name": "Guarani",
        "Country": "Paraguay"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/grn"
  },
  "mms_gyr": {
    "id": "mms_gyr",
    "language": [
      {
        "Iso Code": "gyr",
        "Language Name": "Guarayu",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gyr"
  },
  "mms_guo": {
    "id": "mms_guo",
    "language": [
      {
        "Iso Code": "guo",
        "Language Name": "Guayabero",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/guo"
  },
  "mms_gde": {
    "id": "mms_gde",
    "language": [
      {
        "Iso Code": "gde",
        "Language Name": "Gude",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gde"
  },
  "mms_guj": {
    "id": "mms_guj",
    "language": [
      {
        "Iso Code": "guj",
        "Language Name": "Gujarati",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/guj"
  },
  "mms_gvl": {
    "id": "mms_gvl",
    "language": [
      {
        "Iso Code": "gvl",
        "Language Name": "Gulay",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gvl"
  },
  "mms_guk": {
    "id": "mms_guk",
    "language": [
      {
        "Iso Code": "guk",
        "Language Name": "Gumuz",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": false,
    "Sample Exists": false,
    "url": "Not available"
  },
  "mms_rub": {
    "id": "mms_rub",
    "language": [
      {
        "Iso Code": "rub",
        "Language Name": "Gungu",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rub"
  },
  "mms_dah": {
    "id": "mms_dah",
    "language": [
      {
        "Iso Code": "dah",
        "Language Name": "Gwahatike",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dah"
  },
  "mms_gwr": {
    "id": "mms_gwr",
    "language": [
      {
        "Iso Code": "gwr",
        "Language Name": "Gwere",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gwr"
  },
  "mms_gwi": {
    "id": "mms_gwi",
    "language": [
      {
        "Iso Code": "gwi",
        "Language Name": "Gwich’in",
        "Country": "Canada"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gwi"
  },
  "mms_hat": {
    "id": "mms_hat",
    "language": [
      {
        "Iso Code": "hat",
        "Language Name": "Haitian Creole",
        "Country": "Haiti"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hat"
  },
  "mms_hlb": {
    "id": "mms_hlb",
    "language": [
      {
        "Iso Code": "hlb",
        "Language Name": "Halbi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hlb"
  },
  "mms_amf": {
    "id": "mms_amf",
    "language": [
      {
        "Iso Code": "amf",
        "Language Name": "Hamer-Banna",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/amf"
  },
  "mms_hag": {
    "id": "mms_hag",
    "language": [
      {
        "Iso Code": "hag",
        "Language Name": "Hanga",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hag"
  },
  "mms_hnn": {
    "id": "mms_hnn",
    "language": [
      {
        "Iso Code": "hnn",
        "Language Name": "Hanunoo",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hnn"
  },
  "mms_bgc": {
    "id": "mms_bgc",
    "language": [
      {
        "Iso Code": "bgc",
        "Language Name": "Haryanvi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bgc"
  },
  "mms_had": {
    "id": "mms_had",
    "language": [
      {
        "Iso Code": "had",
        "Language Name": "Hatam",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/had"
  },
  "mms_hau": {
    "id": "mms_hau",
    "language": [
      {
        "Iso Code": "hau",
        "Language Name": "Hausa",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hau"
  },
  "mms_hwc": {
    "id": "mms_hwc",
    "language": [
      {
        "Iso Code": "hwc",
        "Language Name": "Hawaii Pidgin",
        "Country": "United States"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hwc"
  },
  "mms_hvn": {
    "id": "mms_hvn",
    "language": [
      {
        "Iso Code": "hvn",
        "Language Name": "Hawu",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hvn"
  },
  "mms_hay": {
    "id": "mms_hay",
    "language": [
      {
        "Iso Code": "hay",
        "Language Name": "Haya",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hay"
  },
  "mms_xed": {
    "id": "mms_xed",
    "language": [
      {
        "Iso Code": "xed",
        "Language Name": "Hdi",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xed"
  },
  "mms_heb": {
    "id": "mms_heb",
    "language": [
      {
        "Iso Code": "heb",
        "Language Name": "Hebrew",
        "Country": "Israel"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/heb"
  },
  "mms_heh": {
    "id": "mms_heh",
    "language": [
      {
        "Iso Code": "heh",
        "Language Name": "Hehe",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/heh"
  },
  "mms_hil": {
    "id": "mms_hil",
    "language": [
      {
        "Iso Code": "hil",
        "Language Name": "Hiligaynon",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hil"
  },
  "mms_hin": {
    "id": "mms_hin",
    "language": [
      {
        "Iso Code": "hin",
        "Language Name": "Hindi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hin"
  },
  "mms_hif": {
    "id": "mms_hif",
    "language": [
      {
        "Iso Code": "hif",
        "Language Name": "Hindi, Fiji",
        "Country": "Fiji"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hif"
  },
  "mms_hns": {
    "id": "mms_hns",
    "language": [
      {
        "Iso Code": "hns",
        "Language Name": "Hindustani, Sarnami",
        "Country": "Suriname"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hns"
  },
  "mms_hoc": {
    "id": "mms_hoc",
    "language": [
      {
        "Iso Code": "hoc",
        "Language Name": "Ho",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hoc"
  },
  "mms_hoy": {
    "id": "mms_hoy",
    "language": [
      {
        "Iso Code": "hoy",
        "Language Name": "Holiya",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hoy"
  },
  "mms_hus-dialect_westernpotosino": {
    "id": "mms_hus-dialect_westernpotosino",
    "language": [
      {
        "Iso Code": "westernpotosino",
        "Language Name": "Huastec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hus-dialect_westernpotosino"
  },
  "mms_hus-dialect_centralveracruz": {
    "id": "mms_hus-dialect_centralveracruz",
    "language": [
      {
        "Iso Code": "centralveracruz",
        "Language Name": "Huastec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hus-dialect_centralveracruz"
  },
  "mms_huv": {
    "id": "mms_huv",
    "language": [
      {
        "Iso Code": "huv",
        "Language Name": "Huave, San Mateo del Mar",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/huv"
  },
  "mms_hui": {
    "id": "mms_hui",
    "language": [
      {
        "Iso Code": "hui",
        "Language Name": "Huli",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hui"
  },
  "mms_hun": {
    "id": "mms_hun",
    "language": [
      {
        "Iso Code": "hun",
        "Language Name": "Hungarian",
        "Country": "Hungary"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hun"
  },
  "mms_hap": {
    "id": "mms_hap",
    "language": [
      {
        "Iso Code": "hap",
        "Language Name": "Hupla",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hap"
  },
  "mms_iba": {
    "id": "mms_iba",
    "language": [
      {
        "Iso Code": "iba",
        "Language Name": "Iban",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/iba"
  },
  "mms_isl": {
    "id": "mms_isl",
    "language": [
      {
        "Iso Code": "isl",
        "Language Name": "Icelandic",
        "Country": "Iceland"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/isl"
  },
  "mms_dbj": {
    "id": "mms_dbj",
    "language": [
      {
        "Iso Code": "dbj",
        "Language Name": "Ida’an",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dbj"
  },
  "mms_ifa": {
    "id": "mms_ifa",
    "language": [
      {
        "Iso Code": "ifa",
        "Language Name": "Ifugao, Amganad",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ifa"
  },
  "mms_ifb": {
    "id": "mms_ifb",
    "language": [
      {
        "Iso Code": "ifb",
        "Language Name": "Ifugao, Batad",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ifb"
  },
  "mms_ifu": {
    "id": "mms_ifu",
    "language": [
      {
        "Iso Code": "ifu",
        "Language Name": "Ifugao, Mayoyao",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ifu"
  },
  "mms_ifk": {
    "id": "mms_ifk",
    "language": [
      {
        "Iso Code": "ifk",
        "Language Name": "Ifugao, Tuwali",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ifk"
  },
  "mms_ife": {
    "id": "mms_ife",
    "language": [
      {
        "Iso Code": "ife",
        "Language Name": "Ifè",
        "Country": "Togo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ife"
  },
  "mms_ign": {
    "id": "mms_ign",
    "language": [
      {
        "Iso Code": "ign",
        "Language Name": "Ignaciano",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ign"
  },
  "mms_ikk": {
    "id": "mms_ikk",
    "language": [
      {
        "Iso Code": "ikk",
        "Language Name": "Ika",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ikk"
  },
  "mms_iqw": {
    "id": "mms_iqw",
    "language": [
      {
        "Iso Code": "iqw",
        "Language Name": "Ikwo",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/iqw"
  },
  "mms_ilb": {
    "id": "mms_ilb",
    "language": [
      {
        "Iso Code": "ilb",
        "Language Name": "Ila",
        "Country": "Zambia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ilb"
  },
  "mms_ilo": {
    "id": "mms_ilo",
    "language": [
      {
        "Iso Code": "ilo",
        "Language Name": "Ilocano",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ilo"
  },
  "mms_imo": {
    "id": "mms_imo",
    "language": [
      {
        "Iso Code": "imo",
        "Language Name": "Imbongu",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/imo"
  },
  "mms_ind": {
    "id": "mms_ind",
    "language": [
      {
        "Iso Code": "ind",
        "Language Name": "Indonesian",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ind"
  },
  "mms_inb": {
    "id": "mms_inb",
    "language": [
      {
        "Iso Code": "inb",
        "Language Name": "Inga",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/inb"
  },
  "mms_ipi": {
    "id": "mms_ipi",
    "language": [
      {
        "Iso Code": "ipi",
        "Language Name": "Ipili",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ipi"
  },
  "mms_irk": {
    "id": "mms_irk",
    "language": [
      {
        "Iso Code": "irk",
        "Language Name": "Iraqw",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/irk"
  },
  "mms_icr": {
    "id": "mms_icr",
    "language": [
      {
        "Iso Code": "icr",
        "Language Name": "Islander English Creole",
        "Country": "Saint Kitts and Nevis"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/icr"
  },
  "mms_itv": {
    "id": "mms_itv",
    "language": [
      {
        "Iso Code": "itv",
        "Language Name": "Itawit",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/itv"
  },
  "mms_itl": {
    "id": "mms_itl",
    "language": [
      {
        "Iso Code": "itl",
        "Language Name": "Itelmen",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/itl"
  },
  "mms_atg": {
    "id": "mms_atg",
    "language": [
      {
        "Iso Code": "atg",
        "Language Name": "Ivbie North-Okpela-Arhe",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/atg"
  },
  "mms_ixl-dialect_sanjuancotzal": {
    "id": "mms_ixl-dialect_sanjuancotzal",
    "language": [
      {
        "Iso Code": "sanjuancotzal",
        "Language Name": "Ixil",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ixl-dialect_sanjuancotzal"
  },
  "mms_ixl-dialect_sangasparchajul": {
    "id": "mms_ixl-dialect_sangasparchajul",
    "language": [
      {
        "Iso Code": "sangasparchajul",
        "Language Name": "Ixil",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ixl-dialect_sangasparchajul"
  },
  "mms_ixl-dialect_santamarianebaj": {
    "id": "mms_ixl-dialect_santamarianebaj",
    "language": [
      {
        "Iso Code": "santamarianebaj",
        "Language Name": "Ixil",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ixl-dialect_santamarianebaj"
  },
  "mms_nca": {
    "id": "mms_nca",
    "language": [
      {
        "Iso Code": "nca",
        "Language Name": "Iyo",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nca"
  },
  "mms_izr": {
    "id": "mms_izr",
    "language": [
      {
        "Iso Code": "izr",
        "Language Name": "Izere",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/izr"
  },
  "mms_izz": {
    "id": "mms_izz",
    "language": [
      {
        "Iso Code": "izz",
        "Language Name": "Izii",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/izz"
  },
  "mms_jac": {
    "id": "mms_jac",
    "language": [
      {
        "Iso Code": "jac",
        "Language Name": "Jakalteko",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jac"
  },
  "mms_jam": {
    "id": "mms_jam",
    "language": [
      {
        "Iso Code": "jam",
        "Language Name": "Jamaican English Creole",
        "Country": "Jamaica"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jam"
  },
  "mms_jav": {
    "id": "mms_jav",
    "language": [
      {
        "Iso Code": "jav",
        "Language Name": "Javanese",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jav"
  },
  "mms_jvn": {
    "id": "mms_jvn",
    "language": [
      {
        "Iso Code": "jvn",
        "Language Name": "Javanese, Suriname",
        "Country": "Suriname"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jvn"
  },
  "mms_kac": {
    "id": "mms_kac",
    "language": [
      {
        "Iso Code": "kac",
        "Language Name": "Jingpho",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kac"
  },
  "mms_dyo": {
    "id": "mms_dyo",
    "language": [
      {
        "Iso Code": "dyo",
        "Language Name": "Jola-Fonyi",
        "Country": "Senegal"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dyo"
  },
  "mms_csk": {
    "id": "mms_csk",
    "language": [
      {
        "Iso Code": "csk",
        "Language Name": "Jola-Kasa",
        "Country": "Senegal"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/csk"
  },
  "mms_adh": {
    "id": "mms_adh",
    "language": [
      {
        "Iso Code": "adh",
        "Language Name": "Jopadhola",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/adh"
  },
  "mms_jun": {
    "id": "mms_jun",
    "language": [
      {
        "Iso Code": "jun",
        "Language Name": "Juang",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jun"
  },
  "mms_jbu": {
    "id": "mms_jbu",
    "language": [
      {
        "Iso Code": "jbu",
        "Language Name": "Jukun Takum",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jbu"
  },
  "mms_dyu": {
    "id": "mms_dyu",
    "language": [
      {
        "Iso Code": "dyu",
        "Language Name": "Jula",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dyu"
  },
  "mms_bex": {
    "id": "mms_bex",
    "language": [
      {
        "Iso Code": "bex",
        "Language Name": "Jur Modo",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bex"
  },
  "mms_juy": {
    "id": "mms_juy",
    "language": [
      {
        "Iso Code": "juy",
        "Language Name": "Juray",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/juy"
  },
  "mms_gna": {
    "id": "mms_gna",
    "language": [
      {
        "Iso Code": "gna",
        "Language Name": "Kaansa",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gna"
  },
  "mms_urb": {
    "id": "mms_urb",
    "language": [
      {
        "Iso Code": "urb",
        "Language Name": "Kaapor",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/urb"
  },
  "mms_kbp": {
    "id": "mms_kbp",
    "language": [
      {
        "Iso Code": "kbp",
        "Language Name": "Kabiyè",
        "Country": "Togo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kbp"
  },
  "mms_cwa": {
    "id": "mms_cwa",
    "language": [
      {
        "Iso Code": "cwa",
        "Language Name": "Kabwa",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cwa"
  },
  "mms_dtp": {
    "id": "mms_dtp",
    "language": [
      {
        "Iso Code": "dtp",
        "Language Name": "Kadazan Dusun",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dtp"
  },
  "mms_kbr": {
    "id": "mms_kbr",
    "language": [
      {
        "Iso Code": "kbr",
        "Language Name": "Kafa",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kbr"
  },
  "mms_cgc": {
    "id": "mms_cgc",
    "language": [
      {
        "Iso Code": "cgc",
        "Language Name": "Kagayanen",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cgc"
  },
  "mms_kki": {
    "id": "mms_kki",
    "language": [
      {
        "Iso Code": "kki",
        "Language Name": "Kagulu",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kki"
  },
  "mms_kzf": {
    "id": "mms_kzf",
    "language": [
      {
        "Iso Code": "kzf",
        "Language Name": "Kaili, Da’a",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kzf"
  },
  "mms_lew": {
    "id": "mms_lew",
    "language": [
      {
        "Iso Code": "lew",
        "Language Name": "Kaili, Ledo",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lew"
  },
  "mms_cbr": {
    "id": "mms_cbr",
    "language": [
      {
        "Iso Code": "cbr",
        "Language Name": "Kakataibo-Kashibo",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cbr"
  },
  "mms_kkj": {
    "id": "mms_kkj",
    "language": [
      {
        "Iso Code": "kkj",
        "Language Name": "Kako",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kkj"
  },
  "mms_keo": {
    "id": "mms_keo",
    "language": [
      {
        "Iso Code": "keo",
        "Language Name": "Kakwa",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/keo"
  },
  "mms_kqe": {
    "id": "mms_kqe",
    "language": [
      {
        "Iso Code": "kqe",
        "Language Name": "Kalagan",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kqe"
  },
  "mms_kak": {
    "id": "mms_kak",
    "language": [
      {
        "Iso Code": "kak",
        "Language Name": "Kalanguya",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kak"
  },
  "mms_kyb": {
    "id": "mms_kyb",
    "language": [
      {
        "Iso Code": "kyb",
        "Language Name": "Kalinga, Butbut",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kyb"
  },
  "mms_knb": {
    "id": "mms_knb",
    "language": [
      {
        "Iso Code": "knb",
        "Language Name": "Kalinga, Lubuagan",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/knb"
  },
  "mms_kmd": {
    "id": "mms_kmd",
    "language": [
      {
        "Iso Code": "kmd",
        "Language Name": "Kalinga, Majukayang",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kmd"
  },
  "mms_kml": {
    "id": "mms_kml",
    "language": [
      {
        "Iso Code": "kml",
        "Language Name": "Kalinga, Tanudan",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kml"
  },
  "mms_ify": {
    "id": "mms_ify",
    "language": [
      {
        "Iso Code": "ify",
        "Language Name": "Kallahan, Keley-i",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ify"
  },
  "mms_xal": {
    "id": "mms_xal",
    "language": [
      {
        "Iso Code": "xal",
        "Language Name": "Kalmyk-Oirat",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xal"
  },
  "mms_kbq": {
    "id": "mms_kbq",
    "language": [
      {
        "Iso Code": "kbq",
        "Language Name": "Kamano",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kbq"
  },
  "mms_kay": {
    "id": "mms_kay",
    "language": [
      {
        "Iso Code": "kay",
        "Language Name": "Kamayurá",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kay"
  },
  "mms_ktb": {
    "id": "mms_ktb",
    "language": [
      {
        "Iso Code": "ktb",
        "Language Name": "Kambaata",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ktb"
  },
  "mms_hig": {
    "id": "mms_hig",
    "language": [
      {
        "Iso Code": "hig",
        "Language Name": "Kamwe",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hig"
  },
  "mms_gam": {
    "id": "mms_gam",
    "language": [
      {
        "Iso Code": "gam",
        "Language Name": "Kandawo",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gam"
  },
  "mms_cbu": {
    "id": "mms_cbu",
    "language": [
      {
        "Iso Code": "cbu",
        "Language Name": "Kandozi-Chapra",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cbu"
  },
  "mms_xnr": {
    "id": "mms_xnr",
    "language": [
      {
        "Iso Code": "xnr",
        "Language Name": "Kangri",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xnr"
  },
  "mms_kmu": {
    "id": "mms_kmu",
    "language": [
      {
        "Iso Code": "kmu",
        "Language Name": "Kanite",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kmu"
  },
  "mms_kne": {
    "id": "mms_kne",
    "language": [
      {
        "Iso Code": "kne",
        "Language Name": "Kankanaey",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kne"
  },
  "mms_kan": {
    "id": "mms_kan",
    "language": [
      {
        "Iso Code": "kan",
        "Language Name": "Kannada",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kan"
  },
  "mms_kby": {
    "id": "mms_kby",
    "language": [
      {
        "Iso Code": "kby",
        "Language Name": "Kanuri, Manga",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kby"
  },
  "mms_pam": {
    "id": "mms_pam",
    "language": [
      {
        "Iso Code": "pam",
        "Language Name": "Kapampangan",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pam"
  },
  "mms_cak-dialect_santamaríadejesús": {
    "id": "mms_cak-dialect_santamaríadejesús",
    "language": [
      {
        "Iso Code": "santamaríadejesús",
        "Language Name": "Kaqchikel",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cak-dialect_santamaríadejesús"
  },
  "mms_cak-dialect_southcentral": {
    "id": "mms_cak-dialect_southcentral",
    "language": [
      {
        "Iso Code": "southcentral",
        "Language Name": "Kaqchikel",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cak-dialect_southcentral"
  },
  "mms_cak-dialect_yepocapa": {
    "id": "mms_cak-dialect_yepocapa",
    "language": [
      {
        "Iso Code": "yepocapa",
        "Language Name": "Kaqchikel",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cak-dialect_yepocapa"
  },
  "mms_cak-dialect_western": {
    "id": "mms_cak-dialect_western",
    "language": [
      {
        "Iso Code": "western",
        "Language Name": "Kaqchikel",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cak-dialect_western"
  },
  "mms_cak-dialect_santodomingoxenacoj": {
    "id": "mms_cak-dialect_santodomingoxenacoj",
    "language": [
      {
        "Iso Code": "santodomingoxenacoj",
        "Language Name": "Kaqchikel",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cak-dialect_santodomingoxenacoj"
  },
  "mms_cak-dialect_central": {
    "id": "mms_cak-dialect_central",
    "language": [
      {
        "Iso Code": "central",
        "Language Name": "Kaqchikel",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cak-dialect_central"
  },
  "mms_xrb": {
    "id": "mms_xrb",
    "language": [
      {
        "Iso Code": "xrb",
        "Language Name": "Karaboro, Eastern",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xrb"
  },
  "mms_krc": {
    "id": "mms_krc",
    "language": [
      {
        "Iso Code": "krc",
        "Language Name": "Karachay-Balkar",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/krc"
  },
  "mms_kaa": {
    "id": "mms_kaa",
    "language": [
      {
        "Iso Code": "kaa",
        "Language Name": "Karakalpak",
        "Country": "Uzbekistan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kaa"
  },
  "mms_krl": {
    "id": "mms_krl",
    "language": [
      {
        "Iso Code": "krl",
        "Language Name": "Karelian",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/krl"
  },
  "mms_pww": {
    "id": "mms_pww",
    "language": [
      {
        "Iso Code": "pww",
        "Language Name": "Karen, Pwo Northern",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pww"
  },
  "mms_xsm": {
    "id": "mms_xsm",
    "language": [
      {
        "Iso Code": "xsm",
        "Language Name": "Kasem",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xsm"
  },
  "mms_cbs": {
    "id": "mms_cbs",
    "language": [
      {
        "Iso Code": "cbs",
        "Language Name": "Kashinawa",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cbs"
  },
  "mms_pss": {
    "id": "mms_pss",
    "language": [
      {
        "Iso Code": "pss",
        "Language Name": "Kaulong",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pss"
  },
  "mms_kxf": {
    "id": "mms_kxf",
    "language": [
      {
        "Iso Code": "kxf",
        "Language Name": "Kawyaw",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kxf"
  },
  "mms_kyz": {
    "id": "mms_kyz",
    "language": [
      {
        "Iso Code": "kyz",
        "Language Name": "Kayabí",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kyz"
  },
  "mms_kyu": {
    "id": "mms_kyu",
    "language": [
      {
        "Iso Code": "kyu",
        "Language Name": "Kayah, Western",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kyu"
  },
  "mms_txu": {
    "id": "mms_txu",
    "language": [
      {
        "Iso Code": "txu",
        "Language Name": "Kayapó",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/txu"
  },
  "mms_kaz": {
    "id": "mms_kaz",
    "language": [
      {
        "Iso Code": "kaz",
        "Language Name": "Kazakh",
        "Country": "Kazakhstan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kaz"
  },
  "mms_ndp": {
    "id": "mms_ndp",
    "language": [
      {
        "Iso Code": "ndp",
        "Language Name": "Kebu",
        "Country": "Togo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ndp"
  },
  "mms_kbo": {
    "id": "mms_kbo",
    "language": [
      {
        "Iso Code": "kbo",
        "Language Name": "Keliko",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kbo"
  },
  "mms_kyq": {
    "id": "mms_kyq",
    "language": [
      {
        "Iso Code": "kyq",
        "Language Name": "Kenga",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kyq"
  },
  "mms_ken": {
    "id": "mms_ken",
    "language": [
      {
        "Iso Code": "ken",
        "Language Name": "Kenyang",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ken"
  },
  "mms_ker": {
    "id": "mms_ker",
    "language": [
      {
        "Iso Code": "ker",
        "Language Name": "Kera",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ker"
  },
  "mms_xte": {
    "id": "mms_xte",
    "language": [
      {
        "Iso Code": "xte",
        "Language Name": "Ketengban",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xte"
  },
  "mms_kyg": {
    "id": "mms_kyg",
    "language": [
      {
        "Iso Code": "kyg",
        "Language Name": "Keyagana",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kyg"
  },
  "mms_kjh": {
    "id": "mms_kjh",
    "language": [
      {
        "Iso Code": "kjh",
        "Language Name": "Khakas",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kjh"
  },
  "mms_kca": {
    "id": "mms_kca",
    "language": [
      {
        "Iso Code": "kca",
        "Language Name": "Khanty",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kca"
  },
  "mms_khm": {
    "id": "mms_khm",
    "language": [
      {
        "Iso Code": "khm",
        "Language Name": "Khmer",
        "Country": "Cambodia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/khm"
  },
  "mms_kxm": {
    "id": "mms_kxm",
    "language": [
      {
        "Iso Code": "kxm",
        "Language Name": "Khmer, Northern",
        "Country": "Thailand"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kxm"
  },
  "mms_kjg": {
    "id": "mms_kjg",
    "language": [
      {
        "Iso Code": "kjg",
        "Language Name": "Khmu",
        "Country": "Laos"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kjg"
  },
  "mms_nyf": {
    "id": "mms_nyf",
    "language": [
      {
        "Iso Code": "nyf",
        "Language Name": "Kigiryama",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nyf"
  },
  "mms_kij": {
    "id": "mms_kij",
    "language": [
      {
        "Iso Code": "kij",
        "Language Name": "Kilivila",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kij"
  },
  "mms_kia": {
    "id": "mms_kia",
    "language": [
      {
        "Iso Code": "kia",
        "Language Name": "Kim",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kia"
  },
  "mms_kqr": {
    "id": "mms_kqr",
    "language": [
      {
        "Iso Code": "kqr",
        "Language Name": "Kimaragang",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kqr"
  },
  "mms_kqp": {
    "id": "mms_kqp",
    "language": [
      {
        "Iso Code": "kqp",
        "Language Name": "Kimré",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kqp"
  },
  "mms_krj": {
    "id": "mms_krj",
    "language": [
      {
        "Iso Code": "krj",
        "Language Name": "Kinaray-a",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/krj"
  },
  "mms_zga": {
    "id": "mms_zga",
    "language": [
      {
        "Iso Code": "zga",
        "Language Name": "Kinga",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zga"
  },
  "mms_kin": {
    "id": "mms_kin",
    "language": [
      {
        "Iso Code": "kin",
        "Language Name": "Kinyarwanda",
        "Country": "Rwanda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kin"
  },
  "mms_pkb": {
    "id": "mms_pkb",
    "language": [
      {
        "Iso Code": "pkb",
        "Language Name": "Kipfokomo",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pkb"
  },
  "mms_geb": {
    "id": "mms_geb",
    "language": [
      {
        "Iso Code": "geb",
        "Language Name": "Kire",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/geb"
  },
  "mms_gil": {
    "id": "mms_gil",
    "language": [
      {
        "Iso Code": "gil",
        "Language Name": "Kiribati",
        "Country": "Kiribati"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gil"
  },
  "mms_kje": {
    "id": "mms_kje",
    "language": [
      {
        "Iso Code": "kje",
        "Language Name": "Kisar",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kje"
  },
  "mms_kss": {
    "id": "mms_kss",
    "language": [
      {
        "Iso Code": "kss",
        "Language Name": "Kisi, Southern",
        "Country": "Sierra Leone"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kss"
  },
  "mms_thk": {
    "id": "mms_thk",
    "language": [
      {
        "Iso Code": "thk",
        "Language Name": "Kitharaka",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/thk"
  },
  "mms_klu": {
    "id": "mms_klu",
    "language": [
      {
        "Iso Code": "klu",
        "Language Name": "Klao",
        "Country": "Liberia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/klu"
  },
  "mms_kyo": {
    "id": "mms_kyo",
    "language": [
      {
        "Iso Code": "kyo",
        "Language Name": "Klon",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kyo"
  },
  "mms_kog": {
    "id": "mms_kog",
    "language": [
      {
        "Iso Code": "kog",
        "Language Name": "Kogi",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kog"
  },
  "mms_kfb": {
    "id": "mms_kfb",
    "language": [
      {
        "Iso Code": "kfb",
        "Language Name": "Kolami, Northwestern",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kfb"
  },
  "mms_kpv": {
    "id": "mms_kpv",
    "language": [
      {
        "Iso Code": "kpv",
        "Language Name": "Komi-Zyrian",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kpv"
  },
  "mms_bbo": {
    "id": "mms_bbo",
    "language": [
      {
        "Iso Code": "bbo",
        "Language Name": "Konabéré",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bbo"
  },
  "mms_xon": {
    "id": "mms_xon",
    "language": [
      {
        "Iso Code": "xon",
        "Language Name": "Konkomba",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xon"
  },
  "mms_kma": {
    "id": "mms_kma",
    "language": [
      {
        "Iso Code": "kma",
        "Language Name": "Konni",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kma"
  },
  "mms_kno": {
    "id": "mms_kno",
    "language": [
      {
        "Iso Code": "kno",
        "Language Name": "Kono",
        "Country": "Sierra Leone"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kno"
  },
  "mms_kxc": {
    "id": "mms_kxc",
    "language": [
      {
        "Iso Code": "kxc",
        "Language Name": "Konso",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kxc"
  },
  "mms_ozm": {
    "id": "mms_ozm",
    "language": [
      {
        "Iso Code": "ozm",
        "Language Name": "Koonzime",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ozm"
  },
  "mms_kqy": {
    "id": "mms_kqy",
    "language": [
      {
        "Iso Code": "kqy",
        "Language Name": "Koorete",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kqy"
  },
  "mms_kor": {
    "id": "mms_kor",
    "language": [
      {
        "Iso Code": "kor",
        "Language Name": "Korean",
        "Country": "South Korea"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": false,
    "Sample Exists": false,
    "url": "Not available"
  },
  "mms_coe": {
    "id": "mms_coe",
    "language": [
      {
        "Iso Code": "coe",
        "Language Name": "Koreguaje",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/coe"
  },
  "mms_kpq": {
    "id": "mms_kpq",
    "language": [
      {
        "Iso Code": "kpq",
        "Language Name": "Korupun-Sela",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kpq"
  },
  "mms_kpy": {
    "id": "mms_kpy",
    "language": [
      {
        "Iso Code": "kpy",
        "Language Name": "Koryak",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kpy"
  },
  "mms_kyf": {
    "id": "mms_kyf",
    "language": [
      {
        "Iso Code": "kyf",
        "Language Name": "Kouya",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kyf"
  },
  "mms_kff-script_telugu": {
    "id": "mms_kff-script_telugu",
    "language": [
      {
        "Iso Code": "telugu",
        "Language Name": "Koya",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kff-script_telugu"
  },
  "mms_kri": {
    "id": "mms_kri",
    "language": [
      {
        "Iso Code": "kri",
        "Language Name": "Krio",
        "Country": "Sierra Leone"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kri"
  },
  "mms_rop": {
    "id": "mms_rop",
    "language": [
      {
        "Iso Code": "rop",
        "Language Name": "Kriol",
        "Country": "Australia"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rop"
  },
  "mms_ktj": {
    "id": "mms_ktj",
    "language": [
      {
        "Iso Code": "ktj",
        "Language Name": "Krumen, Plapo",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ktj"
  },
  "mms_ted": {
    "id": "mms_ted",
    "language": [
      {
        "Iso Code": "ted",
        "Language Name": "Krumen, Tepo",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ted"
  },
  "mms_krr": {
    "id": "mms_krr",
    "language": [
      {
        "Iso Code": "krr",
        "Language Name": "Krung",
        "Country": "Cambodia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/krr"
  },
  "mms_kdt": {
    "id": "mms_kdt",
    "language": [
      {
        "Iso Code": "kdt",
        "Language Name": "Kuay",
        "Country": "Laos"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kdt"
  },
  "mms_kez": {
    "id": "mms_kez",
    "language": [
      {
        "Iso Code": "kez",
        "Language Name": "Kukele",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kez"
  },
  "mms_cul": {
    "id": "mms_cul",
    "language": [
      {
        "Iso Code": "cul",
        "Language Name": "Kulina",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cul"
  },
  "mms_kle": {
    "id": "mms_kle",
    "language": [
      {
        "Iso Code": "kle",
        "Language Name": "Kulung",
        "Country": "Nepal"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kle"
  },
  "mms_kdi": {
    "id": "mms_kdi",
    "language": [
      {
        "Iso Code": "kdi",
        "Language Name": "Kumam",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kdi"
  },
  "mms_kue": {
    "id": "mms_kue",
    "language": [
      {
        "Iso Code": "kue",
        "Language Name": "Kuman",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kue"
  },
  "mms_kum": {
    "id": "mms_kum",
    "language": [
      {
        "Iso Code": "kum",
        "Language Name": "Kumyk",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kum"
  },
  "mms_kvn": {
    "id": "mms_kvn",
    "language": [
      {
        "Iso Code": "kvn",
        "Language Name": "Kuna, Border",
        "Country": "Panama"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kvn"
  },
  "mms_cuk": {
    "id": "mms_cuk",
    "language": [
      {
        "Iso Code": "cuk",
        "Language Name": "Kuna, San Blas",
        "Country": "Panama"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cuk"
  },
  "mms_kdn": {
    "id": "mms_kdn",
    "language": [
      {
        "Iso Code": "kdn",
        "Language Name": "Kunda",
        "Country": "Zambia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kdn"
  },
  "mms_xuo": {
    "id": "mms_xuo",
    "language": [
      {
        "Iso Code": "xuo",
        "Language Name": "Kuo",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xuo"
  },
  "mms_key": {
    "id": "mms_key",
    "language": [
      {
        "Iso Code": "key",
        "Language Name": "Kupia",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/key"
  },
  "mms_kpz": {
    "id": "mms_kpz",
    "language": [
      {
        "Iso Code": "kpz",
        "Language Name": "Kupsapiiny",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kpz"
  },
  "mms_knk": {
    "id": "mms_knk",
    "language": [
      {
        "Iso Code": "knk",
        "Language Name": "Kuranko",
        "Country": "Sierra Leone"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/knk"
  },
  "mms_kmr-script_latin": {
    "id": "mms_kmr-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Kurdish, Northern",
        "Country": "Turkey"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kmr-script_latin"
  },
  "mms_kmr-script_arabic": {
    "id": "mms_kmr-script_arabic",
    "language": [
      {
        "Iso Code": "arabic",
        "Language Name": "Kurdish, Northern",
        "Country": "Turkey"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kmr-script_arabic"
  },
  "mms_kmr-script_cyrillic": {
    "id": "mms_kmr-script_cyrillic",
    "language": [
      {
        "Iso Code": "cyrillic",
        "Language Name": "Kurdish, Northern",
        "Country": "Turkey"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kmr-script_cyrillic"
  },
  "mms_xua": {
    "id": "mms_xua",
    "language": [
      {
        "Iso Code": "xua",
        "Language Name": "Kurumba, Alu",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xua"
  },
  "mms_kru": {
    "id": "mms_kru",
    "language": [
      {
        "Iso Code": "kru",
        "Language Name": "Kurux",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kru"
  },
  "mms_kus": {
    "id": "mms_kus",
    "language": [
      {
        "Iso Code": "kus",
        "Language Name": "Kusaal",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kus"
  },
  "mms_kub": {
    "id": "mms_kub",
    "language": [
      {
        "Iso Code": "kub",
        "Language Name": "Kutep",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kub"
  },
  "mms_kdc": {
    "id": "mms_kdc",
    "language": [
      {
        "Iso Code": "kdc",
        "Language Name": "Kutu",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kdc"
  },
  "mms_kxv": {
    "id": "mms_kxv",
    "language": [
      {
        "Iso Code": "kxv",
        "Language Name": "Kuvi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kxv"
  },
  "mms_blh": {
    "id": "mms_blh",
    "language": [
      {
        "Iso Code": "blh",
        "Language Name": "Kuwaa",
        "Country": "Liberia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/blh"
  },
  "mms_cwt": {
    "id": "mms_cwt",
    "language": [
      {
        "Iso Code": "cwt",
        "Language Name": "Kuwaataay",
        "Country": "Senegal"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cwt"
  },
  "mms_kwd": {
    "id": "mms_kwd",
    "language": [
      {
        "Iso Code": "kwd",
        "Language Name": "Kwaio",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kwd"
  },
  "mms_tnk": {
    "id": "mms_tnk",
    "language": [
      {
        "Iso Code": "tnk",
        "Language Name": "Kwamera",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tnk"
  },
  "mms_kwf": {
    "id": "mms_kwf",
    "language": [
      {
        "Iso Code": "kwf",
        "Language Name": "Kwara’ae",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kwf"
  },
  "mms_cwe": {
    "id": "mms_cwe",
    "language": [
      {
        "Iso Code": "cwe",
        "Language Name": "Kwere",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cwe"
  },
  "mms_kyc": {
    "id": "mms_kyc",
    "language": [
      {
        "Iso Code": "kyc",
        "Language Name": "Kyaka",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kyc"
  },
  "mms_tye": {
    "id": "mms_tye",
    "language": [
      {
        "Iso Code": "tye",
        "Language Name": "Kyanga",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tye"
  },
  "mms_kir": {
    "id": "mms_kir",
    "language": [
      {
        "Iso Code": "kir",
        "Language Name": "Kyrgyz",
        "Country": "Kyrgyzstan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kir"
  },
  "mms_quc-dialect_north": {
    "id": "mms_quc-dialect_north",
    "language": [
      {
        "Iso Code": "north",
        "Language Name": "K’iche’",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/quc-dialect_north"
  },
  "mms_quc-dialect_east": {
    "id": "mms_quc-dialect_east",
    "language": [
      {
        "Iso Code": "east",
        "Language Name": "K’iche’",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/quc-dialect_east"
  },
  "mms_quc-dialect_central": {
    "id": "mms_quc-dialect_central",
    "language": [
      {
        "Iso Code": "central",
        "Language Name": "K’iche’",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/quc-dialect_central"
  },
  "mms_lac": {
    "id": "mms_lac",
    "language": [
      {
        "Iso Code": "lac",
        "Language Name": "Lacandon",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lac"
  },
  "mms_lsi": {
    "id": "mms_lsi",
    "language": [
      {
        "Iso Code": "lsi",
        "Language Name": "Lacid",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lsi"
  },
  "mms_lbj": {
    "id": "mms_lbj",
    "language": [
      {
        "Iso Code": "lbj",
        "Language Name": "Ladakhi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lbj"
  },
  "mms_lhu": {
    "id": "mms_lhu",
    "language": [
      {
        "Iso Code": "lhu",
        "Language Name": "Lahu",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lhu"
  },
  "mms_las": {
    "id": "mms_las",
    "language": [
      {
        "Iso Code": "las",
        "Language Name": "Lama",
        "Country": "Togo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/las"
  },
  "mms_lam": {
    "id": "mms_lam",
    "language": [
      {
        "Iso Code": "lam",
        "Language Name": "Lamba",
        "Country": "Zambia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lam"
  },
  "mms_lns": {
    "id": "mms_lns",
    "language": [
      {
        "Iso Code": "lns",
        "Language Name": "Lamnso’",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lns"
  },
  "mms_ljp": {
    "id": "mms_ljp",
    "language": [
      {
        "Iso Code": "ljp",
        "Language Name": "Lampung Api",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ljp"
  },
  "mms_laj": {
    "id": "mms_laj",
    "language": [
      {
        "Iso Code": "laj",
        "Language Name": "Lango",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/laj"
  },
  "mms_lao": {
    "id": "mms_lao",
    "language": [
      {
        "Iso Code": "lao",
        "Language Name": "Lao",
        "Country": "Laos"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lao"
  },
  "mms_lat": {
    "id": "mms_lat",
    "language": [
      {
        "Iso Code": "lat",
        "Language Name": "Latin",
        "Country": "Vatican City"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lat"
  },
  "mms_lav": {
    "id": "mms_lav",
    "language": [
      {
        "Iso Code": "lav",
        "Language Name": "Latvian",
        "Country": "Latvia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lav"
  },
  "mms_law": {
    "id": "mms_law",
    "language": [
      {
        "Iso Code": "law",
        "Language Name": "Lauje",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/law"
  },
  "mms_lcp": {
    "id": "mms_lcp",
    "language": [
      {
        "Iso Code": "lcp",
        "Language Name": "Lawa, Western",
        "Country": "Thailand"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lcp"
  },
  "mms_lzz": {
    "id": "mms_lzz",
    "language": [
      {
        "Iso Code": "lzz",
        "Language Name": "Laz",
        "Country": "Turkey"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lzz"
  },
  "mms_lln": {
    "id": "mms_lln",
    "language": [
      {
        "Iso Code": "lln",
        "Language Name": "Lele",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lln"
  },
  "mms_lef": {
    "id": "mms_lef",
    "language": [
      {
        "Iso Code": "lef",
        "Language Name": "Lelemi",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lef"
  },
  "mms_acf": {
    "id": "mms_acf",
    "language": [
      {
        "Iso Code": "acf",
        "Language Name": "Lesser Antillean French Creole",
        "Country": "Saint Lucia"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/acf"
  },
  "mms_lww": {
    "id": "mms_lww",
    "language": [
      {
        "Iso Code": "lww",
        "Language Name": "Lewo",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lww"
  },
  "mms_mhx": {
    "id": "mms_mhx",
    "language": [
      {
        "Iso Code": "mhx",
        "Language Name": "Lhao Vo",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mhx"
  },
  "mms_eip": {
    "id": "mms_eip",
    "language": [
      {
        "Iso Code": "eip",
        "Language Name": "Lik",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/eip"
  },
  "mms_lia": {
    "id": "mms_lia",
    "language": [
      {
        "Iso Code": "lia",
        "Language Name": "Limba, West-Central",
        "Country": "Sierra Leone"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lia"
  },
  "mms_lif": {
    "id": "mms_lif",
    "language": [
      {
        "Iso Code": "lif",
        "Language Name": "Limbu",
        "Country": "Nepal"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lif"
  },
  "mms_onb": {
    "id": "mms_onb",
    "language": [
      {
        "Iso Code": "onb",
        "Language Name": "Lingao",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/onb"
  },
  "mms_lis": {
    "id": "mms_lis",
    "language": [
      {
        "Iso Code": "lis",
        "Language Name": "Lisu",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lis"
  },
  "mms_loq": {
    "id": "mms_loq",
    "language": [
      {
        "Iso Code": "loq",
        "Language Name": "Lobala",
        "Country": "Democratic Republic of the Congo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/loq"
  },
  "mms_lob": {
    "id": "mms_lob",
    "language": [
      {
        "Iso Code": "lob",
        "Language Name": "Lobi",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lob"
  },
  "mms_yaz": {
    "id": "mms_yaz",
    "language": [
      {
        "Iso Code": "yaz",
        "Language Name": "Lokaa",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yaz"
  },
  "mms_lok": {
    "id": "mms_lok",
    "language": [
      {
        "Iso Code": "lok",
        "Language Name": "Loko",
        "Country": "Sierra Leone"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lok"
  },
  "mms_llg": {
    "id": "mms_llg",
    "language": [
      {
        "Iso Code": "llg",
        "Language Name": "Lole",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/llg"
  },
  "mms_ycl": {
    "id": "mms_ycl",
    "language": [
      {
        "Iso Code": "ycl",
        "Language Name": "Lolopo",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ycl"
  },
  "mms_lom": {
    "id": "mms_lom",
    "language": [
      {
        "Iso Code": "lom",
        "Language Name": "Loma",
        "Country": "Liberia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lom"
  },
  "mms_ngl": {
    "id": "mms_ngl",
    "language": [
      {
        "Iso Code": "ngl",
        "Language Name": "Lomwe",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ngl"
  },
  "mms_lon": {
    "id": "mms_lon",
    "language": [
      {
        "Iso Code": "lon",
        "Language Name": "Lomwe, Malawi",
        "Country": "Malawi"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lon"
  },
  "mms_lex": {
    "id": "mms_lex",
    "language": [
      {
        "Iso Code": "lex",
        "Language Name": "Luang",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lex"
  },
  "mms_lgg": {
    "id": "mms_lgg",
    "language": [
      {
        "Iso Code": "lgg",
        "Language Name": "Lugbara",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lgg"
  },
  "mms_ruf": {
    "id": "mms_ruf",
    "language": [
      {
        "Iso Code": "ruf",
        "Language Name": "Luguru",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ruf"
  },
  "mms_dop": {
    "id": "mms_dop",
    "language": [
      {
        "Iso Code": "dop",
        "Language Name": "Lukpa",
        "Country": "Benin"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dop"
  },
  "mms_lnd": {
    "id": "mms_lnd",
    "language": [
      {
        "Iso Code": "lnd",
        "Language Name": "Lundayeh",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lnd"
  },
  "mms_ndy": {
    "id": "mms_ndy",
    "language": [
      {
        "Iso Code": "ndy",
        "Language Name": "Lutos",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ndy"
  },
  "mms_lwo": {
    "id": "mms_lwo",
    "language": [
      {
        "Iso Code": "lwo",
        "Language Name": "Luwo",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lwo"
  },
  "mms_lee": {
    "id": "mms_lee",
    "language": [
      {
        "Iso Code": "lee",
        "Language Name": "Lyélé",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lee"
  },
  "mms_mev": {
    "id": "mms_mev",
    "language": [
      {
        "Iso Code": "mev",
        "Language Name": "Maan",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mev"
  },
  "mms_mfz": {
    "id": "mms_mfz",
    "language": [
      {
        "Iso Code": "mfz",
        "Language Name": "Mabaan",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mfz"
  },
  "mms_jmc": {
    "id": "mms_jmc",
    "language": [
      {
        "Iso Code": "jmc",
        "Language Name": "Machame",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jmc"
  },
  "mms_myy": {
    "id": "mms_myy",
    "language": [
      {
        "Iso Code": "myy",
        "Language Name": "Macuna",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/myy"
  },
  "mms_mbc": {
    "id": "mms_mbc",
    "language": [
      {
        "Iso Code": "mbc",
        "Language Name": "Macushi",
        "Country": "Guyana"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mbc"
  },
  "mms_mda": {
    "id": "mms_mda",
    "language": [
      {
        "Iso Code": "mda",
        "Language Name": "Mada",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mda"
  },
  "mms_mad": {
    "id": "mms_mad",
    "language": [
      {
        "Iso Code": "mad",
        "Language Name": "Madura",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mad"
  },
  "mms_mag": {
    "id": "mms_mag",
    "language": [
      {
        "Iso Code": "mag",
        "Language Name": "Magahi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mag"
  },
  "mms_ayz": {
    "id": "mms_ayz",
    "language": [
      {
        "Iso Code": "ayz",
        "Language Name": "Mai Brat",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ayz"
  },
  "mms_mai": {
    "id": "mms_mai",
    "language": [
      {
        "Iso Code": "mai",
        "Language Name": "Maithili",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mai"
  },
  "mms_mca": {
    "id": "mms_mca",
    "language": [
      {
        "Iso Code": "mca",
        "Language Name": "Maka",
        "Country": "Paraguay"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mca"
  },
  "mms_mcp": {
    "id": "mms_mcp",
    "language": [
      {
        "Iso Code": "mcp",
        "Language Name": "Makaa",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mcp"
  },
  "mms_mak": {
    "id": "mms_mak",
    "language": [
      {
        "Iso Code": "mak",
        "Language Name": "Makasar",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mak"
  },
  "mms_vmw": {
    "id": "mms_vmw",
    "language": [
      {
        "Iso Code": "vmw",
        "Language Name": "Makhuwa",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/vmw"
  },
  "mms_mgh": {
    "id": "mms_mgh",
    "language": [
      {
        "Iso Code": "mgh",
        "Language Name": "Makhuwa-Meetto",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mgh"
  },
  "mms_kde": {
    "id": "mms_kde",
    "language": [
      {
        "Iso Code": "kde",
        "Language Name": "Makonde",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kde"
  },
  "mms_mlg": {
    "id": "mms_mlg",
    "language": [
      {
        "Iso Code": "mlg",
        "Language Name": "Malagasy",
        "Country": "Madagascar"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mlg"
  },
  "mms_zlm": {
    "id": "mms_zlm",
    "language": [
      {
        "Iso Code": "zlm",
        "Language Name": "Malay",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zlm"
  },
  "mms_pse": {
    "id": "mms_pse",
    "language": [
      {
        "Iso Code": "pse",
        "Language Name": "Malay, Central",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pse"
  },
  "mms_mkn": {
    "id": "mms_mkn",
    "language": [
      {
        "Iso Code": "mkn",
        "Language Name": "Malay, Kupang",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mkn"
  },
  "mms_xmm": {
    "id": "mms_xmm",
    "language": [
      {
        "Iso Code": "xmm",
        "Language Name": "Malay, Manado",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xmm"
  },
  "mms_mal": {
    "id": "mms_mal",
    "language": [
      {
        "Iso Code": "mal",
        "Language Name": "Malayalam",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mal"
  },
  "mms_xdy": {
    "id": "mms_xdy",
    "language": [
      {
        "Iso Code": "xdy",
        "Language Name": "Malayic Dayak",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xdy"
  },
  "mms_div": {
    "id": "mms_div",
    "language": [
      {
        "Iso Code": "div",
        "Language Name": "Maldivian",
        "Country": "Maldives"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/div"
  },
  "mms_mdy": {
    "id": "mms_mdy",
    "language": [
      {
        "Iso Code": "mdy",
        "Language Name": "Male",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mdy"
  },
  "mms_mup": {
    "id": "mms_mup",
    "language": [
      {
        "Iso Code": "mup",
        "Language Name": "Malvi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mup"
  },
  "mms_mam-dialect_central": {
    "id": "mms_mam-dialect_central",
    "language": [
      {
        "Iso Code": "central",
        "Language Name": "Mam",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mam-dialect_central"
  },
  "mms_mam-dialect_northern": {
    "id": "mms_mam-dialect_northern",
    "language": [
      {
        "Iso Code": "northern",
        "Language Name": "Mam",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mam-dialect_northern"
  },
  "mms_mam-dialect_southern": {
    "id": "mms_mam-dialect_southern",
    "language": [
      {
        "Iso Code": "southern",
        "Language Name": "Mam",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mam-dialect_southern"
  },
  "mms_mam-dialect_western": {
    "id": "mms_mam-dialect_western",
    "language": [
      {
        "Iso Code": "western",
        "Language Name": "Mam",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mam-dialect_western"
  },
  "mms_mqj": {
    "id": "mms_mqj",
    "language": [
      {
        "Iso Code": "mqj",
        "Language Name": "Mamasa",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mqj"
  },
  "mms_mcu": {
    "id": "mms_mcu",
    "language": [
      {
        "Iso Code": "mcu",
        "Language Name": "Mambila, Cameroon",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mcu"
  },
  "mms_mzk": {
    "id": "mms_mzk",
    "language": [
      {
        "Iso Code": "mzk",
        "Language Name": "Mambila, Nigeria",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mzk"
  },
  "mms_maw": {
    "id": "mms_maw",
    "language": [
      {
        "Iso Code": "maw",
        "Language Name": "Mampruli",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/maw"
  },
  "mms_mjl": {
    "id": "mms_mjl",
    "language": [
      {
        "Iso Code": "mjl",
        "Language Name": "Mandeali",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mjl"
  },
  "mms_mnk": {
    "id": "mms_mnk",
    "language": [
      {
        "Iso Code": "mnk",
        "Language Name": "Mandinka",
        "Country": "Senegal"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mnk"
  },
  "mms_mge": {
    "id": "mms_mge",
    "language": [
      {
        "Iso Code": "mge",
        "Language Name": "Mango",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mge"
  },
  "mms_mbh": {
    "id": "mms_mbh",
    "language": [
      {
        "Iso Code": "mbh",
        "Language Name": "Mangseng",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mbh"
  },
  "mms_knf": {
    "id": "mms_knf",
    "language": [
      {
        "Iso Code": "knf",
        "Language Name": "Mankanya",
        "Country": "Guinea-Bissau"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/knf"
  },
  "mms_mjv": {
    "id": "mms_mjv",
    "language": [
      {
        "Iso Code": "mjv",
        "Language Name": "Mannan",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mjv"
  },
  "mms_mbt": {
    "id": "mms_mbt",
    "language": [
      {
        "Iso Code": "mbt",
        "Language Name": "Manobo, Matigsalug",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mbt"
  },
  "mms_obo": {
    "id": "mms_obo",
    "language": [
      {
        "Iso Code": "obo",
        "Language Name": "Manobo, Obo",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/obo"
  },
  "mms_mbb": {
    "id": "mms_mbb",
    "language": [
      {
        "Iso Code": "mbb",
        "Language Name": "Manobo, Western Bukidnon",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mbb"
  },
  "mms_mzj": {
    "id": "mms_mzj",
    "language": [
      {
        "Iso Code": "mzj",
        "Language Name": "Manya",
        "Country": "Liberia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mzj"
  },
  "mms_sjm": {
    "id": "mms_sjm",
    "language": [
      {
        "Iso Code": "sjm",
        "Language Name": "Mapun",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sjm"
  },
  "mms_mrw": {
    "id": "mms_mrw",
    "language": [
      {
        "Iso Code": "mrw",
        "Language Name": "Maranao",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mrw"
  },
  "mms_mar": {
    "id": "mms_mar",
    "language": [
      {
        "Iso Code": "mar",
        "Language Name": "Marathi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mar"
  },
  "mms_mpg": {
    "id": "mms_mpg",
    "language": [
      {
        "Iso Code": "mpg",
        "Language Name": "Marba",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mpg"
  },
  "mms_mhr": {
    "id": "mms_mhr",
    "language": [
      {
        "Iso Code": "mhr",
        "Language Name": "Mari, Meadow",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mhr"
  },
  "mms_enb": {
    "id": "mms_enb",
    "language": [
      {
        "Iso Code": "enb",
        "Language Name": "Markweeta",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/enb"
  },
  "mms_mah": {
    "id": "mms_mah",
    "language": [
      {
        "Iso Code": "mah",
        "Language Name": "Marshallese",
        "Country": "Marshall Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mah"
  },
  "mms_myx": {
    "id": "mms_myx",
    "language": [
      {
        "Iso Code": "myx",
        "Language Name": "Masaaba",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/myx"
  },
  "mms_klv": {
    "id": "mms_klv",
    "language": [
      {
        "Iso Code": "klv",
        "Language Name": "Maskelynes",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/klv"
  },
  "mms_mfh": {
    "id": "mms_mfh",
    "language": [
      {
        "Iso Code": "mfh",
        "Language Name": "Matal",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mfh"
  },
  "mms_met": {
    "id": "mms_met",
    "language": [
      {
        "Iso Code": "met",
        "Language Name": "Mato",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/met"
  },
  "mms_mcb": {
    "id": "mms_mcb",
    "language": [
      {
        "Iso Code": "mcb",
        "Language Name": "Matsigenka",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mcb"
  },
  "mms_mop": {
    "id": "mms_mop",
    "language": [
      {
        "Iso Code": "mop",
        "Language Name": "Maya, Mopán",
        "Country": "Belize"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mop"
  },
  "mms_yua": {
    "id": "mms_yua",
    "language": [
      {
        "Iso Code": "yua",
        "Language Name": "Maya, Yucatec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yua"
  },
  "mms_mfy": {
    "id": "mms_mfy",
    "language": [
      {
        "Iso Code": "mfy",
        "Language Name": "Mayo",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mfy"
  },
  "mms_maz": {
    "id": "mms_maz",
    "language": [
      {
        "Iso Code": "maz",
        "Language Name": "Mazahua, Central",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/maz"
  },
  "mms_vmy": {
    "id": "mms_vmy",
    "language": [
      {
        "Iso Code": "vmy",
        "Language Name": "Mazatec, Ayautla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/vmy"
  },
  "mms_maq": {
    "id": "mms_maq",
    "language": [
      {
        "Iso Code": "maq",
        "Language Name": "Mazatec, Chiquihuitlán",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/maq"
  },
  "mms_mzi": {
    "id": "mms_mzi",
    "language": [
      {
        "Iso Code": "mzi",
        "Language Name": "Mazatec, Ixcatlán",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mzi"
  },
  "mms_maj": {
    "id": "mms_maj",
    "language": [
      {
        "Iso Code": "maj",
        "Language Name": "Mazatec, Jalapa de Díaz",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/maj"
  },
  "mms_maa-dialect_sanantonio": {
    "id": "mms_maa-dialect_sanantonio",
    "language": [
      {
        "Iso Code": "sanantonio",
        "Language Name": "Mazatec, San Jerónimo Tecóatl",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/maa-dialect_sanantonio"
  },
  "mms_maa-dialect_sanjerónimo": {
    "id": "mms_maa-dialect_sanjerónimo",
    "language": [
      {
        "Iso Code": "sanjerónimo",
        "Language Name": "Mazatec, San Jerónimo Tecóatl",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/maa-dialect_sanjerónimo"
  },
  "mms_mhy": {
    "id": "mms_mhy",
    "language": [
      {
        "Iso Code": "mhy",
        "Language Name": "Ma’anyan",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mhy"
  },
  "mms_mhi": {
    "id": "mms_mhi",
    "language": [
      {
        "Iso Code": "mhi",
        "Language Name": "Ma’di",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mhi"
  },
  "mms_zmz": {
    "id": "mms_zmz",
    "language": [
      {
        "Iso Code": "zmz",
        "Language Name": "Mbandja",
        "Country": "Central African Republic"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zmz"
  },
  "mms_myb": {
    "id": "mms_myb",
    "language": [
      {
        "Iso Code": "myb",
        "Language Name": "Mbay",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/myb"
  },
  "mms_gai": {
    "id": "mms_gai",
    "language": [
      {
        "Iso Code": "gai",
        "Language Name": "Mbore",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gai"
  },
  "mms_mqb": {
    "id": "mms_mqb",
    "language": [
      {
        "Iso Code": "mqb",
        "Language Name": "Mbuko",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mqb"
  },
  "mms_mbu": {
    "id": "mms_mbu",
    "language": [
      {
        "Iso Code": "mbu",
        "Language Name": "Mbula-Bwazza",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mbu"
  },
  "mms_med": {
    "id": "mms_med",
    "language": [
      {
        "Iso Code": "med",
        "Language Name": "Melpa",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/med"
  },
  "mms_men": {
    "id": "mms_men",
    "language": [
      {
        "Iso Code": "men",
        "Language Name": "Mende",
        "Country": "Sierra Leone"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/men"
  },
  "mms_mee": {
    "id": "mms_mee",
    "language": [
      {
        "Iso Code": "mee",
        "Language Name": "Mengen",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mee"
  },
  "mms_mwv": {
    "id": "mms_mwv",
    "language": [
      {
        "Iso Code": "mwv",
        "Language Name": "Mentawai",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mwv"
  },
  "mms_meq": {
    "id": "mms_meq",
    "language": [
      {
        "Iso Code": "meq",
        "Language Name": "Merey",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/meq"
  },
  "mms_zim": {
    "id": "mms_zim",
    "language": [
      {
        "Iso Code": "zim",
        "Language Name": "Mesme",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zim"
  },
  "mms_mgo": {
    "id": "mms_mgo",
    "language": [
      {
        "Iso Code": "mgo",
        "Language Name": "Meta’",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mgo"
  },
  "mms_mej": {
    "id": "mms_mej",
    "language": [
      {
        "Iso Code": "mej",
        "Language Name": "Meyah",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mej"
  },
  "mms_mpp": {
    "id": "mms_mpp",
    "language": [
      {
        "Iso Code": "mpp",
        "Language Name": "Migabac",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mpp"
  },
  "mms_min": {
    "id": "mms_min",
    "language": [
      {
        "Iso Code": "min",
        "Language Name": "Minangkabau",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/min"
  },
  "mms_gum": {
    "id": "mms_gum",
    "language": [
      {
        "Iso Code": "gum",
        "Language Name": "Misak",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gum"
  },
  "mms_mpx": {
    "id": "mms_mpx",
    "language": [
      {
        "Iso Code": "mpx",
        "Language Name": "Misima-Panaeati",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mpx"
  },
  "mms_mco": {
    "id": "mms_mco",
    "language": [
      {
        "Iso Code": "mco",
        "Language Name": "Mixe, Coatlán",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mco"
  },
  "mms_mxq": {
    "id": "mms_mxq",
    "language": [
      {
        "Iso Code": "mxq",
        "Language Name": "Mixe, Juquila",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mxq"
  },
  "mms_pxm": {
    "id": "mms_pxm",
    "language": [
      {
        "Iso Code": "pxm",
        "Language Name": "Mixe, Quetzaltepec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pxm"
  },
  "mms_mto": {
    "id": "mms_mto",
    "language": [
      {
        "Iso Code": "mto",
        "Language Name": "Mixe, Totontepec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mto"
  },
  "mms_mim": {
    "id": "mms_mim",
    "language": [
      {
        "Iso Code": "mim",
        "Language Name": "Mixtec, Alacatlatzala",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mim"
  },
  "mms_xta": {
    "id": "mms_xta",
    "language": [
      {
        "Iso Code": "xta",
        "Language Name": "Mixtec, Alcozauca",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xta"
  },
  "mms_mbz": {
    "id": "mms_mbz",
    "language": [
      {
        "Iso Code": "mbz",
        "Language Name": "Mixtec, Amoltepec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mbz"
  },
  "mms_mip": {
    "id": "mms_mip",
    "language": [
      {
        "Iso Code": "mip",
        "Language Name": "Mixtec, Apasco-Apoala",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mip"
  },
  "mms_mib": {
    "id": "mms_mib",
    "language": [
      {
        "Iso Code": "mib",
        "Language Name": "Mixtec, Atatlahuca",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mib"
  },
  "mms_miy": {
    "id": "mms_miy",
    "language": [
      {
        "Iso Code": "miy",
        "Language Name": "Mixtec, Ayutla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/miy"
  },
  "mms_mih": {
    "id": "mms_mih",
    "language": [
      {
        "Iso Code": "mih",
        "Language Name": "Mixtec, Chayuco",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mih"
  },
  "mms_miz": {
    "id": "mms_miz",
    "language": [
      {
        "Iso Code": "miz",
        "Language Name": "Mixtec, Coatzospan",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/miz"
  },
  "mms_xtd": {
    "id": "mms_xtd",
    "language": [
      {
        "Iso Code": "xtd",
        "Language Name": "Mixtec, Diuxi-Tilantongo",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xtd"
  },
  "mms_mxt": {
    "id": "mms_mxt",
    "language": [
      {
        "Iso Code": "mxt",
        "Language Name": "Mixtec, Jamiltepec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mxt"
  },
  "mms_xtm": {
    "id": "mms_xtm",
    "language": [
      {
        "Iso Code": "xtm",
        "Language Name": "Mixtec, Magdalena Peñasco",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xtm"
  },
  "mms_mxv": {
    "id": "mms_mxv",
    "language": [
      {
        "Iso Code": "mxv",
        "Language Name": "Mixtec, Metlatónoc",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mxv"
  },
  "mms_xtn": {
    "id": "mms_xtn",
    "language": [
      {
        "Iso Code": "xtn",
        "Language Name": "Mixtec, Northern Tlaxiaco",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xtn"
  },
  "mms_mie": {
    "id": "mms_mie",
    "language": [
      {
        "Iso Code": "mie",
        "Language Name": "Mixtec, Ocotepec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mie"
  },
  "mms_mil": {
    "id": "mms_mil",
    "language": [
      {
        "Iso Code": "mil",
        "Language Name": "Mixtec, Peñoles",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mil"
  },
  "mms_mio": {
    "id": "mms_mio",
    "language": [
      {
        "Iso Code": "mio",
        "Language Name": "Mixtec, Pinotepa Nacional",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mio"
  },
  "mms_mdv": {
    "id": "mms_mdv",
    "language": [
      {
        "Iso Code": "mdv",
        "Language Name": "Mixtec, Santa Lucía Monteverde",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mdv"
  },
  "mms_mza": {
    "id": "mms_mza",
    "language": [
      {
        "Iso Code": "mza",
        "Language Name": "Mixtec, Santa María Zacatepec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mza"
  },
  "mms_mit": {
    "id": "mms_mit",
    "language": [
      {
        "Iso Code": "mit",
        "Language Name": "Mixtec, Southern Puebla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mit"
  },
  "mms_mxb": {
    "id": "mms_mxb",
    "language": [
      {
        "Iso Code": "mxb",
        "Language Name": "Mixtec, Tezoatlán",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mxb"
  },
  "mms_mpm": {
    "id": "mms_mpm",
    "language": [
      {
        "Iso Code": "mpm",
        "Language Name": "Mixtec, Yosondúa",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mpm"
  },
  "mms_soy": {
    "id": "mms_soy",
    "language": [
      {
        "Iso Code": "soy",
        "Language Name": "Miyobe",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/soy"
  },
  "mms_cmo-script_latin": {
    "id": "mms_cmo-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Mnong, Central",
        "Country": "Vietnam"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cmo-script_latin"
  },
  "mms_cmo-script_khmer": {
    "id": "mms_cmo-script_khmer",
    "language": [
      {
        "Iso Code": "khmer",
        "Language Name": "Mnong, Central",
        "Country": "Vietnam"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cmo-script_khmer"
  },
  "mms_mfq": {
    "id": "mms_mfq",
    "language": [
      {
        "Iso Code": "mfq",
        "Language Name": "Moba",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mfq"
  },
  "mms_old": {
    "id": "mms_old",
    "language": [
      {
        "Iso Code": "old",
        "Language Name": "Mochi",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/old"
  },
  "mms_mfk": {
    "id": "mms_mfk",
    "language": [
      {
        "Iso Code": "mfk",
        "Language Name": "Mofu, North",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mfk"
  },
  "mms_mif": {
    "id": "mms_mif",
    "language": [
      {
        "Iso Code": "mif",
        "Language Name": "Mofu-Gudur",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mif"
  },
  "mms_mkl": {
    "id": "mms_mkl",
    "language": [
      {
        "Iso Code": "mkl",
        "Language Name": "Mokole",
        "Country": "Guinea"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mkl"
  },
  "mms_mox": {
    "id": "mms_mox",
    "language": [
      {
        "Iso Code": "mox",
        "Language Name": "Molima",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mox"
  },
  "mms_myl": {
    "id": "mms_myl",
    "language": [
      {
        "Iso Code": "myl",
        "Language Name": "Moma",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/myl"
  },
  "mms_mqf": {
    "id": "mms_mqf",
    "language": [
      {
        "Iso Code": "mqf",
        "Language Name": "Momuna",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mqf"
  },
  "mms_mnw": {
    "id": "mms_mnw",
    "language": [
      {
        "Iso Code": "mnw",
        "Language Name": "Mon",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mnw"
  },
  "mms_mon": {
    "id": "mms_mon",
    "language": [
      {
        "Iso Code": "mon",
        "Language Name": "Mongolian",
        "Country": "Mongolia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mon"
  },
  "mms_mog": {
    "id": "mms_mog",
    "language": [
      {
        "Iso Code": "mog",
        "Language Name": "Mongondow",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mog"
  },
  "mms_mfe": {
    "id": "mms_mfe",
    "language": [
      {
        "Iso Code": "mfe",
        "Language Name": "Morisyen",
        "Country": "Mauritius"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mfe"
  },
  "mms_mor": {
    "id": "mms_mor",
    "language": [
      {
        "Iso Code": "mor",
        "Language Name": "Moro",
        "Country": "Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mor"
  },
  "mms_mqn": {
    "id": "mms_mqn",
    "language": [
      {
        "Iso Code": "mqn",
        "Language Name": "Moronene",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mqn"
  },
  "mms_mgd": {
    "id": "mms_mgd",
    "language": [
      {
        "Iso Code": "mgd",
        "Language Name": "Moru",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mgd"
  },
  "mms_mtj": {
    "id": "mms_mtj",
    "language": [
      {
        "Iso Code": "mtj",
        "Language Name": "Moskona",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mtj"
  },
  "mms_cmr": {
    "id": "mms_cmr",
    "language": [
      {
        "Iso Code": "cmr",
        "Language Name": "Mro-Khimi",
        "Country": "Bangladesh"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cmr"
  },
  "mms_mtd": {
    "id": "mms_mtd",
    "language": [
      {
        "Iso Code": "mtd",
        "Language Name": "Mualang",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mtd"
  },
  "mms_bmr": {
    "id": "mms_bmr",
    "language": [
      {
        "Iso Code": "bmr",
        "Language Name": "Muinane",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bmr"
  },
  "mms_moz": {
    "id": "mms_moz",
    "language": [
      {
        "Iso Code": "moz",
        "Language Name": "Mukulu",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/moz"
  },
  "mms_mzm": {
    "id": "mms_mzm",
    "language": [
      {
        "Iso Code": "mzm",
        "Language Name": "Mumuye",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mzm"
  },
  "mms_mnb": {
    "id": "mms_mnb",
    "language": [
      {
        "Iso Code": "mnb",
        "Language Name": "Muna",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mnb"
  },
  "mms_mnf": {
    "id": "mms_mnf",
    "language": [
      {
        "Iso Code": "mnf",
        "Language Name": "Mundani",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mnf"
  },
  "mms_unr": {
    "id": "mms_unr",
    "language": [
      {
        "Iso Code": "unr",
        "Language Name": "Mundari",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/unr"
  },
  "mms_fmu": {
    "id": "mms_fmu",
    "language": [
      {
        "Iso Code": "fmu",
        "Language Name": "Muria, Far Western",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/fmu"
  },
  "mms_mur": {
    "id": "mms_mur",
    "language": [
      {
        "Iso Code": "mur",
        "Language Name": "Murle",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mur"
  },
  "mms_tih": {
    "id": "mms_tih",
    "language": [
      {
        "Iso Code": "tih",
        "Language Name": "Murut, Timugon",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tih"
  },
  "mms_muv": {
    "id": "mms_muv",
    "language": [
      {
        "Iso Code": "muv",
        "Language Name": "Muthuvan",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/muv"
  },
  "mms_muy": {
    "id": "mms_muy",
    "language": [
      {
        "Iso Code": "muy",
        "Language Name": "Muyang",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/muy"
  },
  "mms_sur": {
    "id": "mms_sur",
    "language": [
      {
        "Iso Code": "sur",
        "Language Name": "Mwaghavul",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sur"
  },
  "mms_moa": {
    "id": "mms_moa",
    "language": [
      {
        "Iso Code": "moa",
        "Language Name": "Mwan",
        "Country": "Congo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/moa"
  },
  "mms_wmw": {
    "id": "mms_wmw",
    "language": [
      {
        "Iso Code": "wmw",
        "Language Name": "Mwani",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wmw"
  },
  "mms_tnr": {
    "id": "mms_tnr",
    "language": [
      {
        "Iso Code": "tnr",
        "Language Name": "Ménik",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tnr"
  },
  "mms_miq": {
    "id": "mms_miq",
    "language": [
      {
        "Iso Code": "miq",
        "Language Name": "Mískito",
        "Country": "Honduras"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/miq"
  },
  "mms_mos": {
    "id": "mms_mos",
    "language": [
      {
        "Iso Code": "mos",
        "Language Name": "Mòoré",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mos"
  },
  "mms_muh": {
    "id": "mms_muh",
    "language": [
      {
        "Iso Code": "muh",
        "Language Name": "Mündü",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/muh"
  },
  "mms_nas": {
    "id": "mms_nas",
    "language": [
      {
        "Iso Code": "nas",
        "Language Name": "Naasioi",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nas"
  },
  "mms_mbj": {
    "id": "mms_mbj",
    "language": [
      {
        "Iso Code": "mbj",
        "Language Name": "Nadëb",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mbj"
  },
  "mms_nfr": {
    "id": "mms_nfr",
    "language": [
      {
        "Iso Code": "nfr",
        "Language Name": "Nafaanra",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nfr"
  },
  "mms_kfw": {
    "id": "mms_kfw",
    "language": [
      {
        "Iso Code": "kfw",
        "Language Name": "Naga, Kharam",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kfw"
  },
  "mms_nst": {
    "id": "mms_nst",
    "language": [
      {
        "Iso Code": "nst",
        "Language Name": "Naga, Tangshang",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nst"
  },
  "mms_nag": {
    "id": "mms_nag",
    "language": [
      {
        "Iso Code": "nag",
        "Language Name": "Nagamese",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nag"
  },
  "mms_nch": {
    "id": "mms_nch",
    "language": [
      {
        "Iso Code": "nch",
        "Language Name": "Nahuatl, Central Huasteca",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nch"
  },
  "mms_nhe": {
    "id": "mms_nhe",
    "language": [
      {
        "Iso Code": "nhe",
        "Language Name": "Nahuatl, Eastern Huasteca",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nhe"
  },
  "mms_ngu": {
    "id": "mms_ngu",
    "language": [
      {
        "Iso Code": "ngu",
        "Language Name": "Nahuatl, Guerrero",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ngu"
  },
  "mms_azz": {
    "id": "mms_azz",
    "language": [
      {
        "Iso Code": "azz",
        "Language Name": "Nahuatl, Highland Puebla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/azz"
  },
  "mms_nhx": {
    "id": "mms_nhx",
    "language": [
      {
        "Iso Code": "nhx",
        "Language Name": "Nahuatl, Isthmus-Mecayapan",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nhx"
  },
  "mms_ncl": {
    "id": "mms_ncl",
    "language": [
      {
        "Iso Code": "ncl",
        "Language Name": "Nahuatl, Michoacán",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ncl"
  },
  "mms_nhy": {
    "id": "mms_nhy",
    "language": [
      {
        "Iso Code": "nhy",
        "Language Name": "Nahuatl, Northern Oaxaca",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nhy"
  },
  "mms_ncj": {
    "id": "mms_ncj",
    "language": [
      {
        "Iso Code": "ncj",
        "Language Name": "Nahuatl, Northern Puebla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ncj"
  },
  "mms_nsu": {
    "id": "mms_nsu",
    "language": [
      {
        "Iso Code": "nsu",
        "Language Name": "Nahuatl, Sierra Negra",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nsu"
  },
  "mms_npl": {
    "id": "mms_npl",
    "language": [
      {
        "Iso Code": "npl",
        "Language Name": "Nahuatl, Southeastern Puebla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/npl"
  },
  "mms_nuz": {
    "id": "mms_nuz",
    "language": [
      {
        "Iso Code": "nuz",
        "Language Name": "Nahuatl, Tlamacazapa",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nuz"
  },
  "mms_nhw": {
    "id": "mms_nhw",
    "language": [
      {
        "Iso Code": "nhw",
        "Language Name": "Nahuatl, Western Huasteca",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nhw"
  },
  "mms_nhi": {
    "id": "mms_nhi",
    "language": [
      {
        "Iso Code": "nhi",
        "Language Name": "Nahuatl, Zacatlán-Ahuacatlán-Tepetzintla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nhi"
  },
  "mms_nlc": {
    "id": "mms_nlc",
    "language": [
      {
        "Iso Code": "nlc",
        "Language Name": "Nalca",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nlc"
  },
  "mms_nab": {
    "id": "mms_nab",
    "language": [
      {
        "Iso Code": "nab",
        "Language Name": "Nambikuára, Southern",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nab"
  },
  "mms_gld": {
    "id": "mms_gld",
    "language": [
      {
        "Iso Code": "gld",
        "Language Name": "Nanai",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gld"
  },
  "mms_nnb": {
    "id": "mms_nnb",
    "language": [
      {
        "Iso Code": "nnb",
        "Language Name": "Nande",
        "Country": "Democratic Republic of the Congo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nnb"
  },
  "mms_npy": {
    "id": "mms_npy",
    "language": [
      {
        "Iso Code": "npy",
        "Language Name": "Napu",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/npy"
  },
  "mms_pbb": {
    "id": "mms_pbb",
    "language": [
      {
        "Iso Code": "pbb",
        "Language Name": "Nasa",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pbb"
  },
  "mms_ntm": {
    "id": "mms_ntm",
    "language": [
      {
        "Iso Code": "ntm",
        "Language Name": "Nateni",
        "Country": "Benin"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ntm"
  },
  "mms_nmz": {
    "id": "mms_nmz",
    "language": [
      {
        "Iso Code": "nmz",
        "Language Name": "Nawdm",
        "Country": "Togo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nmz"
  },
  "mms_naw": {
    "id": "mms_naw",
    "language": [
      {
        "Iso Code": "naw",
        "Language Name": "Nawuri",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/naw"
  },
  "mms_nxq": {
    "id": "mms_nxq",
    "language": [
      {
        "Iso Code": "nxq",
        "Language Name": "Naxi",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nxq"
  },
  "mms_ndj": {
    "id": "mms_ndj",
    "language": [
      {
        "Iso Code": "ndj",
        "Language Name": "Ndamba",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ndj"
  },
  "mms_ndz": {
    "id": "mms_ndz",
    "language": [
      {
        "Iso Code": "ndz",
        "Language Name": "Ndogo",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ndz"
  },
  "mms_ndv": {
    "id": "mms_ndv",
    "language": [
      {
        "Iso Code": "ndv",
        "Language Name": "Ndut",
        "Country": "Senegal"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ndv"
  },
  "mms_new": {
    "id": "mms_new",
    "language": [
      {
        "Iso Code": "new",
        "Language Name": "Newar",
        "Country": "Nepal"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/new"
  },
  "mms_nij": {
    "id": "mms_nij",
    "language": [
      {
        "Iso Code": "nij",
        "Language Name": "Ngaju",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nij"
  },
  "mms_sba": {
    "id": "mms_sba",
    "language": [
      {
        "Iso Code": "sba",
        "Language Name": "Ngambay",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sba"
  },
  "mms_gng": {
    "id": "mms_gng",
    "language": [
      {
        "Iso Code": "gng",
        "Language Name": "Ngangam",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gng"
  },
  "mms_nga": {
    "id": "mms_nga",
    "language": [
      {
        "Iso Code": "nga",
        "Language Name": "Ngbaka",
        "Country": "Central African Republic"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nga"
  },
  "mms_nnq": {
    "id": "mms_nnq",
    "language": [
      {
        "Iso Code": "nnq",
        "Language Name": "Ngindo",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nnq"
  },
  "mms_ngp": {
    "id": "mms_ngp",
    "language": [
      {
        "Iso Code": "ngp",
        "Language Name": "Ngulu",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ngp"
  },
  "mms_gym": {
    "id": "mms_gym",
    "language": [
      {
        "Iso Code": "gym",
        "Language Name": "Ngäbere",
        "Country": "Panama"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gym"
  },
  "mms_kdj": {
    "id": "mms_kdj",
    "language": [
      {
        "Iso Code": "kdj",
        "Language Name": "Ng’akarimojong",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kdj"
  },
  "mms_nia": {
    "id": "mms_nia",
    "language": [
      {
        "Iso Code": "nia",
        "Language Name": "Nias",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nia"
  },
  "mms_nim": {
    "id": "mms_nim",
    "language": [
      {
        "Iso Code": "nim",
        "Language Name": "Nilamba",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nim"
  },
  "mms_nin": {
    "id": "mms_nin",
    "language": [
      {
        "Iso Code": "nin",
        "Language Name": "Ninzo",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nin"
  },
  "mms_nko": {
    "id": "mms_nko",
    "language": [
      {
        "Iso Code": "nko",
        "Language Name": "Nkonya",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nko"
  },
  "mms_nog": {
    "id": "mms_nog",
    "language": [
      {
        "Iso Code": "nog",
        "Language Name": "Nogai",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nog"
  },
  "mms_lem": {
    "id": "mms_lem",
    "language": [
      {
        "Iso Code": "lem",
        "Language Name": "Nomaande",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lem"
  },
  "mms_not": {
    "id": "mms_not",
    "language": [
      {
        "Iso Code": "not",
        "Language Name": "Nomatsigenga",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/not"
  },
  "mms_nhu": {
    "id": "mms_nhu",
    "language": [
      {
        "Iso Code": "nhu",
        "Language Name": "Noone",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nhu"
  },
  "mms_bud": {
    "id": "mms_bud",
    "language": [
      {
        "Iso Code": "bud",
        "Language Name": "Ntcham",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bud"
  },
  "mms_nus": {
    "id": "mms_nus",
    "language": [
      {
        "Iso Code": "nus",
        "Language Name": "Nuer",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nus"
  },
  "mms_yas": {
    "id": "mms_yas",
    "language": [
      {
        "Iso Code": "yas",
        "Language Name": "Nugunu",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yas"
  },
  "mms_nnw": {
    "id": "mms_nnw",
    "language": [
      {
        "Iso Code": "nnw",
        "Language Name": "Nuni, Southern",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nnw"
  },
  "mms_nwb": {
    "id": "mms_nwb",
    "language": [
      {
        "Iso Code": "nwb",
        "Language Name": "Nyabwa",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nwb"
  },
  "mms_nyy": {
    "id": "mms_nyy",
    "language": [
      {
        "Iso Code": "nyy",
        "Language Name": "Nyakyusa-Ngonde",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nyy"
  },
  "mms_nyn": {
    "id": "mms_nyn",
    "language": [
      {
        "Iso Code": "nyn",
        "Language Name": "Nyankore",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nyn"
  },
  "mms_rim": {
    "id": "mms_rim",
    "language": [
      {
        "Iso Code": "rim",
        "Language Name": "Nyaturu",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rim"
  },
  "mms_lid": {
    "id": "mms_lid",
    "language": [
      {
        "Iso Code": "lid",
        "Language Name": "Nyindrou",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lid"
  },
  "mms_nuj": {
    "id": "mms_nuj",
    "language": [
      {
        "Iso Code": "nuj",
        "Language Name": "Nyole",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nuj"
  },
  "mms_nyo": {
    "id": "mms_nyo",
    "language": [
      {
        "Iso Code": "nyo",
        "Language Name": "Nyoro",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nyo"
  },
  "mms_nzi": {
    "id": "mms_nzi",
    "language": [
      {
        "Iso Code": "nzi",
        "Language Name": "Nzema",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nzi"
  },
  "mms_ann": {
    "id": "mms_ann",
    "language": [
      {
        "Iso Code": "ann",
        "Language Name": "Obolo",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ann"
  },
  "mms_ory": {
    "id": "mms_ory",
    "language": [
      {
        "Iso Code": "ory",
        "Language Name": "Odia",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ory"
  },
  "mms_ojb-script_latin": {
    "id": "mms_ojb-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Ojibwa, Northwestern",
        "Country": "Canada"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ojb-script_latin"
  },
  "mms_ojb-script_syllabics": {
    "id": "mms_ojb-script_syllabics",
    "language": [
      {
        "Iso Code": "syllabics",
        "Language Name": "Ojibwa, Northwestern",
        "Country": "Canada"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ojb-script_syllabics"
  },
  "mms_oku": {
    "id": "mms_oku",
    "language": [
      {
        "Iso Code": "oku",
        "Language Name": "Oku",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/oku"
  },
  "mms_bsc": {
    "id": "mms_bsc",
    "language": [
      {
        "Iso Code": "bsc",
        "Language Name": "Oniyan",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bsc"
  },
  "mms_bdu": {
    "id": "mms_bdu",
    "language": [
      {
        "Iso Code": "bdu",
        "Language Name": "Oroko",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bdu"
  },
  "mms_orm": {
    "id": "mms_orm",
    "language": [
      {
        "Iso Code": "orm",
        "Language Name": "Oromo",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/orm"
  },
  "mms_ury": {
    "id": "mms_ury",
    "language": [
      {
        "Iso Code": "ury",
        "Language Name": "Orya",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ury"
  },
  "mms_oss": {
    "id": "mms_oss",
    "language": [
      {
        "Iso Code": "oss",
        "Language Name": "Ossetic",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/oss"
  },
  "mms_ote": {
    "id": "mms_ote",
    "language": [
      {
        "Iso Code": "ote",
        "Language Name": "Otomi, Mezquital",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ote"
  },
  "mms_otq": {
    "id": "mms_otq",
    "language": [
      {
        "Iso Code": "otq",
        "Language Name": "Otomi, Querétaro",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/otq"
  },
  "mms_stn": {
    "id": "mms_stn",
    "language": [
      {
        "Iso Code": "stn",
        "Language Name": "Owa",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/stn"
  },
  "mms_sig": {
    "id": "mms_sig",
    "language": [
      {
        "Iso Code": "sig",
        "Language Name": "Paasaal",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sig"
  },
  "mms_kfx": {
    "id": "mms_kfx",
    "language": [
      {
        "Iso Code": "kfx",
        "Language Name": "Pahari, Kullu",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kfx"
  },
  "mms_bfz": {
    "id": "mms_bfz",
    "language": [
      {
        "Iso Code": "bfz",
        "Language Name": "Pahari, Mahasu",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bfz"
  },
  "mms_sey": {
    "id": "mms_sey",
    "language": [
      {
        "Iso Code": "sey",
        "Language Name": "Paicoca",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sey"
  },
  "mms_pao": {
    "id": "mms_pao",
    "language": [
      {
        "Iso Code": "pao",
        "Language Name": "Paiute, Northern",
        "Country": "United States"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pao"
  },
  "mms_pau": {
    "id": "mms_pau",
    "language": [
      {
        "Iso Code": "pau",
        "Language Name": "Palauan",
        "Country": "Palau"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pau"
  },
  "mms_pce": {
    "id": "mms_pce",
    "language": [
      {
        "Iso Code": "pce",
        "Language Name": "Palaung, Ruching",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pce"
  },
  "mms_plw": {
    "id": "mms_plw",
    "language": [
      {
        "Iso Code": "plw",
        "Language Name": "Palawano, Brooke’s Point",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/plw"
  },
  "mms_pmf": {
    "id": "mms_pmf",
    "language": [
      {
        "Iso Code": "pmf",
        "Language Name": "Pamona",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pmf"
  },
  "mms_pag": {
    "id": "mms_pag",
    "language": [
      {
        "Iso Code": "pag",
        "Language Name": "Pangasinan",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pag"
  },
  "mms_pap": {
    "id": "mms_pap",
    "language": [
      {
        "Iso Code": "pap",
        "Language Name": "Papiamentu",
        "Country": "Netherlands"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pap"
  },
  "mms_prf": {
    "id": "mms_prf",
    "language": [
      {
        "Iso Code": "prf",
        "Language Name": "Paranan",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/prf"
  },
  "mms_pab": {
    "id": "mms_pab",
    "language": [
      {
        "Iso Code": "pab",
        "Language Name": "Parecís",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pab"
  },
  "mms_pbi": {
    "id": "mms_pbi",
    "language": [
      {
        "Iso Code": "pbi",
        "Language Name": "Parkwa",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pbi"
  },
  "mms_pbc": {
    "id": "mms_pbc",
    "language": [
      {
        "Iso Code": "pbc",
        "Language Name": "Patamona",
        "Country": "Guyana"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pbc"
  },
  "mms_pad": {
    "id": "mms_pad",
    "language": [
      {
        "Iso Code": "pad",
        "Language Name": "Paumarí",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pad"
  },
  "mms_ata": {
    "id": "mms_ata",
    "language": [
      {
        "Iso Code": "ata",
        "Language Name": "Pele-Ata",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ata"
  },
  "mms_pez": {
    "id": "mms_pez",
    "language": [
      {
        "Iso Code": "pez",
        "Language Name": "Penan, Eastern",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pez"
  },
  "mms_peg": {
    "id": "mms_peg",
    "language": [
      {
        "Iso Code": "peg",
        "Language Name": "Pengo",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/peg"
  },
  "mms_fas": {
    "id": "mms_fas",
    "language": [
      {
        "Iso Code": "fas",
        "Language Name": "Persian",
        "Country": "Iran"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/fas"
  },
  "mms_pcm": {
    "id": "mms_pcm",
    "language": [
      {
        "Iso Code": "pcm",
        "Language Name": "Pidgin, Nigerian",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pcm"
  },
  "mms_pis": {
    "id": "mms_pis",
    "language": [
      {
        "Iso Code": "pis",
        "Language Name": "Pijin",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pis"
  },
  "mms_pny": {
    "id": "mms_pny",
    "language": [
      {
        "Iso Code": "pny",
        "Language Name": "Pinyin",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pny"
  },
  "mms_pir": {
    "id": "mms_pir",
    "language": [
      {
        "Iso Code": "pir",
        "Language Name": "Piratapuyo",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pir"
  },
  "mms_pjt": {
    "id": "mms_pjt",
    "language": [
      {
        "Iso Code": "pjt",
        "Language Name": "Pitjantjatjara",
        "Country": "Australia"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pjt"
  },
  "mms_poy": {
    "id": "mms_poy",
    "language": [
      {
        "Iso Code": "poy",
        "Language Name": "Pogolo",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/poy"
  },
  "mms_pol": {
    "id": "mms_pol",
    "language": [
      {
        "Iso Code": "pol",
        "Language Name": "Polish",
        "Country": "Poland"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pol"
  },
  "mms_pps": {
    "id": "mms_pps",
    "language": [
      {
        "Iso Code": "pps",
        "Language Name": "Popoloca, San Luís Temalacayuca",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pps"
  },
  "mms_pls": {
    "id": "mms_pls",
    "language": [
      {
        "Iso Code": "pls",
        "Language Name": "Popoloca, San Marcos Tlacoyalco",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pls"
  },
  "mms_poi": {
    "id": "mms_poi",
    "language": [
      {
        "Iso Code": "poi",
        "Language Name": "Popoluca, Highland",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/poi"
  },
  "mms_poh-dialect_eastern": {
    "id": "mms_poh-dialect_eastern",
    "language": [
      {
        "Iso Code": "eastern",
        "Language Name": "Poqomchi’",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/poh-dialect_eastern"
  },
  "mms_poh-dialect_western": {
    "id": "mms_poh-dialect_western",
    "language": [
      {
        "Iso Code": "western",
        "Language Name": "Poqomchi’",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/poh-dialect_western"
  },
  "mms_por": {
    "id": "mms_por",
    "language": [
      {
        "Iso Code": "por",
        "Language Name": "Portuguese",
        "Country": "Portugal"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/por"
  },
  "mms_prt": {
    "id": "mms_prt",
    "language": [
      {
        "Iso Code": "prt",
        "Language Name": "Prai",
        "Country": "Laos"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/prt"
  },
  "mms_pui": {
    "id": "mms_pui",
    "language": [
      {
        "Iso Code": "pui",
        "Language Name": "Puinave",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pui"
  },
  "mms_pan": {
    "id": "mms_pan",
    "language": [
      {
        "Iso Code": "pan",
        "Language Name": "Punjabi, Eastern",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pan"
  },
  "mms_tsz": {
    "id": "mms_tsz",
    "language": [
      {
        "Iso Code": "tsz",
        "Language Name": "Purepecha",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tsz"
  },
  "mms_suv": {
    "id": "mms_suv",
    "language": [
      {
        "Iso Code": "suv",
        "Language Name": "Puroik",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/suv"
  },
  "mms_lme": {
    "id": "mms_lme",
    "language": [
      {
        "Iso Code": "lme",
        "Language Name": "Pévé",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lme"
  },
  "mms_quy": {
    "id": "mms_quy",
    "language": [
      {
        "Iso Code": "quy",
        "Language Name": "Quechua, Ayacucho",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/quy"
  },
  "mms_qvc": {
    "id": "mms_qvc",
    "language": [
      {
        "Iso Code": "qvc",
        "Language Name": "Quechua, Cajamarca",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qvc"
  },
  "mms_quz": {
    "id": "mms_quz",
    "language": [
      {
        "Iso Code": "quz",
        "Language Name": "Quechua, Cusco",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/quz"
  },
  "mms_qve": {
    "id": "mms_qve",
    "language": [
      {
        "Iso Code": "qve",
        "Language Name": "Quechua, Eastern Apurímac",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qve"
  },
  "mms_qub": {
    "id": "mms_qub",
    "language": [
      {
        "Iso Code": "qub",
        "Language Name": "Quechua, Huallaga",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qub"
  },
  "mms_qvh": {
    "id": "mms_qvh",
    "language": [
      {
        "Iso Code": "qvh",
        "Language Name": "Quechua, Huamalíes-Dos de Mayo Huánuco",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qvh"
  },
  "mms_qwh": {
    "id": "mms_qwh",
    "language": [
      {
        "Iso Code": "qwh",
        "Language Name": "Quechua, Huaylas Ancash",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qwh"
  },
  "mms_qvw": {
    "id": "mms_qvw",
    "language": [
      {
        "Iso Code": "qvw",
        "Language Name": "Quechua, Huaylla Wanca",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qvw"
  },
  "mms_quf": {
    "id": "mms_quf",
    "language": [
      {
        "Iso Code": "quf",
        "Language Name": "Quechua, Lambayeque",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/quf"
  },
  "mms_qvm": {
    "id": "mms_qvm",
    "language": [
      {
        "Iso Code": "qvm",
        "Language Name": "Quechua, Margos-Yarowilca-Lauricocha",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qvm"
  },
  "mms_qul": {
    "id": "mms_qul",
    "language": [
      {
        "Iso Code": "qul",
        "Language Name": "Quechua, North Bolivian",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qul"
  },
  "mms_qvn": {
    "id": "mms_qvn",
    "language": [
      {
        "Iso Code": "qvn",
        "Language Name": "Quechua, North Junín",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qvn"
  },
  "mms_qxn": {
    "id": "mms_qxn",
    "language": [
      {
        "Iso Code": "qxn",
        "Language Name": "Quechua, Northern Conchucos Ancash",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qxn"
  },
  "mms_qxh": {
    "id": "mms_qxh",
    "language": [
      {
        "Iso Code": "qxh",
        "Language Name": "Quechua, Panao",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qxh"
  },
  "mms_qvs": {
    "id": "mms_qvs",
    "language": [
      {
        "Iso Code": "qvs",
        "Language Name": "Quechua, San Martín",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qvs"
  },
  "mms_quh": {
    "id": "mms_quh",
    "language": [
      {
        "Iso Code": "quh",
        "Language Name": "Quechua, South Bolivian",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/quh"
  },
  "mms_qxo": {
    "id": "mms_qxo",
    "language": [
      {
        "Iso Code": "qxo",
        "Language Name": "Quechua, Southern Conchucos",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qxo"
  },
  "mms_qxr": {
    "id": "mms_qxr",
    "language": [
      {
        "Iso Code": "qxr",
        "Language Name": "Quichua, Cañar Highland",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qxr"
  },
  "mms_qvo": {
    "id": "mms_qvo",
    "language": [
      {
        "Iso Code": "qvo",
        "Language Name": "Quichua, Napo",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qvo"
  },
  "mms_qvz": {
    "id": "mms_qvz",
    "language": [
      {
        "Iso Code": "qvz",
        "Language Name": "Quichua, Northern Pastaza",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qvz"
  },
  "mms_qxl": {
    "id": "mms_qxl",
    "language": [
      {
        "Iso Code": "qxl",
        "Language Name": "Quichua, Salasaca Highland",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/qxl"
  },
  "mms_quw": {
    "id": "mms_quw",
    "language": [
      {
        "Iso Code": "quw",
        "Language Name": "Quichua, Tena Lowland",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/quw"
  },
  "mms_kjb": {
    "id": "mms_kjb",
    "language": [
      {
        "Iso Code": "kjb",
        "Language Name": "Q’anjob’al",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kjb"
  },
  "mms_kek": {
    "id": "mms_kek",
    "language": [
      {
        "Iso Code": "kek",
        "Language Name": "Q’eqchi’",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kek"
  },
  "mms_rah": {
    "id": "mms_rah",
    "language": [
      {
        "Iso Code": "rah",
        "Language Name": "Rabha",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rah"
  },
  "mms_rjs": {
    "id": "mms_rjs",
    "language": [
      {
        "Iso Code": "rjs",
        "Language Name": "Rajbanshi",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rjs"
  },
  "mms_rai": {
    "id": "mms_rai",
    "language": [
      {
        "Iso Code": "rai",
        "Language Name": "Ramoaaina",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rai"
  },
  "mms_lje": {
    "id": "mms_lje",
    "language": [
      {
        "Iso Code": "lje",
        "Language Name": "Rampi",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lje"
  },
  "mms_rnl": {
    "id": "mms_rnl",
    "language": [
      {
        "Iso Code": "rnl",
        "Language Name": "Ranglong",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rnl"
  },
  "mms_rkt": {
    "id": "mms_rkt",
    "language": [
      {
        "Iso Code": "rkt",
        "Language Name": "Rangpuri",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rkt"
  },
  "mms_rap": {
    "id": "mms_rap",
    "language": [
      {
        "Iso Code": "rap",
        "Language Name": "Rapa Nui",
        "Country": "Chile"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rap"
  },
  "mms_yea": {
    "id": "mms_yea",
    "language": [
      {
        "Iso Code": "yea",
        "Language Name": "Ravula",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yea"
  },
  "mms_raw": {
    "id": "mms_raw",
    "language": [
      {
        "Iso Code": "raw",
        "Language Name": "Rawang",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/raw"
  },
  "mms_rej": {
    "id": "mms_rej",
    "language": [
      {
        "Iso Code": "rej",
        "Language Name": "Rejang",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rej"
  },
  "mms_rel": {
    "id": "mms_rel",
    "language": [
      {
        "Iso Code": "rel",
        "Language Name": "Rendille",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rel"
  },
  "mms_ril": {
    "id": "mms_ril",
    "language": [
      {
        "Iso Code": "ril",
        "Language Name": "Riang Lang",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ril"
  },
  "mms_iri": {
    "id": "mms_iri",
    "language": [
      {
        "Iso Code": "iri",
        "Language Name": "Rigwe",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/iri"
  },
  "mms_rgu": {
    "id": "mms_rgu",
    "language": [
      {
        "Iso Code": "rgu",
        "Language Name": "Rikou",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rgu"
  },
  "mms_rhg": {
    "id": "mms_rhg",
    "language": [
      {
        "Iso Code": "rhg",
        "Language Name": "Rohingya",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rhg"
  },
  "mms_rmc-script_latin": {
    "id": "mms_rmc-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Romani, Carpathian",
        "Country": "Ukraine"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rmc-script_latin"
  },
  "mms_rmc-script_cyrillic": {
    "id": "mms_rmc-script_cyrillic",
    "language": [
      {
        "Iso Code": "cyrillic",
        "Language Name": "Romani, Carpathian",
        "Country": "Ukraine"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rmc-script_cyrillic"
  },
  "mms_rmo": {
    "id": "mms_rmo",
    "language": [
      {
        "Iso Code": "rmo",
        "Language Name": "Romani, Sinte",
        "Country": "Germany"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rmo"
  },
  "mms_rmy-script_latin": {
    "id": "mms_rmy-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Romani, Vlax",
        "Country": "Romania"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rmy-script_latin"
  },
  "mms_rmy-script_cyrillic": {
    "id": "mms_rmy-script_cyrillic",
    "language": [
      {
        "Iso Code": "cyrillic",
        "Language Name": "Romani, Vlax",
        "Country": "Romania"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rmy-script_cyrillic"
  },
  "mms_ron": {
    "id": "mms_ron",
    "language": [
      {
        "Iso Code": "ron",
        "Language Name": "Romanian",
        "Country": "Romania"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ron"
  },
  "mms_rol": {
    "id": "mms_rol",
    "language": [
      {
        "Iso Code": "rol",
        "Language Name": "Romblomanon",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rol"
  },
  "mms_cla": {
    "id": "mms_cla",
    "language": [
      {
        "Iso Code": "cla",
        "Language Name": "Ron",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cla"
  },
  "mms_rng": {
    "id": "mms_rng",
    "language": [
      {
        "Iso Code": "rng",
        "Language Name": "Ronga",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rng"
  },
  "mms_rug": {
    "id": "mms_rug",
    "language": [
      {
        "Iso Code": "rug",
        "Language Name": "Roviana",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rug"
  },
  "mms_run": {
    "id": "mms_run",
    "language": [
      {
        "Iso Code": "run",
        "Language Name": "Rundi",
        "Country": "Burundi"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/run"
  },
  "mms_rus": {
    "id": "mms_rus",
    "language": [
      {
        "Iso Code": "rus",
        "Language Name": "Russian",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rus"
  },
  "mms_lsm": {
    "id": "mms_lsm",
    "language": [
      {
        "Iso Code": "lsm",
        "Language Name": "Saamya-Gwe",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lsm"
  },
  "mms_spy": {
    "id": "mms_spy",
    "language": [
      {
        "Iso Code": "spy",
        "Language Name": "Sabaot",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/spy"
  },
  "mms_sck": {
    "id": "mms_sck",
    "language": [
      {
        "Iso Code": "sck",
        "Language Name": "Sadri",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sck"
  },
  "mms_saj": {
    "id": "mms_saj",
    "language": [
      {
        "Iso Code": "saj",
        "Language Name": "Sahu",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/saj"
  },
  "mms_sch": {
    "id": "mms_sch",
    "language": [
      {
        "Iso Code": "sch",
        "Language Name": "Sakachep",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sch"
  },
  "mms_sml": {
    "id": "mms_sml",
    "language": [
      {
        "Iso Code": "sml",
        "Language Name": "Sama, Central",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sml"
  },
  "mms_xsb": {
    "id": "mms_xsb",
    "language": [
      {
        "Iso Code": "xsb",
        "Language Name": "Sambal",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xsb"
  },
  "mms_sbl": {
    "id": "mms_sbl",
    "language": [
      {
        "Iso Code": "sbl",
        "Language Name": "Sambal, Botolan",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sbl"
  },
  "mms_saq": {
    "id": "mms_saq",
    "language": [
      {
        "Iso Code": "saq",
        "Language Name": "Samburu",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/saq"
  },
  "mms_sbd": {
    "id": "mms_sbd",
    "language": [
      {
        "Iso Code": "sbd",
        "Language Name": "Samo, Southern",
        "Country": "Burkina Faso"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sbd"
  },
  "mms_smo": {
    "id": "mms_smo",
    "language": [
      {
        "Iso Code": "smo",
        "Language Name": "Samoan",
        "Country": "Samoa"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/smo"
  },
  "mms_rav": {
    "id": "mms_rav",
    "language": [
      {
        "Iso Code": "rav",
        "Language Name": "Sampang",
        "Country": "Nepal"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rav"
  },
  "mms_sxn": {
    "id": "mms_sxn",
    "language": [
      {
        "Iso Code": "sxn",
        "Language Name": "Sangir",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sxn"
  },
  "mms_sag": {
    "id": "mms_sag",
    "language": [
      {
        "Iso Code": "sag",
        "Language Name": "Sango",
        "Country": "Central African Republic"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sag"
  },
  "mms_sbp": {
    "id": "mms_sbp",
    "language": [
      {
        "Iso Code": "sbp",
        "Language Name": "Sangu",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sbp"
  },
  "mms_xsu": {
    "id": "mms_xsu",
    "language": [
      {
        "Iso Code": "xsu",
        "Language Name": "Sanumá",
        "Country": "Venezuela"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xsu"
  },
  "mms_srm": {
    "id": "mms_srm",
    "language": [
      {
        "Iso Code": "srm",
        "Language Name": "Saramaccan",
        "Country": "Suriname"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/srm"
  },
  "mms_sas": {
    "id": "mms_sas",
    "language": [
      {
        "Iso Code": "sas",
        "Language Name": "Sasak",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sas"
  },
  "mms_apb": {
    "id": "mms_apb",
    "language": [
      {
        "Iso Code": "apb",
        "Language Name": "Sa’a",
        "Country": "Solomon Islands"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/apb"
  },
  "mms_sgw": {
    "id": "mms_sgw",
    "language": [
      {
        "Iso Code": "sgw",
        "Language Name": "Sebat Bet Gurage",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": false,
    "Sample Exists": false,
    "url": "Not available"
  },
  "mms_tvw": {
    "id": "mms_tvw",
    "language": [
      {
        "Iso Code": "tvw",
        "Language Name": "Sedoa",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tvw"
  },
  "mms_lip": {
    "id": "mms_lip",
    "language": [
      {
        "Iso Code": "lip",
        "Language Name": "Sekpele",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lip"
  },
  "mms_slu": {
    "id": "mms_slu",
    "language": [
      {
        "Iso Code": "slu",
        "Language Name": "Selaru",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/slu"
  },
  "mms_snw": {
    "id": "mms_snw",
    "language": [
      {
        "Iso Code": "snw",
        "Language Name": "Selee",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/snw"
  },
  "mms_sea": {
    "id": "mms_sea",
    "language": [
      {
        "Iso Code": "sea",
        "Language Name": "Semai",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sea"
  },
  "mms_sza": {
    "id": "mms_sza",
    "language": [
      {
        "Iso Code": "sza",
        "Language Name": "Semelai",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sza"
  },
  "mms_seh": {
    "id": "mms_seh",
    "language": [
      {
        "Iso Code": "seh",
        "Language Name": "Sena",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/seh"
  },
  "mms_crs": {
    "id": "mms_crs",
    "language": [
      {
        "Iso Code": "crs",
        "Language Name": "Seychelles French Creole",
        "Country": "Seychelles"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/crs"
  },
  "mms_ksb": {
    "id": "mms_ksb",
    "language": [
      {
        "Iso Code": "ksb",
        "Language Name": "Shambala",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ksb"
  },
  "mms_shn": {
    "id": "mms_shn",
    "language": [
      {
        "Iso Code": "shn",
        "Language Name": "Shan",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/shn"
  },
  "mms_sho": {
    "id": "mms_sho",
    "language": [
      {
        "Iso Code": "sho",
        "Language Name": "Shanga",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sho"
  },
  "mms_mcd": {
    "id": "mms_mcd",
    "language": [
      {
        "Iso Code": "mcd",
        "Language Name": "Sharanahua",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mcd"
  },
  "mms_cbt": {
    "id": "mms_cbt",
    "language": [
      {
        "Iso Code": "cbt",
        "Language Name": "Shawi",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cbt"
  },
  "mms_xsr": {
    "id": "mms_xsr",
    "language": [
      {
        "Iso Code": "xsr",
        "Language Name": "Sherpa",
        "Country": "Nepal"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xsr"
  },
  "mms_shk": {
    "id": "mms_shk",
    "language": [
      {
        "Iso Code": "shk",
        "Language Name": "Shilluk",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/shk"
  },
  "mms_shp": {
    "id": "mms_shp",
    "language": [
      {
        "Iso Code": "shp",
        "Language Name": "Shipibo-Conibo",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/shp"
  },
  "mms_sna": {
    "id": "mms_sna",
    "language": [
      {
        "Iso Code": "sna",
        "Language Name": "Shona",
        "Country": "Zimbabwe"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sna"
  },
  "mms_cjs": {
    "id": "mms_cjs",
    "language": [
      {
        "Iso Code": "cjs",
        "Language Name": "Shor",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cjs"
  },
  "mms_jiv": {
    "id": "mms_jiv",
    "language": [
      {
        "Iso Code": "jiv",
        "Language Name": "Shuar",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jiv"
  },
  "mms_snp": {
    "id": "mms_snp",
    "language": [
      {
        "Iso Code": "snp",
        "Language Name": "Siane",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/snp"
  },
  "mms_sya": {
    "id": "mms_sya",
    "language": [
      {
        "Iso Code": "sya",
        "Language Name": "Siang",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sya"
  },
  "mms_sid": {
    "id": "mms_sid",
    "language": [
      {
        "Iso Code": "sid",
        "Language Name": "Sidamo",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sid"
  },
  "mms_snn": {
    "id": "mms_snn",
    "language": [
      {
        "Iso Code": "snn",
        "Language Name": "Siona",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/snn"
  },
  "mms_sri": {
    "id": "mms_sri",
    "language": [
      {
        "Iso Code": "sri",
        "Language Name": "Siriano",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sri"
  },
  "mms_srx": {
    "id": "mms_srx",
    "language": [
      {
        "Iso Code": "srx",
        "Language Name": "Sirmauri",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/srx"
  },
  "mms_sil": {
    "id": "mms_sil",
    "language": [
      {
        "Iso Code": "sil",
        "Language Name": "Sisaala, Tumulung",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sil"
  },
  "mms_sld": {
    "id": "mms_sld",
    "language": [
      {
        "Iso Code": "sld",
        "Language Name": "Sissala",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sld"
  },
  "mms_akp": {
    "id": "mms_akp",
    "language": [
      {
        "Iso Code": "akp",
        "Language Name": "Siwu",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/akp"
  },
  "mms_xog": {
    "id": "mms_xog",
    "language": [
      {
        "Iso Code": "xog",
        "Language Name": "Soga",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xog"
  },
  "mms_som": {
    "id": "mms_som",
    "language": [
      {
        "Iso Code": "som",
        "Language Name": "Somali",
        "Country": "Somalia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/som"
  },
  "mms_bmu": {
    "id": "mms_bmu",
    "language": [
      {
        "Iso Code": "bmu",
        "Language Name": "Somba-Siawari",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bmu"
  },
  "mms_khq": {
    "id": "mms_khq",
    "language": [
      {
        "Iso Code": "khq",
        "Language Name": "Songhay, Koyra Chiini",
        "Country": "Mali"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/khq"
  },
  "mms_ses": {
    "id": "mms_ses",
    "language": [
      {
        "Iso Code": "ses",
        "Language Name": "Songhay, Koyraboro Senni",
        "Country": "Mali"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ses"
  },
  "mms_mnx": {
    "id": "mms_mnx",
    "language": [
      {
        "Iso Code": "mnx",
        "Language Name": "Sougb",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mnx"
  },
  "mms_spa": {
    "id": "mms_spa",
    "language": [
      {
        "Iso Code": "spa",
        "Language Name": "Spanish",
        "Country": "Spain"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/spa"
  },
  "mms_srn": {
    "id": "mms_srn",
    "language": [
      {
        "Iso Code": "srn",
        "Language Name": "Sranan Tongo",
        "Country": "Suriname"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/srn"
  },
  "mms_sxb": {
    "id": "mms_sxb",
    "language": [
      {
        "Iso Code": "sxb",
        "Language Name": "Suba",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sxb"
  },
  "mms_suc": {
    "id": "mms_suc",
    "language": [
      {
        "Iso Code": "suc",
        "Language Name": "Subanon, Western",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/suc"
  },
  "mms_tgo": {
    "id": "mms_tgo",
    "language": [
      {
        "Iso Code": "tgo",
        "Language Name": "Sudest",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tgo"
  },
  "mms_suk": {
    "id": "mms_suk",
    "language": [
      {
        "Iso Code": "suk",
        "Language Name": "Sukuma",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/suk"
  },
  "mms_sun": {
    "id": "mms_sun",
    "language": [
      {
        "Iso Code": "sun",
        "Language Name": "Sunda",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sun"
  },
  "mms_suz": {
    "id": "mms_suz",
    "language": [
      {
        "Iso Code": "suz",
        "Language Name": "Sunwar",
        "Country": "Nepal"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/suz"
  },
  "mms_sgj": {
    "id": "mms_sgj",
    "language": [
      {
        "Iso Code": "sgj",
        "Language Name": "Surgujia",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sgj"
  },
  "mms_sus": {
    "id": "mms_sus",
    "language": [
      {
        "Iso Code": "sus",
        "Language Name": "Susu",
        "Country": "Guinea"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sus"
  },
  "mms_swh": {
    "id": "mms_swh",
    "language": [
      {
        "Iso Code": "swh",
        "Language Name": "Swahili",
        "Country": "Kenya"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/swh"
  },
  "mms_swe": {
    "id": "mms_swe",
    "language": [
      {
        "Iso Code": "swe",
        "Language Name": "Swedish",
        "Country": "Sweden"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/swe"
  },
  "mms_syl": {
    "id": "mms_syl",
    "language": [
      {
        "Iso Code": "syl",
        "Language Name": "Sylheti",
        "Country": "Bangladesh"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/syl"
  },
  "mms_dyi": {
    "id": "mms_dyi",
    "language": [
      {
        "Iso Code": "dyi",
        "Language Name": "Sénoufo, Djimini",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dyi"
  },
  "mms_myk": {
    "id": "mms_myk",
    "language": [
      {
        "Iso Code": "myk",
        "Language Name": "Sénoufo, Mamara",
        "Country": "Mali"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/myk"
  },
  "mms_spp": {
    "id": "mms_spp",
    "language": [
      {
        "Iso Code": "spp",
        "Language Name": "Sénoufo, Supyire",
        "Country": "Mali"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/spp"
  },
  "mms_tap": {
    "id": "mms_tap",
    "language": [
      {
        "Iso Code": "tap",
        "Language Name": "Taabwa",
        "Country": "Zambia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tap"
  },
  "mms_tby": {
    "id": "mms_tby",
    "language": [
      {
        "Iso Code": "tby",
        "Language Name": "Tabaru",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tby"
  },
  "mms_tna": {
    "id": "mms_tna",
    "language": [
      {
        "Iso Code": "tna",
        "Language Name": "Tacana",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tna"
  },
  "mms_shi": {
    "id": "mms_shi",
    "language": [
      {
        "Iso Code": "shi",
        "Language Name": "Tachelhit",
        "Country": "Morocco"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/shi"
  },
  "mms_klw": {
    "id": "mms_klw",
    "language": [
      {
        "Iso Code": "klw",
        "Language Name": "Tado",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/klw"
  },
  "mms_tgl": {
    "id": "mms_tgl",
    "language": [
      {
        "Iso Code": "tgl",
        "Language Name": "Tagalog",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tgl"
  },
  "mms_tbk": {
    "id": "mms_tbk",
    "language": [
      {
        "Iso Code": "tbk",
        "Language Name": "Tagbanwa, Calamian",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tbk"
  },
  "mms_tgj": {
    "id": "mms_tgj",
    "language": [
      {
        "Iso Code": "tgj",
        "Language Name": "Tagin",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tgj"
  },
  "mms_blt": {
    "id": "mms_blt",
    "language": [
      {
        "Iso Code": "blt",
        "Language Name": "Tai Dam",
        "Country": "Vietnam"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/blt"
  },
  "mms_tbg": {
    "id": "mms_tbg",
    "language": [
      {
        "Iso Code": "tbg",
        "Language Name": "Tairora, North",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tbg"
  },
  "mms_omw": {
    "id": "mms_omw",
    "language": [
      {
        "Iso Code": "omw",
        "Language Name": "Tairora, South",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/omw"
  },
  "mms_tgk": {
    "id": "mms_tgk",
    "language": [
      {
        "Iso Code": "tgk",
        "Language Name": "Tajik",
        "Country": "Tajikistan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tgk"
  },
  "mms_tdj": {
    "id": "mms_tdj",
    "language": [
      {
        "Iso Code": "tdj",
        "Language Name": "Tajio",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tdj"
  },
  "mms_tbc": {
    "id": "mms_tbc",
    "language": [
      {
        "Iso Code": "tbc",
        "Language Name": "Takia",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tbc"
  },
  "mms_tlj": {
    "id": "mms_tlj",
    "language": [
      {
        "Iso Code": "tlj",
        "Language Name": "Talinga-Bwisi",
        "Country": "Uganda"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tlj"
  },
  "mms_tly": {
    "id": "mms_tly",
    "language": [
      {
        "Iso Code": "tly",
        "Language Name": "Talysh",
        "Country": "Azerbaijan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tly"
  },
  "mms_ttq-script_tifinagh": {
    "id": "mms_ttq-script_tifinagh",
    "language": [
      {
        "Iso Code": "tifinagh",
        "Language Name": "Tamajaq, Tawallammat",
        "Country": "Niger"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ttq-script_tifinagh"
  },
  "mms_taj": {
    "id": "mms_taj",
    "language": [
      {
        "Iso Code": "taj",
        "Language Name": "Tamang, Eastern",
        "Country": "Nepal"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/taj"
  },
  "mms_taq": {
    "id": "mms_taq",
    "language": [
      {
        "Iso Code": "taq",
        "Language Name": "Tamasheq",
        "Country": "Mali"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/taq"
  },
  "mms_tam": {
    "id": "mms_tam",
    "language": [
      {
        "Iso Code": "tam",
        "Language Name": "Tamil",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tam"
  },
  "mms_tpm": {
    "id": "mms_tpm",
    "language": [
      {
        "Iso Code": "tpm",
        "Language Name": "Tampulma",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tpm"
  },
  "mms_tgp": {
    "id": "mms_tgp",
    "language": [
      {
        "Iso Code": "tgp",
        "Language Name": "Tangoa",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tgp"
  },
  "mms_tnn": {
    "id": "mms_tnn",
    "language": [
      {
        "Iso Code": "tnn",
        "Language Name": "Tanna, North",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tnn"
  },
  "mms_tac": {
    "id": "mms_tac",
    "language": [
      {
        "Iso Code": "tac",
        "Language Name": "Tarahumara, Western",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tac"
  },
  "mms_rif-script_latin": {
    "id": "mms_rif-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Tarifit",
        "Country": "Morocco"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rif-script_latin"
  },
  "mms_rif-script_arabic": {
    "id": "mms_rif-script_arabic",
    "language": [
      {
        "Iso Code": "arabic",
        "Language Name": "Tarifit",
        "Country": "Morocco"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rif-script_arabic"
  },
  "mms_tat": {
    "id": "mms_tat",
    "language": [
      {
        "Iso Code": "tat",
        "Language Name": "Tatar",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tat"
  },
  "mms_tav": {
    "id": "mms_tav",
    "language": [
      {
        "Iso Code": "tav",
        "Language Name": "Tatuyo",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tav"
  },
  "mms_twb": {
    "id": "mms_twb",
    "language": [
      {
        "Iso Code": "twb",
        "Language Name": "Tawbuid",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/twb"
  },
  "mms_tbl": {
    "id": "mms_tbl",
    "language": [
      {
        "Iso Code": "tbl",
        "Language Name": "Tboli",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tbl"
  },
  "mms_kps": {
    "id": "mms_kps",
    "language": [
      {
        "Iso Code": "kps",
        "Language Name": "Tehit",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kps"
  },
  "mms_twe": {
    "id": "mms_twe",
    "language": [
      {
        "Iso Code": "twe",
        "Language Name": "Teiwa",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/twe"
  },
  "mms_ttc": {
    "id": "mms_ttc",
    "language": [
      {
        "Iso Code": "ttc",
        "Language Name": "Tektiteko",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ttc"
  },
  "mms_tel": {
    "id": "mms_tel",
    "language": [
      {
        "Iso Code": "tel",
        "Language Name": "Telugu",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tel"
  },
  "mms_kdh": {
    "id": "mms_kdh",
    "language": [
      {
        "Iso Code": "kdh",
        "Language Name": "Tem",
        "Country": "Togo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kdh"
  },
  "mms_tes": {
    "id": "mms_tes",
    "language": [
      {
        "Iso Code": "tes",
        "Language Name": "Tengger",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tes"
  },
  "mms_tex": {
    "id": "mms_tex",
    "language": [
      {
        "Iso Code": "tex",
        "Language Name": "Tennet",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tex"
  },
  "mms_tee": {
    "id": "mms_tee",
    "language": [
      {
        "Iso Code": "tee",
        "Language Name": "Tepehua, Huehuetla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tee"
  },
  "mms_tpp": {
    "id": "mms_tpp",
    "language": [
      {
        "Iso Code": "tpp",
        "Language Name": "Tepehua, Pisaflores",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tpp"
  },
  "mms_tpt": {
    "id": "mms_tpt",
    "language": [
      {
        "Iso Code": "tpt",
        "Language Name": "Tepehua, Tlachichilco",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tpt"
  },
  "mms_stp": {
    "id": "mms_stp",
    "language": [
      {
        "Iso Code": "stp",
        "Language Name": "Tepehuan, Southeastern",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/stp"
  },
  "mms_tfr": {
    "id": "mms_tfr",
    "language": [
      {
        "Iso Code": "tfr",
        "Language Name": "Teribe",
        "Country": "Costa Rica"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tfr"
  },
  "mms_twu": {
    "id": "mms_twu",
    "language": [
      {
        "Iso Code": "twu",
        "Language Name": "Termanu",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/twu"
  },
  "mms_ter": {
    "id": "mms_ter",
    "language": [
      {
        "Iso Code": "ter",
        "Language Name": "Terêna",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ter"
  },
  "mms_tew": {
    "id": "mms_tew",
    "language": [
      {
        "Iso Code": "tew",
        "Language Name": "Tewa",
        "Country": "United States"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tew"
  },
  "mms_tha": {
    "id": "mms_tha",
    "language": [
      {
        "Iso Code": "tha",
        "Language Name": "Thai",
        "Country": "Thailand"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tha"
  },
  "mms_nod": {
    "id": "mms_nod",
    "language": [
      {
        "Iso Code": "nod",
        "Language Name": "Thai, Northern",
        "Country": "Thailand"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nod"
  },
  "mms_thl": {
    "id": "mms_thl",
    "language": [
      {
        "Iso Code": "thl",
        "Language Name": "Tharu, Dangaura",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/thl"
  },
  "mms_tem": {
    "id": "mms_tem",
    "language": [
      {
        "Iso Code": "tem",
        "Language Name": "Themne",
        "Country": "Sierra Leone"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tem"
  },
  "mms_adx": {
    "id": "mms_adx",
    "language": [
      {
        "Iso Code": "adx",
        "Language Name": "Tibetan, Amdo",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/adx"
  },
  "mms_bod": {
    "id": "mms_bod",
    "language": [
      {
        "Iso Code": "bod",
        "Language Name": "Tibetan, Central",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bod"
  },
  "mms_khg": {
    "id": "mms_khg",
    "language": [
      {
        "Iso Code": "khg",
        "Language Name": "Tibetan, Khams",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/khg"
  },
  "mms_tca": {
    "id": "mms_tca",
    "language": [
      {
        "Iso Code": "tca",
        "Language Name": "Ticuna",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tca"
  },
  "mms_tir": {
    "id": "mms_tir",
    "language": [
      {
        "Iso Code": "tir",
        "Language Name": "Tigrigna",
        "Country": "Eritrea"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": false,
    "Sample Exists": false,
    "url": "Not available"
  },
  "mms_txq": {
    "id": "mms_txq",
    "language": [
      {
        "Iso Code": "txq",
        "Language Name": "Tii",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/txq"
  },
  "mms_tik": {
    "id": "mms_tik",
    "language": [
      {
        "Iso Code": "tik",
        "Language Name": "Tikar",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tik"
  },
  "mms_dgr": {
    "id": "mms_dgr",
    "language": [
      {
        "Iso Code": "dgr",
        "Language Name": "Tlicho",
        "Country": "Canada"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/dgr"
  },
  "mms_tob": {
    "id": "mms_tob",
    "language": [
      {
        "Iso Code": "tob",
        "Language Name": "Toba",
        "Country": "Argentina"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tob"
  },
  "mms_tmf": {
    "id": "mms_tmf",
    "language": [
      {
        "Iso Code": "tmf",
        "Language Name": "Toba-Maskoy",
        "Country": "Paraguay"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tmf"
  },
  "mms_tng": {
    "id": "mms_tng",
    "language": [
      {
        "Iso Code": "tng",
        "Language Name": "Tobanga",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tng"
  },
  "mms_tlb": {
    "id": "mms_tlb",
    "language": [
      {
        "Iso Code": "tlb",
        "Language Name": "Tobelo",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tlb"
  },
  "mms_ood": {
    "id": "mms_ood",
    "language": [
      {
        "Iso Code": "ood",
        "Language Name": "Tohono O’odham",
        "Country": "United States"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ood"
  },
  "mms_tpi": {
    "id": "mms_tpi",
    "language": [
      {
        "Iso Code": "tpi",
        "Language Name": "Tok Pisin",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tpi"
  },
  "mms_jic": {
    "id": "mms_jic",
    "language": [
      {
        "Iso Code": "jic",
        "Language Name": "Tol",
        "Country": "Honduras"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jic"
  },
  "mms_lbw": {
    "id": "mms_lbw",
    "language": [
      {
        "Iso Code": "lbw",
        "Language Name": "Tolaki",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lbw"
  },
  "mms_txa": {
    "id": "mms_txa",
    "language": [
      {
        "Iso Code": "txa",
        "Language Name": "Tombonuo",
        "Country": "Malaysia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/txa"
  },
  "mms_tom": {
    "id": "mms_tom",
    "language": [
      {
        "Iso Code": "tom",
        "Language Name": "Tombulu",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tom"
  },
  "mms_toh": {
    "id": "mms_toh",
    "language": [
      {
        "Iso Code": "toh",
        "Language Name": "Tonga",
        "Country": "Zambia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/toh"
  },
  "mms_tnt": {
    "id": "mms_tnt",
    "language": [
      {
        "Iso Code": "tnt",
        "Language Name": "Tontemboan",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tnt"
  },
  "mms_sda": {
    "id": "mms_sda",
    "language": [
      {
        "Iso Code": "sda",
        "Language Name": "Toraja-Sa’dan",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sda"
  },
  "mms_tcs": {
    "id": "mms_tcs",
    "language": [
      {
        "Iso Code": "tcs",
        "Language Name": "Torres Strait Creole",
        "Country": "Australia"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tcs"
  },
  "mms_toc": {
    "id": "mms_toc",
    "language": [
      {
        "Iso Code": "toc",
        "Language Name": "Totonac, Coyutla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/toc"
  },
  "mms_tos": {
    "id": "mms_tos",
    "language": [
      {
        "Iso Code": "tos",
        "Language Name": "Totonac, Highland",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tos"
  },
  "mms_neb": {
    "id": "mms_neb",
    "language": [
      {
        "Iso Code": "neb",
        "Language Name": "Toura",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/neb"
  },
  "mms_trn": {
    "id": "mms_trn",
    "language": [
      {
        "Iso Code": "trn",
        "Language Name": "Trinitario",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/trn"
  },
  "mms_trs": {
    "id": "mms_trs",
    "language": [
      {
        "Iso Code": "trs",
        "Language Name": "Triqui, Chicahuaxtla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/trs"
  },
  "mms_trc": {
    "id": "mms_trc",
    "language": [
      {
        "Iso Code": "trc",
        "Language Name": "Triqui, Copala",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/trc"
  },
  "mms_tri": {
    "id": "mms_tri",
    "language": [
      {
        "Iso Code": "tri",
        "Language Name": "Trió",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tri"
  },
  "mms_cof": {
    "id": "mms_cof",
    "language": [
      {
        "Iso Code": "cof",
        "Language Name": "Tsafiki",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cof"
  },
  "mms_tkr": {
    "id": "mms_tkr",
    "language": [
      {
        "Iso Code": "tkr",
        "Language Name": "Tsakhur",
        "Country": "Azerbaijan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tkr"
  },
  "mms_kdl": {
    "id": "mms_kdl",
    "language": [
      {
        "Iso Code": "kdl",
        "Language Name": "Tsikimba",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kdl"
  },
  "mms_cas": {
    "id": "mms_cas",
    "language": [
      {
        "Iso Code": "cas",
        "Language Name": "Tsimané",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cas"
  },
  "mms_tso": {
    "id": "mms_tso",
    "language": [
      {
        "Iso Code": "tso",
        "Language Name": "Tsonga",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tso"
  },
  "mms_tuo": {
    "id": "mms_tuo",
    "language": [
      {
        "Iso Code": "tuo",
        "Language Name": "Tucano",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tuo"
  },
  "mms_iou": {
    "id": "mms_iou",
    "language": [
      {
        "Iso Code": "iou",
        "Language Name": "Tuma-Irumu",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/iou"
  },
  "mms_tmc": {
    "id": "mms_tmc",
    "language": [
      {
        "Iso Code": "tmc",
        "Language Name": "Tumak",
        "Country": "Chad"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tmc"
  },
  "mms_tuf": {
    "id": "mms_tuf",
    "language": [
      {
        "Iso Code": "tuf",
        "Language Name": "Tunebo, Central",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tuf"
  },
  "mms_tur": {
    "id": "mms_tur",
    "language": [
      {
        "Iso Code": "tur",
        "Language Name": "Turkish",
        "Country": "Turkey"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tur"
  },
  "mms_tuk-script_latin": {
    "id": "mms_tuk-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Turkmen",
        "Country": "Turkmenistan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tuk-script_latin"
  },
  "mms_tuk-script_arabic": {
    "id": "mms_tuk-script_arabic",
    "language": [
      {
        "Iso Code": "arabic",
        "Language Name": "Turkmen",
        "Country": "Turkmenistan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tuk-script_arabic"
  },
  "mms_bov": {
    "id": "mms_bov",
    "language": [
      {
        "Iso Code": "bov",
        "Language Name": "Tuwuli",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bov"
  },
  "mms_tue": {
    "id": "mms_tue",
    "language": [
      {
        "Iso Code": "tue",
        "Language Name": "Tuyuca",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tue"
  },
  "mms_kcg": {
    "id": "mms_kcg",
    "language": [
      {
        "Iso Code": "kcg",
        "Language Name": "Tyap",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kcg"
  },
  "mms_tzh-dialect_bachajón": {
    "id": "mms_tzh-dialect_bachajón",
    "language": [
      {
        "Iso Code": "bachajón",
        "Language Name": "Tzeltal",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tzh-dialect_bachajón"
  },
  "mms_tzh-dialect_tenejapa": {
    "id": "mms_tzh-dialect_tenejapa",
    "language": [
      {
        "Iso Code": "tenejapa",
        "Language Name": "Tzeltal",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tzh-dialect_tenejapa"
  },
  "mms_tzo-dialect_chenalhó": {
    "id": "mms_tzo-dialect_chenalhó",
    "language": [
      {
        "Iso Code": "chenalhó",
        "Language Name": "Tzotzil",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tzo-dialect_chenalhó"
  },
  "mms_tzo-dialect_chamula": {
    "id": "mms_tzo-dialect_chamula",
    "language": [
      {
        "Iso Code": "chamula",
        "Language Name": "Tzotzil",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tzo-dialect_chamula"
  },
  "mms_tzj-dialect_western": {
    "id": "mms_tzj-dialect_western",
    "language": [
      {
        "Iso Code": "western",
        "Language Name": "Tz’utujil",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tzj-dialect_western"
  },
  "mms_tzj-dialect_eastern": {
    "id": "mms_tzj-dialect_eastern",
    "language": [
      {
        "Iso Code": "eastern",
        "Language Name": "Tz’utujil",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tzj-dialect_eastern"
  },
  "mms_aoz": {
    "id": "mms_aoz",
    "language": [
      {
        "Iso Code": "aoz",
        "Language Name": "Uab Meto",
        "Country": "East Timor"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/aoz"
  },
  "mms_udm": {
    "id": "mms_udm",
    "language": [
      {
        "Iso Code": "udm",
        "Language Name": "Udmurt",
        "Country": "Russia"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/udm"
  },
  "mms_udu": {
    "id": "mms_udu",
    "language": [
      {
        "Iso Code": "udu",
        "Language Name": "Uduk",
        "Country": "South Sudan"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/udu"
  },
  "mms_ukr": {
    "id": "mms_ukr",
    "language": [
      {
        "Iso Code": "ukr",
        "Language Name": "Ukrainian",
        "Country": "Ukraine"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ukr"
  },
  "mms_ppk": {
    "id": "mms_ppk",
    "language": [
      {
        "Iso Code": "ppk",
        "Language Name": "Uma",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ppk"
  },
  "mms_ubu": {
    "id": "mms_ubu",
    "language": [
      {
        "Iso Code": "ubu",
        "Language Name": "Umbu-Ungu",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ubu"
  },
  "mms_urk": {
    "id": "mms_urk",
    "language": [
      {
        "Iso Code": "urk",
        "Language Name": "Urak Lawoi’",
        "Country": "Thailand"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/urk"
  },
  "mms_ura": {
    "id": "mms_ura",
    "language": [
      {
        "Iso Code": "ura",
        "Language Name": "Urarina",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ura"
  },
  "mms_urt": {
    "id": "mms_urt",
    "language": [
      {
        "Iso Code": "urt",
        "Language Name": "Urat",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/urt"
  },
  "mms_urd-script_devanagari": {
    "id": "mms_urd-script_devanagari",
    "language": [
      {
        "Iso Code": "devanagari",
        "Language Name": "Urdu",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/urd-script_devanagari"
  },
  "mms_urd-script_arabic": {
    "id": "mms_urd-script_arabic",
    "language": [
      {
        "Iso Code": "arabic",
        "Language Name": "Urdu",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/urd-script_arabic"
  },
  "mms_urd-script_latin": {
    "id": "mms_urd-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Urdu",
        "Country": "India"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/urd-script_latin"
  },
  "mms_upv": {
    "id": "mms_upv",
    "language": [
      {
        "Iso Code": "upv",
        "Language Name": "Uripiv-Wala-Rano-Atchin",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/upv"
  },
  "mms_usp": {
    "id": "mms_usp",
    "language": [
      {
        "Iso Code": "usp",
        "Language Name": "Uspanteko",
        "Country": "Guatemala"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/usp"
  },
  "mms_uig-script_arabic": {
    "id": "mms_uig-script_arabic",
    "language": [
      {
        "Iso Code": "arabic",
        "Language Name": "Uyghur",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/uig-script_arabic"
  },
  "mms_uig-script_cyrillic": {
    "id": "mms_uig-script_cyrillic",
    "language": [
      {
        "Iso Code": "cyrillic",
        "Language Name": "Uyghur",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/uig-script_cyrillic"
  },
  "mms_uzb-script_cyrillic": {
    "id": "mms_uzb-script_cyrillic",
    "language": [
      {
        "Iso Code": "cyrillic",
        "Language Name": "Uzbek",
        "Country": "Uzbekistan"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/uzb-script_cyrillic"
  },
  "mms_vag": {
    "id": "mms_vag",
    "language": [
      {
        "Iso Code": "vag",
        "Language Name": "Vagla",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/vag"
  },
  "mms_bav": {
    "id": "mms_bav",
    "language": [
      {
        "Iso Code": "bav",
        "Language Name": "Vengo",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bav"
  },
  "mms_vid": {
    "id": "mms_vid",
    "language": [
      {
        "Iso Code": "vid",
        "Language Name": "Vidunda",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/vid"
  },
  "mms_vie": {
    "id": "mms_vie",
    "language": [
      {
        "Iso Code": "vie",
        "Language Name": "Vietnamese",
        "Country": "Vietnam"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/vie"
  },
  "mms_vif": {
    "id": "mms_vif",
    "language": [
      {
        "Iso Code": "vif",
        "Language Name": "Vili",
        "Country": "Gabon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/vif"
  },
  "mms_vun": {
    "id": "mms_vun",
    "language": [
      {
        "Iso Code": "vun",
        "Language Name": "Vunjo",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/vun"
  },
  "mms_vut": {
    "id": "mms_vut",
    "language": [
      {
        "Iso Code": "vut",
        "Language Name": "Vute",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/vut"
  },
  "mms_prk": {
    "id": "mms_prk",
    "language": [
      {
        "Iso Code": "prk",
        "Language Name": "Wa, Parauk",
        "Country": "Myanmar"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/prk"
  },
  "mms_wwa": {
    "id": "mms_wwa",
    "language": [
      {
        "Iso Code": "wwa",
        "Language Name": "Waama",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wwa"
  },
  "mms_rro": {
    "id": "mms_rro",
    "language": [
      {
        "Iso Code": "rro",
        "Language Name": "Waima",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/rro"
  },
  "mms_bao": {
    "id": "mms_bao",
    "language": [
      {
        "Iso Code": "bao",
        "Language Name": "Waimaha",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/bao"
  },
  "mms_waw": {
    "id": "mms_waw",
    "language": [
      {
        "Iso Code": "waw",
        "Language Name": "Waiwai",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/waw"
  },
  "mms_lgl": {
    "id": "mms_lgl",
    "language": [
      {
        "Iso Code": "lgl",
        "Language Name": "Wala",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/lgl"
  },
  "mms_wlx": {
    "id": "mms_wlx",
    "language": [
      {
        "Iso Code": "wlx",
        "Language Name": "Wali",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wlx"
  },
  "mms_cou": {
    "id": "mms_cou",
    "language": [
      {
        "Iso Code": "cou",
        "Language Name": "Wamey",
        "Country": "Guinea"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cou"
  },
  "mms_hub": {
    "id": "mms_hub",
    "language": [
      {
        "Iso Code": "hub",
        "Language Name": "Wampís",
        "Country": "Ecuador"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hub"
  },
  "mms_gvc": {
    "id": "mms_gvc",
    "language": [
      {
        "Iso Code": "gvc",
        "Language Name": "Wanano",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gvc"
  },
  "mms_mfi": {
    "id": "mms_mfi",
    "language": [
      {
        "Iso Code": "mfi",
        "Language Name": "Wandala",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/mfi"
  },
  "mms_wap": {
    "id": "mms_wap",
    "language": [
      {
        "Iso Code": "wap",
        "Language Name": "Wapishana",
        "Country": "Guyana"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wap"
  },
  "mms_wba": {
    "id": "mms_wba",
    "language": [
      {
        "Iso Code": "wba",
        "Language Name": "Warao",
        "Country": "Guyana"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wba"
  },
  "mms_war": {
    "id": "mms_war",
    "language": [
      {
        "Iso Code": "war",
        "Language Name": "Waray-Waray",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/war"
  },
  "mms_way": {
    "id": "mms_way",
    "language": [
      {
        "Iso Code": "way",
        "Language Name": "Wayana",
        "Country": "Suriname"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/way"
  },
  "mms_guc": {
    "id": "mms_guc",
    "language": [
      {
        "Iso Code": "guc",
        "Language Name": "Wayuu",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/guc"
  },
  "mms_cym": {
    "id": "mms_cym",
    "language": [
      {
        "Iso Code": "cym",
        "Language Name": "Welsh",
        "Country": "United Kingdom"
      }
    ],
    "Region": "Europe",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/cym"
  },
  "mms_kvw": {
    "id": "mms_kvw",
    "language": [
      {
        "Iso Code": "kvw",
        "Language Name": "Wersing",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kvw"
  },
  "mms_tnp": {
    "id": "mms_tnp",
    "language": [
      {
        "Iso Code": "tnp",
        "Language Name": "Whitesands",
        "Country": "Vanuatu"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tnp"
  },
  "mms_hto": {
    "id": "mms_hto",
    "language": [
      {
        "Iso Code": "hto",
        "Language Name": "Witoto, Minika",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/hto"
  },
  "mms_huu": {
    "id": "mms_huu",
    "language": [
      {
        "Iso Code": "huu",
        "Language Name": "Witoto, Murui",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/huu"
  },
  "mms_wal-script_latin": {
    "id": "mms_wal-script_latin",
    "language": [
      {
        "Iso Code": "latin",
        "Language Name": "Wolaytta",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wal-script_latin"
  },
  "mms_wal-script_ethiopic": {
    "id": "mms_wal-script_ethiopic",
    "language": [
      {
        "Iso Code": "ethiopic",
        "Language Name": "Wolaytta",
        "Country": "Ethiopia"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wal-script_ethiopic"
  },
  "mms_wlo": {
    "id": "mms_wlo",
    "language": [
      {
        "Iso Code": "wlo",
        "Language Name": "Wolio",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wlo"
  },
  "mms_noa": {
    "id": "mms_noa",
    "language": [
      {
        "Iso Code": "noa",
        "Language Name": "Woun Meu",
        "Country": "Panama"
      }
    ],
    "Region": "Central America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/noa"
  },
  "mms_wob": {
    "id": "mms_wob",
    "language": [
      {
        "Iso Code": "wob",
        "Language Name": "Wè Northern",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/wob"
  },
  "mms_kao": {
    "id": "mms_kao",
    "language": [
      {
        "Iso Code": "kao",
        "Language Name": "Xaasongaxango",
        "Country": "Mali"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/kao"
  },
  "mms_xer": {
    "id": "mms_xer",
    "language": [
      {
        "Iso Code": "xer",
        "Language Name": "Xerénte",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/xer"
  },
  "mms_yad": {
    "id": "mms_yad",
    "language": [
      {
        "Iso Code": "yad",
        "Language Name": "Yagua",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yad"
  },
  "mms_yka": {
    "id": "mms_yka",
    "language": [
      {
        "Iso Code": "yka",
        "Language Name": "Yakan",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yka"
  },
  "mms_sah": {
    "id": "mms_sah",
    "language": [
      {
        "Iso Code": "sah",
        "Language Name": "Yakut",
        "Country": "Russia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/sah"
  },
  "mms_yba": {
    "id": "mms_yba",
    "language": [
      {
        "Iso Code": "yba",
        "Language Name": "Yala",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yba"
  },
  "mms_yli": {
    "id": "mms_yli",
    "language": [
      {
        "Iso Code": "yli",
        "Language Name": "Yali, Angguruk",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yli"
  },
  "mms_nlk": {
    "id": "mms_nlk",
    "language": [
      {
        "Iso Code": "nlk",
        "Language Name": "Yali, Ninia",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/nlk"
  },
  "mms_yal": {
    "id": "mms_yal",
    "language": [
      {
        "Iso Code": "yal",
        "Language Name": "Yalunka",
        "Country": "Guinea"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yal"
  },
  "mms_yam": {
    "id": "mms_yam",
    "language": [
      {
        "Iso Code": "yam",
        "Language Name": "Yamba",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yam"
  },
  "mms_yat": {
    "id": "mms_yat",
    "language": [
      {
        "Iso Code": "yat",
        "Language Name": "Yambeta",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yat"
  },
  "mms_jmd": {
    "id": "mms_jmd",
    "language": [
      {
        "Iso Code": "jmd",
        "Language Name": "Yamdena",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/jmd"
  },
  "mms_tao": {
    "id": "mms_tao",
    "language": [
      {
        "Iso Code": "tao",
        "Language Name": "Yami",
        "Country": "Philippines"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/tao"
  },
  "mms_yaa": {
    "id": "mms_yaa",
    "language": [
      {
        "Iso Code": "yaa",
        "Language Name": "Yaminahua",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yaa"
  },
  "mms_ame": {
    "id": "mms_ame",
    "language": [
      {
        "Iso Code": "ame",
        "Language Name": "Yanesha’",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ame"
  },
  "mms_guu": {
    "id": "mms_guu",
    "language": [
      {
        "Iso Code": "guu",
        "Language Name": "Yanomamö",
        "Country": "Brazil"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/guu"
  },
  "mms_yao": {
    "id": "mms_yao",
    "language": [
      {
        "Iso Code": "yao",
        "Language Name": "Yao",
        "Country": "Mozambique"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yao"
  },
  "mms_yre": {
    "id": "mms_yre",
    "language": [
      {
        "Iso Code": "yre",
        "Language Name": "Yaouré",
        "Country": "Ivory Coast"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yre"
  },
  "mms_yva": {
    "id": "mms_yva",
    "language": [
      {
        "Iso Code": "yva",
        "Language Name": "Yawa",
        "Country": "Indonesia"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yva"
  },
  "mms_ybb": {
    "id": "mms_ybb",
    "language": [
      {
        "Iso Code": "ybb",
        "Language Name": "Yemba",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ybb"
  },
  "mms_pib": {
    "id": "mms_pib",
    "language": [
      {
        "Iso Code": "pib",
        "Language Name": "Yine",
        "Country": "Peru"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pib"
  },
  "mms_byr": {
    "id": "mms_byr",
    "language": [
      {
        "Iso Code": "byr",
        "Language Name": "Yipma",
        "Country": "Papua New Guinea"
      }
    ],
    "Region": "Oceania",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/byr"
  },
  "mms_pil": {
    "id": "mms_pil",
    "language": [
      {
        "Iso Code": "pil",
        "Language Name": "Yom",
        "Country": "Togo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/pil"
  },
  "mms_yor": {
    "id": "mms_yor",
    "language": [
      {
        "Iso Code": "yor",
        "Language Name": "Yoruba",
        "Country": "Nigeria"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yor"
  },
  "mms_ycn": {
    "id": "mms_ycn",
    "language": [
      {
        "Iso Code": "ycn",
        "Language Name": "Yucuna",
        "Country": "Colombia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ycn"
  },
  "mms_ess": {
    "id": "mms_ess",
    "language": [
      {
        "Iso Code": "ess",
        "Language Name": "Yupik, Saint Lawrence Island",
        "Country": "United States"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ess"
  },
  "mms_yuz": {
    "id": "mms_yuz",
    "language": [
      {
        "Iso Code": "yuz",
        "Language Name": "Yuracare",
        "Country": "Bolivia"
      }
    ],
    "Region": "South America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/yuz"
  },
  "mms_atb": {
    "id": "mms_atb",
    "language": [
      {
        "Iso Code": "atb",
        "Language Name": "Zaiwa",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/atb"
  },
  "mms_zne": {
    "id": "mms_zne",
    "language": [
      {
        "Iso Code": "zne",
        "Language Name": "Zande",
        "Country": "Democratic Republic of the Congo"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zne"
  },
  "mms_zaq": {
    "id": "mms_zaq",
    "language": [
      {
        "Iso Code": "zaq",
        "Language Name": "Zapotec, Aloápam",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zaq"
  },
  "mms_zpo": {
    "id": "mms_zpo",
    "language": [
      {
        "Iso Code": "zpo",
        "Language Name": "Zapotec, Amatlán",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zpo"
  },
  "mms_zad": {
    "id": "mms_zad",
    "language": [
      {
        "Iso Code": "zad",
        "Language Name": "Zapotec, Cajonos",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zad"
  },
  "mms_zpc": {
    "id": "mms_zpc",
    "language": [
      {
        "Iso Code": "zpc",
        "Language Name": "Zapotec, Choapan",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zpc"
  },
  "mms_zca": {
    "id": "mms_zca",
    "language": [
      {
        "Iso Code": "zca",
        "Language Name": "Zapotec, Coatecas Altas",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zca"
  },
  "mms_zpg": {
    "id": "mms_zpg",
    "language": [
      {
        "Iso Code": "zpg",
        "Language Name": "Zapotec, Guevea de Humboldt",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zpg"
  },
  "mms_zai": {
    "id": "mms_zai",
    "language": [
      {
        "Iso Code": "zai",
        "Language Name": "Zapotec, Isthmus",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zai"
  },
  "mms_zpl": {
    "id": "mms_zpl",
    "language": [
      {
        "Iso Code": "zpl",
        "Language Name": "Zapotec, Lachixío",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zpl"
  },
  "mms_zam": {
    "id": "mms_zam",
    "language": [
      {
        "Iso Code": "zam",
        "Language Name": "Zapotec, Miahuatlán",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zam"
  },
  "mms_zaw": {
    "id": "mms_zaw",
    "language": [
      {
        "Iso Code": "zaw",
        "Language Name": "Zapotec, Mitla",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zaw"
  },
  "mms_zpm": {
    "id": "mms_zpm",
    "language": [
      {
        "Iso Code": "zpm",
        "Language Name": "Zapotec, Mixtepec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zpm"
  },
  "mms_zac": {
    "id": "mms_zac",
    "language": [
      {
        "Iso Code": "zac",
        "Language Name": "Zapotec, Ocotlán",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zac"
  },
  "mms_zao": {
    "id": "mms_zao",
    "language": [
      {
        "Iso Code": "zao",
        "Language Name": "Zapotec, Ozolotepec",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zao"
  },
  "mms_ztq": {
    "id": "mms_ztq",
    "language": [
      {
        "Iso Code": "ztq",
        "Language Name": "Zapotec, Quioquitani-Quierí",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ztq"
  },
  "mms_zar": {
    "id": "mms_zar",
    "language": [
      {
        "Iso Code": "zar",
        "Language Name": "Zapotec, Rincón",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zar"
  },
  "mms_zpt": {
    "id": "mms_zpt",
    "language": [
      {
        "Iso Code": "zpt",
        "Language Name": "Zapotec, San Vicente Coatlán",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zpt"
  },
  "mms_zpi": {
    "id": "mms_zpi",
    "language": [
      {
        "Iso Code": "zpi",
        "Language Name": "Zapotec, Santa María Quiegolani",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zpi"
  },
  "mms_zas": {
    "id": "mms_zas",
    "language": [
      {
        "Iso Code": "zas",
        "Language Name": "Zapotec, Santo Domingo Albarradas",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zas"
  },
  "mms_zaa": {
    "id": "mms_zaa",
    "language": [
      {
        "Iso Code": "zaa",
        "Language Name": "Zapotec, Sierra de Juárez",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zaa"
  },
  "mms_zpz": {
    "id": "mms_zpz",
    "language": [
      {
        "Iso Code": "zpz",
        "Language Name": "Zapotec, Texmelucan",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zpz"
  },
  "mms_zab": {
    "id": "mms_zab",
    "language": [
      {
        "Iso Code": "zab",
        "Language Name": "Zapotec, Western Tlacolula Valley",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zab"
  },
  "mms_zpu": {
    "id": "mms_zpu",
    "language": [
      {
        "Iso Code": "zpu",
        "Language Name": "Zapotec, Yalálag",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zpu"
  },
  "mms_zae": {
    "id": "mms_zae",
    "language": [
      {
        "Iso Code": "zae",
        "Language Name": "Zapotec, Yareni",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zae"
  },
  "mms_zty": {
    "id": "mms_zty",
    "language": [
      {
        "Iso Code": "zty",
        "Language Name": "Zapotec, Yatee",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zty"
  },
  "mms_zav": {
    "id": "mms_zav",
    "language": [
      {
        "Iso Code": "zav",
        "Language Name": "Zapotec, Yatzachi",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zav"
  },
  "mms_zza": {
    "id": "mms_zza",
    "language": [
      {
        "Iso Code": "zza",
        "Language Name": "Zaza",
        "Country": "Turkey"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zza"
  },
  "mms_zyb": {
    "id": "mms_zyb",
    "language": [
      {
        "Iso Code": "zyb",
        "Language Name": "Zhuang, Yongbei",
        "Country": "China"
      }
    ],
    "Region": "Asia",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zyb"
  },
  "mms_ziw": {
    "id": "mms_ziw",
    "language": [
      {
        "Iso Code": "ziw",
        "Language Name": "Zigula",
        "Country": "Tanzania"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ziw"
  },
  "mms_zos": {
    "id": "mms_zos",
    "language": [
      {
        "Iso Code": "zos",
        "Language Name": "Zoque, Francisco León",
        "Country": "Mexico"
      }
    ],
    "Region": "North America",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/zos"
  },
  "mms_gnd": {
    "id": "mms_gnd",
    "language": [
      {
        "Iso Code": "gnd",
        "Language Name": "Zulgo-Gemzek",
        "Country": "Cameroon"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": false,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/gnd"
  },
  "mms_ewe": {
    "id": "mms_ewe",
    "language": [
      {
        "Iso Code": "ewe",
        "Language Name": "Éwé",
        "Country": "Ghana"
      }
    ],
    "Region": "Africa",
    "ONNX Exists": true,
    "Sample Exists": true,
    "url": "https://huggingface.co/willwade/mms-tts-multilingual-models-onnx/resolve/main/ewe"
  }
};
